webpackJsonp([6],{

/***/ 176:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/owner.29eb6da.png";

/***/ }),

/***/ 180:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initPosthog;
/* harmony export (immutable) */ __webpack_exports__["d"] = capturePosthog;
/* harmony export (immutable) */ __webpack_exports__["b"] = identifyPosthogDistinctId;
/* harmony export (immutable) */ __webpack_exports__["c"] = identifyPosthogWithPerson;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_posthog_js__ = __webpack_require__(574);


var enabled = false;

function stripEnvQuotes(value) {
  if (value === undefined || value === null) return '';
  return String(value).replace(/^['"]|['"]$/g, '').trim();
}

/**
 * Initialize PostHog when VUE_APP_POSTHOG_KEY is set. No-op otherwise.
 * Autocapture and automatic pageviews are disabled; use track-events.js for explicit events.
 */
function initPosthog() {
  var key = stripEnvQuotes(__webpack_require__.i({"NODE_ENV":"production","VUE_APP_FIREBASE_API_KEY":'AIzaSyD8hfbPdqmz8rf1njlM4xTuZBkoKK19mJs',"VUE_APP_FIREBASE_AUTH_DOMAIN":'ponce-staging.firebaseapp.com',"VUE_APP_FIREBASE_DATABASE_URL":'https://ponce-staging.firebaseio.com',"VUE_APP_FIREBASE_PROJECT_ID":'ponce-staging',"VUE_APP_FIREBASE_STORAGE_BUCKET":'ponce-staging.appspot.com',"VUE_APP_FIREBASE_MESSAGING_SENDER_ID":'764014852327',"VUE_APP_FIREBASE_APP_ID":'1:764014852327:web:bb7126fa42a08d9a89ca42',"REPORTS_KEYSTONE_URL":'https://keystone-report-764014852327.us-central1.run.app',"AUDITS_KEYSTONE_URL":'https://adminaudits-sa.ponceautomations.com',"VUE_APP_GOOGLE_MAPS_KEY":'AIzaSyDEi2wgWpANAY4sttulylcvbtSfQ1Oxw88',"WEBHOOKS_URL":'https://web-hook-ov3crrf7tq-uc.a.run.app',"WEBHOOKS_BASIC_TOKEN":'Basic PonceAutomationToken',"DEVICES_APP_URL":'https://ponce-staging.web.app',"MIDDLEWARE_URL":'https://us-central1-ponce-staging.cloudfunctions.net/middleware',"VUE_APP_ESTEBAN_PHONE":'+5492236693375',"VUE_APP_LOGROCKET_ID":'',"VUE_APP_MIXPANEL_TOKEN":'530c5db4921cde2f716cc15e87a5e890',"VUE_APP_SUPPORT_PHONE":'+541139882886'}).VUE_APP_POSTHOG_KEY);
  if (!key) return;

  var host = stripEnvQuotes(__webpack_require__.i({"NODE_ENV":"production","VUE_APP_FIREBASE_API_KEY":'AIzaSyD8hfbPdqmz8rf1njlM4xTuZBkoKK19mJs',"VUE_APP_FIREBASE_AUTH_DOMAIN":'ponce-staging.firebaseapp.com',"VUE_APP_FIREBASE_DATABASE_URL":'https://ponce-staging.firebaseio.com',"VUE_APP_FIREBASE_PROJECT_ID":'ponce-staging',"VUE_APP_FIREBASE_STORAGE_BUCKET":'ponce-staging.appspot.com',"VUE_APP_FIREBASE_MESSAGING_SENDER_ID":'764014852327',"VUE_APP_FIREBASE_APP_ID":'1:764014852327:web:bb7126fa42a08d9a89ca42',"REPORTS_KEYSTONE_URL":'https://keystone-report-764014852327.us-central1.run.app',"AUDITS_KEYSTONE_URL":'https://adminaudits-sa.ponceautomations.com',"VUE_APP_GOOGLE_MAPS_KEY":'AIzaSyDEi2wgWpANAY4sttulylcvbtSfQ1Oxw88',"WEBHOOKS_URL":'https://web-hook-ov3crrf7tq-uc.a.run.app',"WEBHOOKS_BASIC_TOKEN":'Basic PonceAutomationToken',"DEVICES_APP_URL":'https://ponce-staging.web.app',"MIDDLEWARE_URL":'https://us-central1-ponce-staging.cloudfunctions.net/middleware',"VUE_APP_ESTEBAN_PHONE":'+5492236693375',"VUE_APP_LOGROCKET_ID":'',"VUE_APP_MIXPANEL_TOKEN":'530c5db4921cde2f716cc15e87a5e890',"VUE_APP_SUPPORT_PHONE":'+541139882886'}).VUE_APP_POSTHOG_HOST) || 'https://us.i.posthog.com';

  __WEBPACK_IMPORTED_MODULE_0_posthog_js__["a" /* default */].init(key, {
    api_host: host,
    autocapture: false,
    persistence: 'localStorage+cookie',
    defaults: '2026-01-30'
  });
  enabled = true;
}

function capturePosthog(eventName, properties) {
  if (!enabled) return;
  try {
    __WEBPACK_IMPORTED_MODULE_0_posthog_js__["a" /* default */].capture(eventName, properties);
  } catch (e) {
    console.warn('PostHog capture failed:', e);
  }
}

function identifyPosthogDistinctId(userId) {
  if (!enabled || !userId) return;
  try {
    __WEBPACK_IMPORTED_MODULE_0_posthog_js__["a" /* default */].identify(String(userId));
  } catch (e) {
    console.warn('PostHog identify failed:', e);
  }
}

function identifyPosthogWithPerson(userId, personProps) {
  if (!enabled || !userId) return;
  try {
    __WEBPACK_IMPORTED_MODULE_0_posthog_js__["a" /* default */].identify(String(userId), personProps || {});
  } catch (e) {
    console.warn('PostHog identify failed:', e);
  }
}

/***/ }),

/***/ 285:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_i18n__ = __webpack_require__(85);


/* harmony default export */ __webpack_exports__["a"] = (function (Vue) {
  Vue.config.productionTip = false;

  function getTimeRange(type, hourDiff) {
    var date = new Date();

    if (type === 1) {
      // Hour selections
      var auxDate = new Date();
      var hours = date.getHours() - hourDiff;

      return {
        from: new Date(auxDate.setHours(hours)),
        to: date
      };
    } else if (type === 2) {
      // This week
      var y = date.getFullYear();
      var m = date.getMonth();
      var first = date.getDate() - date.getDay(); // First day is the day of the month - the day of the week
      var last = first + 6; // last day is the first day + 6

      return {
        from: new Date(new Date(y, m, first)),
        to: new Date(new Date(y, m, last))
      };
    } else if (type === 3) {
      // This month
      var _y = date.getFullYear();
      var _m = date.getMonth();
      var firstDay = new Date(_y, _m, 1);
      var lastDay = new Date(_y, _m + 1, 0);

      return {
        from: firstDay,
        to: lastDay
      };
    }
  }

  Vue.prototype.$eventHub = new Vue(); // Global event bus

  Vue.prototype.$ponceConfig = {
    checkStatus: function checkStatus(value) {
      if (value === 1) {
        return '#00d166';
      } else if (value === 2) {
        return '#4F5AB0';
      } else if (value === 3) {
        return '#999';
      } else {
        return '#f93a2f';
      }
    },
    sortArrayByDeviceName: function sortArrayByDeviceName(dataArray) {
      return dataArray.sort(function (a, b) {
        if (a.deviceName > b.deviceName) {
          return 1;
        } else if (a.deviceName < b.deviceName) {
          return -1;
        } else {
          return 0;
        }
      });
    },
    sortArrayByName: function sortArrayByName(dataArray) {
      return dataArray.sort(function (a, b) {
        if (a.name > b.name) {
          return 1;
        } else if (a.name < b.name) {
          return -1;
        } else {
          return 0;
        }
      });
    },

    timerTypes: {
      'diffHours': 1,
      'setWeek': 2,
      'setMonth': 3
    },
    timeFrames: function timeFrames(range) {
      if (range === 'oneHour') {
        return getTimeRange(this.timerTypes['diffHours'], 1);
      } else if (range === 'sixHours') {
        return getTimeRange(this.timerTypes['diffHours'], 6);
      } else if (range === 'oneDay') {
        return getTimeRange(this.timerTypes['diffHours'], 24);
      } else if (range === 'twoDays') {
        return getTimeRange(this.timerTypes['diffHours'], 48);
      } else if (range === 'oneWeek') {
        return getTimeRange(this.timerTypes['diffHours'], 168);
      } else if (range === 'twoWeeks') {
        return getTimeRange(this.timerTypes['diffHours'], 336);
      } else if (range === 'thisWeek') {
        return getTimeRange(this.timerTypes['setWeek']);
      } else if (range === 'thisMonth') {
        return getTimeRange(this.timerTypes['setMonth']);
      }
    },

    organizationDemoId: 999,
    sortByEntityName: function sortByEntityName(array) {
      return array.sort(function (a, b) {
        if (a.campaign.entityName < b.campaign.entityName) {
          return -1;
        }
        if (a.campaign.entityName > b.campaign.entityName) {
          return 1;
        }
        return 0;
      });
    },

    states: {
      1: __WEBPACK_IMPORTED_MODULE_0__lib_i18n__["a" /* default */].t('Config.irrigating'),
      2: __WEBPACK_IMPORTED_MODULE_0__lib_i18n__["a" /* default */].t('Config.movement'),
      3: __WEBPACK_IMPORTED_MODULE_0__lib_i18n__["a" /* default */].t('Config.off'),
      4: __WEBPACK_IMPORTED_MODULE_0__lib_i18n__["a" /* default */].t('Config.failure')
    },
    numberRules: [function (v) {
      return !!v || __WEBPACK_IMPORTED_MODULE_0__lib_i18n__["a" /* default */].t('Config.fieldIsRequired');
    }, function (v) {
      return (/^[+]?\d+([.]\d+)?$/.test(v) || __WEBPACK_IMPORTED_MODULE_0__lib_i18n__["a" /* default */].t('Config.onlyNumbers')
      );
    }],
    phoneRules: [function (v) {
      return !!v || __WEBPACK_IMPORTED_MODULE_0__lib_i18n__["a" /* default */].t('Config.phoneIsRequired');
    }, function (v) {
      return (/^[+]{1}[0-9]{13}$/.test(v) || __WEBPACK_IMPORTED_MODULE_0__lib_i18n__["a" /* default */].t('Config.formatRequired')
      );
    }],
    phoneWithoutPrefixRules: [function (v) {
      return !!v || __WEBPACK_IMPORTED_MODULE_0__lib_i18n__["a" /* default */].t('Config.phoneIsRequired');
    }, function (v) {
      return (/^[0-9]{11}$/.test(v) || __WEBPACK_IMPORTED_MODULE_0__lib_i18n__["a" /* default */].t('Config.formatWithoutPrefixRequired')
      );
    }],
    requiredRules: [function (v) {
      return !!v || __WEBPACK_IMPORTED_MODULE_0__lib_i18n__["a" /* default */].t('Config.thisFieldIsRequired');
    }],
    /* latLonRules: [
      v => !!v || 'La latitud y Longitud es requerida',
      v => /^(\-?\d+(\.\d+)?).\s*(\-?\d+(\.\d+)?)$/.test(v) || 'Formato requerido: (-)38.002625'
    ], */
    numberOptionalRules: [function (v) {
      return (/^[+]?\d+([.]\d+)?$/.test(v) || __WEBPACK_IMPORTED_MODULE_0__lib_i18n__["a" /* default */].t('Config.onlyNumbers')
      );
    }],
    passwordRules: [function (v) {
      return !!v || __WEBPACK_IMPORTED_MODULE_0__lib_i18n__["a" /* default */].t('Config.passwordIsRequired');
    }, function (v) {
      return v && v.length >= 6 || __WEBPACK_IMPORTED_MODULE_0__lib_i18n__["a" /* default */].t('Config.passwordRequirements');
    }],
    emailRules: [function (v) {
      return !!v || __WEBPACK_IMPORTED_MODULE_0__lib_i18n__["a" /* default */].t('Config.emailIsRequired');
    }, function (v) {
      return (/^(([^<>()[\]\\.,:\s@"]+(\.[^<>()[\]\\.,:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || __WEBPACK_IMPORTED_MODULE_0__lib_i18n__["a" /* default */].t('Config.emailRule')
      );
    }],
    lotNameRules: [function (v) {
      return !!v || __WEBPACK_IMPORTED_MODULE_0__lib_i18n__["a" /* default */].t('Config.nameIsRequired');
    }, function (v) {
      return v && v.length <= 21 || __WEBPACK_IMPORTED_MODULE_0__lib_i18n__["a" /* default */].t('Config.name21char');
    }],
    equipmentNameRules: [function (v) {
      return !!v || __WEBPACK_IMPORTED_MODULE_0__lib_i18n__["a" /* default */].t('Config.nameIsRequired');
    }, function (v) {
      return v && v.length <= 16 || __WEBPACK_IMPORTED_MODULE_0__lib_i18n__["a" /* default */].t('Config.name16char');
    }],
    organizationTypes: [{ text: __WEBPACK_IMPORTED_MODULE_0__lib_i18n__["a" /* default */].t('Config.grower'), value: 'grower' }, { text: __WEBPACK_IMPORTED_MODULE_0__lib_i18n__["a" /* default */].t('Config.company'), value: 'company' }, { text: __WEBPACK_IMPORTED_MODULE_0__lib_i18n__["a" /* default */].t('Config.corporation'), value: 'corporation' }],
    deviceMode: [{ text: __WEBPACK_IMPORTED_MODULE_0__lib_i18n__["a" /* default */].t('Config.active'), value: true }, { text: __WEBPACK_IMPORTED_MODULE_0__lib_i18n__["a" /* default */].t('Config.inactive'), value: false }],
    equipmentTypes: [{ text: __WEBPACK_IMPORTED_MODULE_0__lib_i18n__["a" /* default */].t('Config.pivot'), value: 1 }, { text: __WEBPACK_IMPORTED_MODULE_0__lib_i18n__["a" /* default */].t('Config.forwardAvance'), value: 2 }],
    roles: [{ value: 'farmhand' }, { value: 'fieldman' }, { value: 'manager' }, { value: 'owner' }]
  };
});

/***/ }),

/***/ 286:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (Vue) {
  Vue.filter('capitalize', function (value) {
    if (!value) {
      return '';
    }
    value = value.toString();
    return value.charAt(0).toUpperCase() + value.slice(1);
  });

  Vue.filter('number', function (value) {
    return value ? parseFloat(value.toFixed(3)) : value;
  });
});

/***/ }),

/***/ 287:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Apollo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_apollo__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_apollo_client__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_apollo_link_http__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_apollo_link__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_apollo_cache_inmemory__ = __webpack_require__(356);





// import { persistCache } from 'apollo-cache-persist'

var Apollo = function Apollo() {
  // HTTP connection to the API
  var httpLink = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_apollo_link_http__["a" /* createHttpLink */])({
    uri: 'https://keystone-report-764014852327.us-central1.run.app' + '/admin/api'
  });

  var authLink = new __WEBPACK_IMPORTED_MODULE_3_apollo_link__["a" /* ApolloLink */](function (operation, forward) {
    // Retrieve the authorization token from local storage.
    var token = localStorage.getItem('auth_token');

    // Use the setContext method to set the HTTP headers.
    operation.setContext({
      headers: {
        authorization: token ? 'Bearer ' + token : ''
      }
    });

    // Call the next link in the middleware chain.
    return forward(operation);
  });

  // Cache implementation
  var cache = new __WEBPACK_IMPORTED_MODULE_4_apollo_cache_inmemory__["a" /* InMemoryCache */]();

  // await before instantiating ApolloClient, else queries might run before the cache is persisted
  // persistCache({
  //   cache,
  //   storage: window.localStorage
  // })
  // Create the apollo client
  var apolloClient = new __WEBPACK_IMPORTED_MODULE_1_apollo_client__["a" /* ApolloClient */]({
    link: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_apollo_link__["b" /* concat */])(authLink, httpLink),
    cache: cache
  });
  var reportsClient = new __WEBPACK_IMPORTED_MODULE_1_apollo_client__["a" /* ApolloClient */]({
    link: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_apollo_link_http__["a" /* createHttpLink */])({ uri: 'https://keystone-report-764014852327.us-central1.run.app' + '/admin/api' }),
    cache: new __WEBPACK_IMPORTED_MODULE_4_apollo_cache_inmemory__["a" /* InMemoryCache */]()
  });
  var auditsClient = new __WEBPACK_IMPORTED_MODULE_1_apollo_client__["a" /* ApolloClient */]({
    link: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_apollo_link_http__["a" /* createHttpLink */])({ uri: 'https://adminaudits-sa.ponceautomations.com' + '/api/graphql' }),
    cache: new __WEBPACK_IMPORTED_MODULE_4_apollo_cache_inmemory__["a" /* InMemoryCache */]()
  });

  var apolloProvider = new __WEBPACK_IMPORTED_MODULE_0_vue_apollo__["a" /* default */]({
    clients: {
      apolloClient: apolloClient,
      reportsClient: reportsClient,
      auditsClient: auditsClient
    },
    defaultClient: apolloClient
  });

  return apolloProvider;
};

/***/ }),

/***/ 288:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(56);

window.addEventListener('online', function () {
  __WEBPACK_IMPORTED_MODULE_0__store__["a" /* store */].commit('setIsOnline', true);
});
window.addEventListener('offline', function () {
  __WEBPACK_IMPORTED_MODULE_0__store__["a" /* store */].commit('setIsOnline', false);
});

/***/ }),

/***/ 289:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VueRegister; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_apollo__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_google_maps__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_browser_geolocation__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_browser_geolocation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_browser_geolocation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_settings_js__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_datetime__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_datetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_datetime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_datetime_dist_vue_datetime_css__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_datetime_dist_vue_datetime_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_datetime_dist_vue_datetime_css__);








// List of components
var AlertCmp = function AlertCmp() {
  return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 628));
};
var ToolbarCmp = function ToolbarCmp() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 629));
};
var SnackbarCmp = function SnackbarCmp() {
  return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 627));
};

var VueRegister = function VueRegister() {
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_apollo__["a" /* default */]);
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_datetime__["Datetime"]);
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_browser_geolocation___default.a);
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue2_google_maps__, {
    load: {
      key: __WEBPACK_IMPORTED_MODULE_4__constants_settings_js__["a" /* GoogleMapsKey */],
      libraries: 'places'
    }
  });
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$log = console.log;

  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('app-alert', AlertCmp);
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('datetime', __WEBPACK_IMPORTED_MODULE_5_vue_datetime__["Datetime"]);
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('app-toolbar', ToolbarCmp);
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('app-snackbar', SnackbarCmp);

  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"];
};

/***/ }),

/***/ 290:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth_guard__ = __webpack_require__(363);





__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  routes: [{
    path: '*',
    redirect: '/'
  }, {
    path: '/',
    redirect: '/signin'
  }, {
    path: '/r/:shortId' // Allow redirection links without modifying the route
  }, {
    path: '/dashboard',
    name: 'Dashboard',
    component: view('Dashboard/DashboardMainScreen'),
    beforeEnter: __WEBPACK_IMPORTED_MODULE_3__auth_guard__["a" /* default */]
  }, {
    path: '/signin',
    name: 'Signin',
    component: view('User/Signin'),
    beforeEnter: __WEBPACK_IMPORTED_MODULE_3__auth_guard__["a" /* default */]
  }, {
    path: '/loading',
    name: 'LoadingScreen',
    component: view('User/LoadingScreen'),
    beforeEnter: __WEBPACK_IMPORTED_MODULE_3__auth_guard__["a" /* default */]
  }, {
    path: '/passRecovery',
    name: 'PassRecovery',
    component: view('User/PassRecovery')
  }, {
    path: '/passChange',
    name: 'PassChange',
    component: view('User/PassChange')
  }, {
    path: '/reports',
    name: 'Reports',
    component: view('Reports/Reports'),
    beforeEnter: __WEBPACK_IMPORTED_MODULE_3__auth_guard__["a" /* default */]
  }, {
    path: '/dashboardLiag',
    name: 'DashboardLiag',
    component: view('Dashboard/DashboardLiag')
  }, {
    path: '/organizationHome',
    name: 'OrganizationHome',
    component: view('OrganizationHome/OrganizationHome'),
    beforeEnter: __WEBPACK_IMPORTED_MODULE_3__auth_guard__["a" /* default */]
  }, {
    path: '/welcome/:createUserToken',
    name: 'Welcome',
    component: view('Additions/Welcome'),
    beforeEnter: __WEBPACK_IMPORTED_MODULE_3__auth_guard__["a" /* default */]
  }, {
    path: '/addDevice',
    name: 'AddDevice',
    component: view('Additions/AddDevice'),
    beforeEnter: __WEBPACK_IMPORTED_MODULE_3__auth_guard__["a" /* default */]
  }, {
    path: '/addUser',
    name: 'AddUser',
    component: view('Additions/AddUser'),
    beforeEnter: __WEBPACK_IMPORTED_MODULE_3__auth_guard__["a" /* default */]
  }, {
    path: '/addCrop',
    name: 'AddCrop',
    component: view('Additions/AddCrop'),
    beforeEnter: __WEBPACK_IMPORTED_MODULE_3__auth_guard__["a" /* default */]
  }, {
    path: '/editUser',
    name: 'EditUser',
    component: view('Additions/EditUser'),
    beforeEnter: __WEBPACK_IMPORTED_MODULE_3__auth_guard__["a" /* default */]
  }, {
    path: '/addField',
    name: 'AddField',
    component: view('Additions/AddField'),
    beforeEnter: __WEBPACK_IMPORTED_MODULE_3__auth_guard__["a" /* default */]
  }, {
    path: '/manageField',
    name: 'ManageField',
    component: view('OrganizationHome/ManageField'),
    beforeEnter: __WEBPACK_IMPORTED_MODULE_3__auth_guard__["a" /* default */]
  }, {
    path: '/newCampaignInitialData/:campaignId',
    name: 'NewCampaignInitialData',
    component: view('OrganizationHome/NewCampaignInitialData'),
    beforeEnter: __WEBPACK_IMPORTED_MODULE_3__auth_guard__["a" /* default */]
  }, {
    path: '/editCampaignDevicesAndServices/:campaignId',
    name: 'EditCampaignDevicesAndServices',
    component: view('Campaigns/EditCampaignDevicesAndServices'),
    beforeEnter: __WEBPACK_IMPORTED_MODULE_3__auth_guard__["a" /* default */]
  }, {
    path: '/audits/demo',
    name: 'AuditsDemo',
    component: view('Audits/AuditsDemo')
  }, {
    path: '/audits',
    name: 'Audits',
    component: view('Audits/Audits'),
    beforeEnter: __WEBPACK_IMPORTED_MODULE_3__auth_guard__["a" /* default */]
  }, {
    path: '/fieldSurveys/:id',
    name: 'FieldSurveyForm',
    component: view('FieldSurveys/FieldSurveyForm'),
    beforeEnter: __WEBPACK_IMPORTED_MODULE_3__auth_guard__["a" /* default */]
  }, {
    path: '/sharedPluviometricChart/:pluviometricChartId',
    name: 'SharedPluviometricChart',
    component: view('Audits/SharedPluviometricChart')
  }],
  mode: 'history'
});

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * @param  {string}   name     the filename (basename) of the view to load.
 */
function view(name) {
  return function (resolve) {
    __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(631)("./" + name + '.vue')]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  };
}

router.beforeEach(function (to, from, next) {
  if (to.path.includes('/r/')) {
    // If the path includes '/r/', redirect to the loading screen
    return next({ path: '/loading', query: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, to.query, { to: to.path }) });
  }
  next();
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 291:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 301:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EQUIPMENT_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return EQUIPMENT_SUBTYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return EQUIPMENT_TYPES_LABELS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return defaultRoles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return USER_ROLES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return PROFILE_PIC_FILE_SIZE_LIMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return ALLOWED_IMAGES_FILE_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return ALLOWED_IMAGES_FILE_EXTENSIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return NOTIFICATIONS_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return ALLOWED_PLUVIOMETRIC_CHARTS_FILE_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return ALLOWED_PLUVIOMETRIC_CHARTS_FILE_EXTENSIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return WEBHOOKS_PATHS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return HTTP_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return CUSTOM_ERROR_CODES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return MIDDLEWARE_PATHS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SATISFACTION_SURVEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return PRESSURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return DEFAULT_START_ANGLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EVENTS_TO_TRACK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return DEFAULT_PERMISSIONS_BY_ROLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DEFAULT_DAYS_BEFORE_START_TO_ALLOW_INITIAL_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return CAMPAIGN_STEPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return FIRESTORE_CAMPAIGN_PRE_DATA_STEPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return HUBSPOT_ONBOARDING_STATES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return CAMPAIGN_VALIDATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DEVICE_CONSTANTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return PRODUCT_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return AUDITS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return DEFAULT_PLUVIOMETRIC_CHART_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return DEFAULT_FIELD_SOURCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return DEFAULT_PLUVIOMETRIC_CHART_ADVANCED_CONFIGURATION; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

var DEFAULT_PLUVIOMETRIC_CHART_ADVANCED_CONFIGURATION = {
  fieldArea: {},
  cannonRadius: {},
  flowPerArea: {},
  flowPerDay: {},
  cannonFlow: {},
  fullApplicationRate: {},
  pressure: { lowestElevation: {}, highestElevation: {}, basePress: {}, pivotPress: {}, endPress: {} },
  pipes: { tubes: [] },
  flowPerSpan: { spans: [] },
  lrduDriveTrain: {},
  sprinklerConfiguration: { sprinklersPerSpan: [] }

  /** Default field source: 'auto' = from webhook automatic reading, 'manual' = user input */
};var DEFAULT_FIELD_SOURCE = {
  pumpFlow: 'manual',
  brand: 'manual',
  model: 'manual',
  deviceLength: 'manual',
  area: 'manual',
  equipmentReach: 'manual',
  hoseLength: 'manual',
  chartPressure: 'manual',
  minPressure: 'manual',
  maxPressure: 'manual'
};

var DEFAULT_PLUVIOMETRIC_CHART_DATA = {
  deviceLength: { unit: 'm' },
  pumpFlow: { unit: 'm3/h' },
  area: { unit: 'ha' },
  pressureRange: { unit: 'bar' },
  advancedConfiguration: DEFAULT_PLUVIOMETRIC_CHART_ADVANCED_CONFIGURATION,
  equipmentReach: { unit: 'm' },
  hoseLength: { unit: 'm' },
  fieldSource: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, DEFAULT_FIELD_SOURCE)

  // Assign to module.exports properties to avoid "read only property 'exports'" when used with ESM imports
};var allExports = {
  EQUIPMENT_TYPE: {
    PIVOT: 1,
    AF: 2,
    IR: 3
  },
  EQUIPMENT_SUBTYPE: {
    AF: {
      TWO_WINGS: 1,
      ONE_WING: 2,
      PIVOTABLE: 3
    }
  },
  EQUIPMENT_TYPES_LABELS: {
    1: 'pivot',
    2: 'forwardAvance',
    3: 'irrigationReel'
  },
  defaultRoles: {
    farmhand: false,
    fieldman: false,
    manager: false,
    owner: false
  },
  USER_ROLES: {
    ADMIN: 'admin',
    FARMHAND: 'farmhand',
    FIELDMAN: 'fieldman',
    MANAGER: 'manager',
    OWNER: 'owner',
    AUDITS: 'audits'
  },
  PROFILE_PIC_FILE_SIZE_LIMIT: 4,
  ALLOWED_IMAGES_FILE_TYPES: ['image/png', 'image/jpg', 'image/jpeg'],
  ALLOWED_IMAGES_FILE_EXTENSIONS: '.png, .jpg, .jpeg',
  NOTIFICATIONS_TYPES: ['failure', 'off', 'position', 'pressure', 'irrigationOrders'],
  ALLOWED_PLUVIOMETRIC_CHARTS_FILE_TYPES: ['image/png', 'image/tiff', 'image/jpg', 'image/jpeg', 'application/pdf'],
  ALLOWED_PLUVIOMETRIC_CHARTS_FILE_EXTENSIONS: '.pdf,.png,.jpg,.jpeg,.tiff,.tif',
  WEBHOOKS_PATHS: {
    PHONE_EXISTS: '/utilities/phoneExists',
    CREATE_USER: '/utilities/createUser',
    VALIDATE_USER_TOKEN: '/utilities/validateUserToken',
    UPDATE_CONTACT_DATA: '/mobileApp/updateHubspotContact',
    LINK_USERS: '/mobileApp/linkUsersToCampaign',
    LOAD_CAMPAIGN_DATA: '/mobileApp/loadCampaignData',
    SERVICE_EXTENSION: '/mobileApp/serviceExtension',
    LINK_SHORTENER: '/utilities/linkShortener',
    PROCESS_PLUVIOMETRIC_CHART: '/pluviometricCharts/process'
  },
  HTTP_STATUS: {
    OK: 200
  },
  CUSTOM_ERROR_CODES: {
    TOKEN_EXPIRED: 'TOKEN_EXPIRED'
  },
  MIDDLEWARE_PATHS: {
    V1: '/v1',
    ALTIMETRY: '/altimetry'
  },
  SATISFACTION_SURVEY: {
    QUESTION_TYPE: {
      RATING: 'rating',
      OPTIONS: 'options',
      TEXT: 'text'
    },
    OPTIONS: {
      OTHER: 'other',
      MISSING_DATA: 'missingData',
      INACCURATE_DATA: 'inaccurateData',
      CONFUSING_INFO: 'confusingInfo'
    },
    FUNCTIONALITIES: {
      REPORTS: 'reports'
    },
    DEFAULT_COUNT: 3,
    DEFAULT_COOLDOWN: 30,
    DEFAULT_COOLDOWN_UNIT: 'days'
  },
  PRESSURE: {
    MIN: '0.1',
    MIN_RANGE: 0.8,
    MAX_RANGE: 0.8
  },
  DEFAULT_START_ANGLE: 0,
  EVENTS_TO_TRACK: {
    OPEN_APP: 'Open app',
    CLICK_OPEN_MENU_BUTTON: 'Click open menu button',
    CLICK_CLOSE_MENU_BUTTON: 'Click close menu button',
    CLICK_ORGANIZATION_HOME_VIEW_BUTTON: 'Click organization home view button',
    CLICK_REPORTS_VIEW_BUTTON: 'Click reports view button',
    CLICK_REPORTS_DATE_SELECTOR: 'Click reports date selector',
    OPEN_FULL_REPORT: 'Open full report',
    EXPAND_DEVICE_REPORT_PANEL: 'Expand device report panel',
    COLLAPSE_DEVICE_REPORT_PANEL: 'Collapse device report panel',
    CLICK_SELECT_LOT_REPORT: 'Click select lot report',
    CLICK_UNSELECT_LOT_REPORT: 'Click unselect lot report',
    CLICK_SELECT_CIRCULAR_MAP_LAYER_OPTION: 'Click select circular map layer option',
    CLICK_SELECT_CIRCULAR_MAP_LAYER_SUBOPTION: 'Click select circular map layer suboption',
    CLICK_UNSELECT_CIRCULAR_MAP_LAYER_SUBOPTION: 'Click unselect circular map layer suboption',
    DOWNLOAD_PLUVIOMETRIC_CHART: 'Click download pluviometric chart',
    CLICK_OPEN_DEVICE_DETAILS_DIALOG: 'Click open device details dialog',
    CLICK_ORGANIZATION_HOME_DEVICE_MENU: 'Click organization home device menu',
    CLICK_ORGANIZATION_HOME_FIELD_MENU: 'Click organization home field menu',
    CLICK_ADD_DEVICE_BUTTON: 'Click add device button',
    CLICK_ADD_FIELD_BUTTON: 'Click add field button',
    CLICK_ADD_USER_BUTTON: 'Click add user button',
    CLICK_OPEN_FIELD_BUTTON: 'Click open field button',
    CLICK_GO_TO_ORGANIZATION_HOME_FROM_FIELD_BUTTON: 'Click go to organization home from field button',
    CLICK_DELETE_USER_BUTTON: 'Click delete user button',
    CLICK_CONFIRM_DELETE_USER_BUTTON: 'Click confirm delete user button',
    CLICK_SAVE_USER_BUTTON: 'Click save user button',
    CLICK_OPEN_PERMISSIONS_BY_DEVICE_BUTTON: 'Click open permissions by device button',
    REQUEST_AUDIT_QUOTE: 'Click request audit quote button',
    CLICK_EDIT_CAMPAIGN_BUTTON: 'Click edit campaign button',
    CLICK_START_CAMPAIGN_BUTTON: 'Click start campaign button',
    CLICK_CAMPAIGN_TERMS_AND_CONDITIONS_CHECKBOX: 'Click campaign terms and conditions checkbox',
    CLICK_AGREE_TERMS_AND_CONDITIONS_BUTTON: 'Click agree terms and conditions button',
    CLICK_CAMPAIGN_ONBOARDING_INVITE_USERS_BUTTON: 'Click campaign onboarding invite users button',
    CLICK_CAMPAIGN_ONBOARDING_ADD_NEW_DEVICE_BUTTON: 'Click campaign onboarding add new device button',
    CLICK_CAMPAIGN_ONBOARDING_ADD_NEW_FIELD_BUTTON: 'Click campaign onboarding add new field button',
    CLICK_CAMPAIGN_ONBOARDING_BACK_BUTTON: 'Click campaign onboarding back button',
    CLICK_CAMPAIGN_ONBOARDING_CREATE_NEW_DEVICE_BUTTON: 'Click campaign onboarding create new device button',
    CLICK_CAMPAIGN_ONBOARDING_DEVICES_AND_SERVICES_FINISH_BUTTON: 'Click campaign onboarding devices and services finish button',
    CLICK_CAMPAIGN_ONBOARDING_FINISH_BUTTON: 'Click campaign onboarding finish button',
    CLICK_CREATE_NEW_USER_BUTTON: 'Click create new user button',
    CLICK_INVITE_EXISTING_USERS_BUTTON: 'Click invite existing users button',
    CLICK_EDIT_CAMPAIGN_BACK_BUTTON: 'Click edit campaign back button',
    CLICK_EDIT_CAMPAIGN_SAVE_CHANGES_BUTTON: 'Click edit campaign save changes button',
    CLICK_EDIT_CAMPAIGN_ADD_NEW_FIELD_BUTTON: 'Click edit campaign add new field button',
    CLICK_ADD_NEW_FIELD_CONTACT_USER_BUTTON: 'Click add new field contact user button',
    CLICK_PENDING_CAMPAIGN_ONBOARDING_REMIND_ME_LATER_BUTTON: 'Click pending campaign onboarding remind me later button',
    CLICK_PENDING_CAMPAIGN_ONBOARDING_START_BUTTON: 'Click pending campaign onboarding start button',
    CLICK_START_DATE_WARNING_PRELOAD_BUTTON: 'Click start date warning preload button',
    CLICK_ACCEPT_SERVICE_EXTENSION: 'Click accept service extension',
    CLOSE_SERVICE_EXTENSION_DIALOG: 'Close service extension dialog',
    REQUEST_SERVICE_EXTENSION: 'Request service extension',
    CLICK_REQUEST_SERVICE_EXTENSION_BUTTON: 'Click request service extension button',
    CLICK_CAMPAIGN_ONBOARDING_ADD_NEW_EXTENSION_BUTTON: 'Click campaign onboarding add new extension button',
    CLICK_CAMPAIGN_ONBOARDING_REMOVE_EXTENSION_BUTTON: 'Click campaign onboarding remove extension button',
    CLICK_AUDITS_VIEW_BUTTON: 'Click audits view button',
    EXPAND_DEVICE_AUDIT_PANEL: 'Expand device audit panel',
    COLLAPSE_DEVICE_AUDIT_PANEL: 'Collapse device audit panel',
    OPEN_FULL_AUDIT_DEAL: 'Open full audit deal',
    FIELD_SURVEY_AUTO_REDIRECT_FROM_AUDITS: 'Field survey auto redirect from audits',
    FIELD_SURVEY_PENDING_DIALOG_SHOWN: 'Field survey pending dialog shown',
    FIELD_SURVEY_PENDING_COMPLETE_LATER: 'Field survey pending complete later',
    FIELD_SURVEY_PENDING_GO_TO_SETUP: 'Field survey pending go to setup',
    FIELD_SURVEY_CTA_GO_TO_SETUP: 'Field survey CTA go to setup',
    FIELD_SURVEY_FORM_LOADED: 'Field survey form loaded',
    FIELD_SURVEY_FORM_ACCESS_DENIED: 'Field survey form access denied',
    FIELD_SURVEY_FORM_NOT_FOUND: 'Field survey form not found',
    FIELD_SURVEY_SURVEY_WORK_SAVED: 'Field survey survey work saved',
    FIELD_SURVEY_SURVEY_WORK_CREATED_FROM_MAP: 'Field survey survey work created from map',
    FIELD_SURVEY_SURVEY_WORK_DELETED: 'Field survey survey work deleted',
    FIELD_SURVEY_MAP_ADD_BLOCKED: 'Field survey map add blocked',
    FIELD_SURVEY_COMPLETED: 'Field survey completed',
    FIELD_SURVEY_PONCE_CHARGE_DIALOG_OPENED: 'Field survey Ponce charge dialog opened',
    FIELD_SURVEY_TECHNICIAN_USER_CREATED: 'Field survey technician user created'
  },
  DEFAULT_PERMISSIONS_BY_ROLE: {
    admin: [],
    owner: ['failure', 'off'],
    manager: ['failure', 'off'],
    fieldman: ['failure', 'off', 'pressure'],
    farmhand: ['failure', 'off', 'irrigationOrders', 'position', 'pressure']
  },
  DEFAULT_DAYS_BEFORE_START_TO_ALLOW_INITIAL_DATA: 90,
  CAMPAIGN_STEPS: {
    INTRODUCTION: 'introduction',
    T_AND_C: 't&c',
    EQUIPMENTS: 'equipments',
    FINISH: 'finish'
  },
  FIRESTORE_CAMPAIGN_PRE_DATA_STEPS: {
    T_AND_C: 'T&C',
    INTRODUCTION: 'Introduction',
    DEVICES: 'Devices',
    FINISH: 'Finish'
  },
  HUBSPOT_ONBOARDING_STATES: {
    NEW: 'NEW',
    FIRST_ACCESS: 'FIRST_ACCESS',
    ACCEPTED_TYC: 'ACCEPTED_TYC',
    CAMPAIGN_CREATED: 'CAMPAIGN_CREATED',
    COMPLETED_ONBOARDING: 'COMPLETED_ONBOARDING'
  },
  CAMPAIGN_VALIDATION: {
    MIN_DAYS_BEFORE_START: 21
  },
  DEVICE_CONSTANTS: {
    DAYS_FOR_END_OF_SERVICE_NOTICE: 10
  },
  PRODUCT_TYPES: {
    MONITORING: 'monitoring',
    EXTENSION: 'extension'
  },
  AUDITS: {
    OTHER_MOTOR_RPM_ID: '3',
    NO_VISIBLE_MOTOR_RPM_ID: '0',
    ALTIMETRY: {
      DISTANCE_TO_CENTER_DIFFERENCE: 30,
      ANGLES_DIFFERENCE: 30
    },
    OUTLET_TYPES: {
      PLUG: {
        ID: '0',
        LABEL: 'Tapón'
      },
      OUTLET: {
        ID: '1',
        LABEL: 'Bajante'
      },
      END_OF_PIVOT_SPRINKLER: {
        ID: '2',
        LABEL: 'Aspersor de fin de pivot'
      },
      CANNON: {
        ID: '3',
        LABEL: 'Cañón'
      },
      SANDTRAP: {
        ID: '4',
        LABEL: 'Trampa de arena'
      }
    },
    SPAN_TYPE_SPAN_ID: '0',
    SPRINKLER_TYPES: {
      PLUG: '0',
      WITHOUT_SPRINKLER: '1'
    },
    NOZZLE: {
      NULL: '0'
    }
  },
  DEFAULT_PLUVIOMETRIC_CHART_DATA: DEFAULT_PLUVIOMETRIC_CHART_DATA,
  DEFAULT_FIELD_SOURCE: DEFAULT_FIELD_SOURCE,
  DEFAULT_PLUVIOMETRIC_CHART_ADVANCED_CONFIGURATION: DEFAULT_PLUVIOMETRIC_CHART_ADVANCED_CONFIGURATION
};

var EQUIPMENT_TYPE = allExports.EQUIPMENT_TYPE,
    EQUIPMENT_SUBTYPE = allExports.EQUIPMENT_SUBTYPE,
    EQUIPMENT_TYPES_LABELS = allExports.EQUIPMENT_TYPES_LABELS,
    defaultRoles = allExports.defaultRoles,
    USER_ROLES = allExports.USER_ROLES,
    PROFILE_PIC_FILE_SIZE_LIMIT = allExports.PROFILE_PIC_FILE_SIZE_LIMIT,
    ALLOWED_IMAGES_FILE_TYPES = allExports.ALLOWED_IMAGES_FILE_TYPES,
    ALLOWED_IMAGES_FILE_EXTENSIONS = allExports.ALLOWED_IMAGES_FILE_EXTENSIONS,
    NOTIFICATIONS_TYPES = allExports.NOTIFICATIONS_TYPES,
    ALLOWED_PLUVIOMETRIC_CHARTS_FILE_TYPES = allExports.ALLOWED_PLUVIOMETRIC_CHARTS_FILE_TYPES,
    ALLOWED_PLUVIOMETRIC_CHARTS_FILE_EXTENSIONS = allExports.ALLOWED_PLUVIOMETRIC_CHARTS_FILE_EXTENSIONS,
    WEBHOOKS_PATHS = allExports.WEBHOOKS_PATHS,
    HTTP_STATUS = allExports.HTTP_STATUS,
    CUSTOM_ERROR_CODES = allExports.CUSTOM_ERROR_CODES,
    MIDDLEWARE_PATHS = allExports.MIDDLEWARE_PATHS,
    SATISFACTION_SURVEY = allExports.SATISFACTION_SURVEY,
    PRESSURE = allExports.PRESSURE,
    DEFAULT_START_ANGLE = allExports.DEFAULT_START_ANGLE,
    EVENTS_TO_TRACK = allExports.EVENTS_TO_TRACK,
    DEFAULT_PERMISSIONS_BY_ROLE = allExports.DEFAULT_PERMISSIONS_BY_ROLE,
    DEFAULT_DAYS_BEFORE_START_TO_ALLOW_INITIAL_DATA = allExports.DEFAULT_DAYS_BEFORE_START_TO_ALLOW_INITIAL_DATA,
    CAMPAIGN_STEPS = allExports.CAMPAIGN_STEPS,
    FIRESTORE_CAMPAIGN_PRE_DATA_STEPS = allExports.FIRESTORE_CAMPAIGN_PRE_DATA_STEPS,
    HUBSPOT_ONBOARDING_STATES = allExports.HUBSPOT_ONBOARDING_STATES,
    CAMPAIGN_VALIDATION = allExports.CAMPAIGN_VALIDATION,
    DEVICE_CONSTANTS = allExports.DEVICE_CONSTANTS,
    PRODUCT_TYPES = allExports.PRODUCT_TYPES,
    AUDITS = allExports.AUDITS;



/* unused harmony default export */ var _unused_webpack_default_export = (allExports);

/***/ }),

/***/ 302:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return auth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return firestore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return firestoreConstructors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return storage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getAuthCurrentUser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_auth__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_firestore__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_storage__ = __webpack_require__(426);






var firebaseConfig = {
  apiKey: 'AIzaSyD8hfbPdqmz8rf1njlM4xTuZBkoKK19mJs',
  authDomain: 'ponce-staging.firebaseapp.com',
  databaseURL: 'https://ponce-staging.firebaseio.com',
  projectId: 'ponce-staging',
  storageBucket: 'ponce-staging.appspot.com',
  messagingSenderId: '764014852327',
  appId: '1:764014852327:web:bb7126fa42a08d9a89ca42'
};

__WEBPACK_IMPORTED_MODULE_1_firebase_app__["initializeApp"](firebaseConfig);

// utils
var auth = __WEBPACK_IMPORTED_MODULE_1_firebase_app__["auth"]();

var firestore = __WEBPACK_IMPORTED_MODULE_1_firebase_app__["firestore"]().enablePersistence({ synchronizeTabs: true }).then(function () {
  return __WEBPACK_IMPORTED_MODULE_1_firebase_app__["firestore"]();
});

var firestoreConstructors = __WEBPACK_IMPORTED_MODULE_1_firebase_app__["firestore"];

var storage = __WEBPACK_IMPORTED_MODULE_1_firebase_app__["storage"]();

var userLoaded = false;
/**
 * Retrieves the currently authenticated user. If the user data has not been loaded yet,
 * it waits for the user's authentication state to change before resolving the promise.
 * @returns {Promise<Object|null>} A promise that resolves to the currently authenticated user or null if no user is authenticated.
 */
function getAuthCurrentUser() {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    if (userLoaded) {
      resolve(auth.currentUser);
    } else {
      var unsubscribe = auth.onAuthStateChanged(function (user) {
        userLoaded = true;
        unsubscribe();
        resolve(user);
      }, reject);
    }
  });
}



/***/ }),

/***/ 303:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["o"] = sortByName;
/* harmony export (immutable) */ __webpack_exports__["x"] = isoDateToSlashes;
/* harmony export (immutable) */ __webpack_exports__["I"] = checkAndParseFloat;
/* harmony export (immutable) */ __webpack_exports__["e"] = parseDevice;
/* harmony export (immutable) */ __webpack_exports__["m"] = getBearing;
/* harmony export (immutable) */ __webpack_exports__["h"] = isAuthToEdit;
/* harmony export (immutable) */ __webpack_exports__["i"] = isAuthToReports;
/* harmony export (immutable) */ __webpack_exports__["j"] = isAuthToAudits;
/* harmony export (immutable) */ __webpack_exports__["K"] = isAuthToFieldSurveys;
/* harmony export (immutable) */ __webpack_exports__["J"] = parsePluviometricChartData;
/* harmony export (immutable) */ __webpack_exports__["D"] = getPivotZoom;
/* harmony export (immutable) */ __webpack_exports__["H"] = getZoom;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return makeFetchQueryRequest; });
/* unused harmony export parseFirestoreLocation */
/* harmony export (immutable) */ __webpack_exports__["n"] = getCoordinate;
/* harmony export (immutable) */ __webpack_exports__["a"] = parsePhoneNumberForWaMe;
/* harmony export (immutable) */ __webpack_exports__["p"] = cleanDeep;
/* harmony export (immutable) */ __webpack_exports__["F"] = getLetterFromIndex;
/* harmony export (immutable) */ __webpack_exports__["t"] = getCampaignIdsWithPendingInitialData;
/* harmony export (immutable) */ __webpack_exports__["s"] = hasUserActiveCampaigns;
/* harmony export (immutable) */ __webpack_exports__["z"] = validateLatLon;
/* harmony export (immutable) */ __webpack_exports__["k"] = replaceWithBr;
/* harmony export (immutable) */ __webpack_exports__["r"] = getUserImg;
/* harmony export (immutable) */ __webpack_exports__["d"] = parseCampaignData;
/* harmony export (immutable) */ __webpack_exports__["v"] = isNearEndOfService;
/* harmony export (immutable) */ __webpack_exports__["g"] = getLatestClonedDevices;
/* harmony export (immutable) */ __webpack_exports__["b"] = parseField;
/* harmony export (immutable) */ __webpack_exports__["f"] = getLatestClonedFields;
/* unused harmony export getCropsForFields */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return loadCampaignDataToStore; });
/* harmony export (immutable) */ __webpack_exports__["y"] = ddMMyyyyToJsDate;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getSatisfactionSurveyConstants; });
/* harmony export (immutable) */ __webpack_exports__["B"] = getOutletsConfigurationAnalysis;
/* harmony export (immutable) */ __webpack_exports__["E"] = getOutletsReportData;
/* harmony export (immutable) */ __webpack_exports__["A"] = formatNumberHelper;
/* unused harmony export mapAltimetryByNearest */
/* harmony export (immutable) */ __webpack_exports__["C"] = isObservationsDocumentEmpty;
/* harmony export (immutable) */ __webpack_exports__["c"] = parseCrop;
/* harmony export (immutable) */ __webpack_exports__["G"] = parseStringToCoordinates;
/* harmony export (immutable) */ __webpack_exports__["q"] = getDataChanges;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_values__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_entries__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_slicedToArray__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_geolib_es_getDistance__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_geolib_es_getDistance___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_geolib_es_getDistance__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_geolib_es_isValidCoordinate__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_geolib_es_isValidCoordinate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_geolib_es_isValidCoordinate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_get__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_some__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_some___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash_some__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_omit__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_omit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_lodash_omit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_isArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_isPlainObject__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_isPlainObject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_lodash_isPlainObject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash_mapValues__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash_mapValues___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_lodash_mapValues__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash_omitBy__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash_omitBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_lodash_omitBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_lodash_isNil__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lodash_flatMap__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lodash_flatMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_lodash_flatMap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_lodash_isEmpty__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_lodash_uniq__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_lodash_uniq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_lodash_uniq__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_lodash_flatten__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_lodash_flatten___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_lodash_flatten__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_lodash_max__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_lodash_max___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_lodash_max__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_lodash_minBy__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_lodash_minBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_lodash_minBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_lodash_memoize__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_lodash_memoize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_lodash_memoize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_lodash_isEqual__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_lodash_set__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_lodash_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_lodash_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_lodash_merge__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_lodash_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_lodash_merge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__plugins_firebase__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__store__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__constants_const__ = __webpack_require__(301);












// vendors























// constants


/**
 * Sorting function that campares to objects with a name property, the names are compared alphabetically.
 * This function is used in a sort function of an array.
 * @param {{name: string}} a
 * @param {{name: string}} b
 * @returns {number}
 */
function sortByName(a, b) {
  var aName = a.name.toUpperCase();
  var bName = b.name.toUpperCase();
  return aName.localeCompare(bName, undefined, { numeric: true, sensitivity: 'base' });
}

/**
 * It converts a string date in ISO format to `day/month/year` format,
 * without modifying the original string.
 * @param {string} isoDate string date in ISO format.
 * @returns {string}
 */
function isoDateToSlashes(isoDate) {
  if (!isoDate) return '';

  var _isoDate$split$0$spli = isoDate.split('T')[0].split('-'),
      _isoDate$split$0$spli2 = __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_slicedToArray___default()(_isoDate$split$0$spli, 3),
      year = _isoDate$split$0$spli2[0],
      month = _isoDate$split$0$spli2[1],
      day = _isoDate$split$0$spli2[2];

  return day + '/' + month + '/' + year;
}

/**
 * Checks if a value exists into an object, if it exists it is returned as a float number
 * @param {Object} obj
 * @param {string} path
 * @returns {number|null}
 */
function checkAndParseFloat(obj, path) {
  var val = __WEBPACK_IMPORTED_MODULE_14_lodash_get___default()(obj, path);
  return val ? parseFloat(val) : null;
}

/**
 * Parses the device data retrieved from Firestore into the required format for this app
 * @param {string} deviceId
 * @param {Object} deviceData - Raw data from Firebase
 * @returns {Object}
 */
function parseDevice(deviceId, deviceData) {
  var notifications = [];
  deviceData.users.data.forEach(function (user) {
    notifications[user.id] = {
      id: user.id,
      name: user.name,
      permissions: {
        failure: false,
        pressure: false,
        off: false,
        position: false
      }
    };
  });
  __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_entries___default()(deviceData.users.permissions.notifications).forEach(function (permission) {
    permission[1].forEach(function (user) {
      if (notifications[user.id]) {
        notifications[user.id].permissions[permission[0]] = true;
      }
    });
  });

  // Device crops parsing
  var campaign = deviceData.campaign;
  campaign = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends___default()({}, campaign, {
    crops: campaign.crops.map(function (crop) {
      // Map only the fields we need, avoiding Firestore internal fields
      var mappedCrop = {
        name: crop.name || '',
        device: deviceId,
        originalDevice: deviceId,
        field: crop.field && crop.field.id,
        startDate: crop.startDate || '',
        radius: crop.radius || 0, // radius doesn't exist in pivot lots created before the CropEditor form was submitted to production
        cropRef: crop.cropRef && crop.cropRef.id,
        clonedFrom: crop.clonedFrom && crop.clonedFrom.length > 0 ? crop.clonedFrom.map(function (ref) {
          return ref.id;
        }) : [],
        organization: crop.organization && crop.organization.id,
        campaign: crop.campaign && crop.campaign.id

        // Handle GeoPoint fields if they exist
      };__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_entries___default()(crop).forEach(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        if (value instanceof __WEBPACK_IMPORTED_MODULE_32__plugins_firebase__["c" /* firestoreConstructors */].GeoPoint) {
          mappedCrop[key] = { latitude: value.latitude, longitude: value.longitude };
        }
      });

      return mappedCrop;
    })
  });

  var pluviometricCharts = deviceData.pluviometricCharts;
  if (pluviometricCharts && pluviometricCharts.length) {
    pluviometricCharts = pluviometricCharts.map(function (chart) {
      var chartObj = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends___default()({}, chart, {
        parsedChartId: chart.parsedChartReference ? chart.parsedChartReference.id : ''
      });
      delete chartObj.parsedChartReference;

      return chartObj;
    });
  }

  var postponementRequest = deviceData.postponementRequest;
  if (postponementRequest) {
    postponementRequest = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends___default()({}, postponementRequest, {
      suggestedDate: postponementRequest.suggestedDate.toDate()
    });
  }

  return {
    id: deviceId,
    currentCampaign: deviceData.currentCampaign && deviceData.currentCampaign.id,
    campaign: campaign,
    equipment: deviceData.equipment,
    pluviometricCharts: pluviometricCharts,
    users: deviceData.users && deviceData.users.data ? deviceData.users.data.sort(function (a, b) {
      return a.name > b.name ? 1 : b.name > a.name ? -1 : 0;
    }) : [],
    notifications: notifications ? __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_values___default()(notifications) : [],
    isDemoDevice: deviceData.isDemoDevice,
    clonedFrom: deviceData.clonedFrom ? deviceData.clonedFrom.map(function (cloned) {
      return cloned.id;
    }) : [],
    hasCompleteData: !!deviceData.hasCompleteData,
    zoom: deviceData.zoom,
    postponementRequest: postponementRequest,
    serviceStartDate: deviceData.serviceStartDate && deviceData.serviceStartDate.toDate(),
    serviceEndDate: deviceData.serviceEndDate && deviceData.serviceEndDate.toDate(),
    serviceExtensionRequests: deviceData.serviceExtensionRequests || [],
    installationField: deviceData.installationField && deviceData.installationField.id,
    installationCoordinates: deviceData.installationCoordinates ? parseFirestoreLocation(deviceData.installationCoordinates) : null,
    modem: deviceData.modem || {}
  };
}

function toDegrees(radians) {
  return radians * 180 / Math.PI;
}
function toRadians(degrees) {
  return degrees * Math.PI / 180;
}

/**
 * Calculates the angle that the "destiny Point" has with regard to the "start point"
 * @param {{latitude: number, longitude: number}} startCoord
 * @param {{latitude: number, longitude: number}} destCoord
 * @returns {number}
 */
function getBearing(startCoord, destCoord) {
  var startLat = toRadians(startCoord.latitude);
  var startLng = toRadians(startCoord.longitude);
  var destLat = toRadians(destCoord.latitude);
  var destLng = toRadians(destCoord.longitude);

  var y = Math.sin(destLng - startLng) * Math.cos(destLat);
  var x = Math.cos(startLat) * Math.sin(destLat) - Math.sin(startLat) * Math.cos(destLat) * Math.cos(destLng - startLng);
  var brng = Math.atan2(y, x);
  brng = toDegrees(brng);
  return (brng + 360) % 360;
}

/**
 * Check if an user is authorized to manage the organization data
 * @param {{roles: Object, editDataPermission: boolean}} user - The stored user object
 * @param {string|Boolean} impersonating - Whether the user is being impersonated
 * @returns {boolean}
 */
function isAuthToEdit(user) {
  var impersonating = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var hasEditPermission = __WEBPACK_IMPORTED_MODULE_15_lodash_some___default()(user.userCampaignsSettings, function (campaign) {
    return campaign.editDataPermission;
  });
  return impersonating || user && (user.isAdmin || hasEditPermission);
}

/**
 * Check if an user is authorized to view reports data
 * @param {{roles: Object, reports: boolean}} user - The stored user object
 * @param {string|Boolean} impersonating - Whether the user is being impersonated
 * @returns {boolean}
 */
function isAuthToReports(user) {
  var impersonating = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var hasReportsPermission = __WEBPACK_IMPORTED_MODULE_15_lodash_some___default()(user.userCampaignsSettings, function (campaign) {
    return campaign.reports;
  });
  return impersonating || user && (user.isAdmin || hasReportsPermission);
}

/**
 * Check if an user is authorized to view audits data
 * @param {{roles: Object, audits: boolean}} user - The stored user object
 * @param {string|Boolean} impersonating - Whether the user is being impersonated
 * @returns {boolean}
 */
function isAuthToAudits(user) {
  var impersonating = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  return impersonating || user && (user.isAdmin || user.audits || user.fieldSurveyIds && user.fieldSurveyIds.length > 0);
}

/**
 * Field survey entry route: audits users, admins, or users with fieldSurveyIds on their profile.
 * @param {{ isAdmin?: boolean, audits?: boolean, fieldSurveyIds?: string[] }} user
 * @param {string|boolean} impersonating
 * @returns {boolean}
 */
function isAuthToFieldSurveys(user) {
  var impersonating = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (impersonating) return true;
  if (!user) return false;
  if (user.isAdmin || user.audits) return true;
  return !!(user.fieldSurveyIds && user.fieldSurveyIds.length);
}

/**
 * Parsed the pluviemetric chart data retrieved from firestore into values that are shown in the edit cards
 * @param {{linkToFile: string, validityDate: Date, creationDate: Date, parsedChartId: string}} pluviometricChart - Data from firestore
 * @returns {pluviometricChartFile: File, validityDate: string, creationDate: string, parsedChartId: string}
 */
function parsePluviometricChartData(pluviometricChart) {
  var pluviometricChartFile = void 0;
  var validityDate = '';
  var creationDate = '';
  var parsedChartId = '';

  if (pluviometricChart) {
    pluviometricChartFile = pluviometricChart.linkToFile
    // creates empty file so the v-file-input shows the file name
    ? new File([], pluviometricChart.linkToFile.split('/').pop()) : undefined;
    validityDate = pluviometricChart.validityDate ? pluviometricChart.validityDate.toDate().toISOString() : '';
    creationDate = pluviometricChart.creationDate ? pluviometricChart.creationDate.toDate().toISOString() : '';
    parsedChartId = pluviometricChart.parsedChartId || '';
  }

  return { pluviometricChartFile: pluviometricChartFile, validityDate: validityDate, creationDate: creationDate, parsedChartId: parsedChartId };
}

/**
 * It gets the zoom for a Pivot, depending on its length.
 * @param {number} length
 * @returns {number} the zoom for a pivot
 */
function getPivotZoom() {
  var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  if (length < 310) return 16;
  if (length < 650) return 15;
  return 14;
}

/**
 * It gets the zoom for a Linear or Irrigation Reel, depending on its length.
 * @param {number} length
 * @returns {number} the zoom for a Linear or Irrigation Reel
 */
function getLinearOrReelZoom() {
  var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  if (length < 2800) return 15;
  if (length < 3500) return 14;
  if (length < 9000) return 13;
  return 12;
}

/**
 * It gets the max lot distance of an Irrigation Reel.
 * @param {Array<{ points: Array<{ latitude: number, longitude: number }> }>} lots
 * the device's lots
 * @returns {number} the max lot distance
 */
function getIRLotMaxDistance() {
  var lots = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var maxDistance = 0;

  lots.forEach(function (_ref3) {
    var points = _ref3.points;

    if (points) {
      var maxLat = void 0,
          minLat = void 0,
          maxLon = void 0,
          minLon = void 0;

      points.forEach(function (_ref4) {
        var latitude = _ref4.latitude,
            longitude = _ref4.longitude;

        if (!minLat || latitude < minLat) minLat = latitude;
        if (!maxLat || latitude > maxLat) maxLat = latitude;
        if (!minLon || longitude < minLon) minLon = longitude;
        if (!maxLon || longitude > maxLon) maxLon = longitude;
      });

      var latitudeDistance = __WEBPACK_IMPORTED_MODULE_12_geolib_es_getDistance___default()({ latitude: minLat, longitude: 0 }, { latitude: maxLat, longitude: 0 }, 0.01);
      var longitudeDistance = __WEBPACK_IMPORTED_MODULE_12_geolib_es_getDistance___default()({ latitude: 0, longitude: minLon }, { latitude: 0, longitude: maxLon }, 0.01);
      var distance = latitudeDistance > longitudeDistance ? latitudeDistance : longitudeDistance;

      if (!maxDistance || distance > maxDistance) maxDistance = distance;
    }
  });

  return maxDistance;
}

/**
 * It calculates the map zoom for a device, depending on its type and length or
 * lots' length.
 * @param {EQUIPMENT_TYPE} type device type
 * @param {number} length device length
 * device lots, to be used if the device is an Irrigation Reel
 * @returns {number} the map zoom to be used for the device
 */
function getZoom(type) {
  var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_34__constants_const__["b" /* EQUIPMENT_TYPE */].PIVOT:
      return getPivotZoom(length);
    case __WEBPACK_IMPORTED_MODULE_34__constants_const__["b" /* EQUIPMENT_TYPE */].AF:
      return getLinearOrReelZoom(length);
    case __WEBPACK_IMPORTED_MODULE_34__constants_const__["b" /* EQUIPMENT_TYPE */].IR:
      return getLinearOrReelZoom(getIRLotMaxDistance());
    default:
      return 0;
  }
}

var makeFetchQueryRequest = function () {
  var _ref5 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee(body, user) {
    var fetchOptions, res;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!user) {
              _context.next = 6;
              break;
            }

            _context.next = 3;
            return user.getIdToken();

          case 3:
            _context.t0 = _context.sent;
            _context.next = 7;
            break;

          case 6:
            _context.t0 = '';

          case 7:
            _context.t1 = _context.t0;
            _context.t2 = {
              'auth-token': _context.t1
            };
            _context.t3 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(body);
            fetchOptions = {
              method: 'POST',
              headers: _context.t2,
              body: _context.t3
            };
            _context.next = 13;
            return fetch('https://us-central1-' + 'ponce-staging' + '.cloudfunctions.net/fetchQuery', fetchOptions);

          case 13:
            res = _context.sent;
            return _context.abrupt('return', res.json());

          case 15:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function makeFetchQueryRequest(_x9, _x10) {
    return _ref5.apply(this, arguments);
  };
}();

function parseFirestoreLocation(location) {
  return {
    latitude: location.latitude,
    longitude: location.longitude
  };
}

function getCoordinate(coordinate) {
  var result = {
    latitude: 0,
    longitude: 0
  };
  if (coordinate.latitude && coordinate.longitude) {
    result = {
      latitude: coordinate.latitude,
      longitude: coordinate.longitude
    };
  } else if (coordinate._latitude && coordinate._longitude) {
    result = {
      latitude: coordinate._latitude,
      longitude: coordinate._longitude
    };
  } else if (coordinate.getLatitude && coordinate.getLongitude) {
    result = {
      latitude: coordinate.getLatitude(),
      longitude: coordinate.getLongitude()
    };
  }
  return result;
}

function parsePhoneNumberForWaMe(phone) {
  return phone.replaceAll(/\s/g, '').replaceAll('+', '').replaceAll('-', '');
}

/**
 * Recursively removes null and undefined values from objects and arrays.
 * @param {*} value - Any value (object, array, primitive).
 * @returns {*} - Cleaned value with null/undefined removed.
 */
function cleanDeep(value) {
  if (__WEBPACK_IMPORTED_MODULE_17_lodash_isArray___default()(value)) {
    return value.map(cleanDeep).filter(function (v) {
      return !__WEBPACK_IMPORTED_MODULE_21_lodash_isNil___default()(v);
    });
  }

  if (__WEBPACK_IMPORTED_MODULE_18_lodash_isPlainObject___default()(value)) {
    var mapped = __WEBPACK_IMPORTED_MODULE_19_lodash_mapValues___default()(value, cleanDeep);
    return __WEBPACK_IMPORTED_MODULE_20_lodash_omitBy___default()(mapped, function (v) {
      return __WEBPACK_IMPORTED_MODULE_21_lodash_isNil___default()(v);
    });
  }

  return value;
}

/**
 * Converts a given index to its corresponding uppercase letter in the English alphabet.
 *
 * @param {number} index - The index to convert, where 1 corresponds to 'A', 2 to 'B', etc.
 * @returns {string} The uppercase letter corresponding to the given index.
 */
function getLetterFromIndex(index) {
  return String.fromCharCode(64 + index);
}

/**
 * Gets campaign IDs with pending initial data that the user has permission to edit.
 * Filters campaigns based on user permissions and date range (X days before estimated start date).
 * Returns array of campaign IDs sorted chronologically by estimatedStartDate.
 *
 * @param {Array<object>} campaigns - Array of campaign objects
 * @param {Array<object>} userCampaignsSettings - User's campaign permissions
 * @returns {Array<string>} Array of campaign IDs with pending initial data, sorted by estimatedStartDate
 */
function getCampaignIdsWithPendingInitialData(campaigns, userCampaignsSettings) {
  // Get campaign IDs where user has owner role or edit permission
  var filteredCampaignsIds = userCampaignsSettings.filter(function (userCampaign) {
    return userCampaign.roles.owner || userCampaign.editCampaignDataPermission;
  }).map(function (campaign) {
    return campaign.id;
  });

  // Filter campaigns by user permissions and date range (90 days before estimated start date)
  var filteredCampaigns = campaigns.filter(function (campaign) {
    return filteredCampaignsIds.includes(campaign.id) && new Date() >= campaign.estimatedStartDate.toDate() - 1000 * 60 * 60 * 24 * (__WEBPACK_IMPORTED_MODULE_33__store__["a" /* store */].getters.globalConstants && __WEBPACK_IMPORTED_MODULE_33__store__["a" /* store */].getters.globalConstants.daysBeforeStartToAllowInitialData || __WEBPACK_IMPORTED_MODULE_34__constants_const__["c" /* DEFAULT_DAYS_BEFORE_START_TO_ALLOW_INITIAL_DATA */]) &&
    // Validate that at least one property in preDataSteps is false (has pending initial data)
    campaign.preDataSteps && __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_values___default()(campaign.preDataSteps).some(function (step) {
      return step === false;
    });
  });

  // Return empty array if no campaigns match the criteria
  if (filteredCampaigns.length === 0) {
    return [];
  }

  // Sort campaigns chronologically by estimatedStartDate (ascending order) and return IDs
  var sortedCampaignIds = filteredCampaigns.sort(function (a, b) {
    return a.estimatedStartDate.toDate() - b.estimatedStartDate.toDate();
  }).map(function (campaign) {
    return campaign.id;
  });

  return sortedCampaignIds;
}

/**
 * Checks if a user has active campaigns based on campaign date ranges.
 * A campaign is considered active if the current date falls between campaign.fromDate and campaign.toDate.
 *
 * @param {Array<object>} campaigns - Array of campaign objects
 * @param {Array<object>} userCampaignsSettings - User's campaign permissions
 * @returns {boolean} True if user has at least one active campaign, false otherwise
 */
function hasUserActiveCampaigns(campaigns, userCampaignsSettings) {
  // Get campaign IDs where user has any role or permission
  var filteredCampaignsIds = userCampaignsSettings.filter(function (userCampaign) {
    return userCampaign.roles.owner || userCampaign.editCampaignDataPermission;
  }).map(function (campaign) {
    return campaign.id;
  });

  // Check if any campaign is currently active (current date is between fromDate and toDate)
  var hasActiveCampaign = campaigns.some(function (campaign) {
    // Check if user has access to this campaign
    if (!filteredCampaignsIds.includes(campaign.id)) {
      return false;
    }

    // Check if campaign has valid date range
    if (!campaign.fromDate || !campaign.toDate) {
      return false;
    }

    var currentDate = new Date();
    var fromDate = campaign.fromDate.toDate ? campaign.fromDate.toDate() : new Date(campaign.fromDate);
    var toDate = campaign.toDate.toDate ? campaign.toDate.toDate() : new Date(campaign.toDate);

    // Campaign is active if current date is between fromDate and toDate (inclusive)
    return currentDate >= fromDate && currentDate <= toDate;
  });

  return hasActiveCampaign;
}

function dmsComponentToDecimal(degrees, minutes, seconds, direction) {
  var decimal = Math.abs(degrees) + minutes / 60 + seconds / 3600;
  if (/[SW]/i.test(direction)) decimal *= -1;
  return decimal;
}

function parseDMSPart(part) {
  // First try DDM format: 33°07.406' S
  var ddmRegex = /(\d{1,3})[°]\s*(\d{1,2}(?:\.\d+)?)[']\s*([NSEW])/i;
  var ddmMatch = part.trim().match(ddmRegex);

  if (ddmMatch) {
    var _ddmMatch = __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_slicedToArray___default()(ddmMatch, 4),
        _deg = _ddmMatch[1],
        _min = _ddmMatch[2],
        _dir = _ddmMatch[3];

    return dmsComponentToDecimal(parseFloat(_deg), parseFloat(_min), 0, _dir);
  }

  // Then try DMS format: 33°07'24.4"S
  var dmsRegex = /(\d{1,3})[°]\s*(\d{1,2})?[']\s*(\d{1,2}(?:\.\d+)?)?["]\s*([NSEW])/i;
  var dmsMatch = part.trim().match(dmsRegex);

  if (!dmsMatch) return null;

  var _dmsMatch = __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_slicedToArray___default()(dmsMatch, 5),
      deg = _dmsMatch[1],
      _dmsMatch$ = _dmsMatch[2],
      min = _dmsMatch$ === undefined ? 0 : _dmsMatch$,
      _dmsMatch$2 = _dmsMatch[3],
      sec = _dmsMatch$2 === undefined ? 0 : _dmsMatch$2,
      dir = _dmsMatch[4];

  return dmsComponentToDecimal(parseFloat(deg), parseFloat(min), parseFloat(sec), dir);
}

function isLikelyDMS(input) {
  return (/[°′'″"]/g.test(input) || /[NSEW]/i.test(input)
  );
}

function parseDecimalLatLonString(input) {
  var parts = input.split(/[, ]+/).map(function (s) {
    return s.trim();
  }).filter(Boolean);
  if (parts.length !== 2) return null;

  var lat = parseFloat(parts[0]);
  var lon = parseFloat(parts[1]);
  if (isNaN(lat) || isNaN(lon)) return null;

  return { latitude: lat, longitude: lon };
}

function parseDMSLatLonString(input) {
  // Look for patterns like: 33°07.406' S, 60°59.259' W or 33°07.406' S 60°59.259' W
  // But NOT: 33°07.406' S60°59.259' W (missing separator)
  var dmsPattern = /^\s*(\d{1,3}°\s*\d{1,2}(?:\.\d+)?'\s*(?:\d{1,2}(?:\.\d+)?")?\s*[NS])\s*(?:,\s*|\s+)(\d{1,3}°\s*\d{1,2}(?:\.\d+)?'\s*(?:\d{1,2}(?:\.\d+)?")?\s*[EW])\s*$/i;
  var match = input.match(dmsPattern);

  if (!match) return null;

  var lat = parseDMSPart(match[1]);
  var lon = parseDMSPart(match[2]);
  if (lat === null || lon === null) return null;

  return { latitude: lat, longitude: lon };
}

function validateLatLon(input) {
  if (!input || typeof input !== 'string') {
    return false;
  }

  var trimmedInput = input.trim();
  if (!trimmedInput) {
    return false;
  }

  var coords = isLikelyDMS(trimmedInput) ? parseDMSLatLonString(trimmedInput) : parseDecimalLatLonString(trimmedInput);

  if (!coords) {
    return false;
  }

  return __WEBPACK_IMPORTED_MODULE_13_geolib_es_isValidCoordinate___default()(coords);
}

function replaceWithBr(s) {
  if (s) {
    return s.replace(/\n/g, '<br />');
  } else {
    return '';
  }
}

function getUserImg(user) {
  if (user.photoUrl) {
    return user.profilePic;
  }
  switch (user.role) {
    case 'admin':
    case 'owner':
      return __webpack_require__(176);
    case 'manager':
      return __webpack_require__(310);
    case 'fieldman':
      return __webpack_require__(309);
    case 'farmhand':
      return __webpack_require__(308);
    default:
      return __webpack_require__(176);
  }
}

function parseCampaignData(doc) {
  var campaignData = doc.data();

  // Handle device references if they exist
  var processedData = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends___default()({}, campaignData);

  // If campaign has devices array, convert references to IDs
  if (campaignData.devices && Array.isArray(campaignData.devices)) {
    processedData.devices = campaignData.devices.map(function (device) {
      // If device is a Firestore reference, extract the ID
      if (device && (typeof device === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(device)) === 'object' && device.id) {
        return device.id;
      }
      // If device is already an ID string, return as is
      return device;
    });
  }

  // If campaign has fields array, convert references to IDs
  if (campaignData.fields && Array.isArray(campaignData.fields)) {
    processedData.fields = campaignData.fields.map(function (field) {
      // If field is a Firestore reference, extract the ID
      if (field && (typeof field === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(field)) === 'object' && field.id) {
        return field.id;
      }
      // If field is already an ID string, return as is
      return field;
    });
  }

  // If campaign has product array with devices, handle those too
  if (campaignData.product && Array.isArray(campaignData.product)) {
    processedData.product = campaignData.product.map(function (product) {
      if (product.devices && Array.isArray(product.devices)) {
        return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends___default()({}, product, {
          devices: product.devices.map(function (device) {
            if (device && (typeof device === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(device)) === 'object' && device.device && device.device.id) {
              return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends___default()({}, device, {
                device: device.device.id
              });
            }
            return device;
          })
        });
      }
      return product;
    });
  }

  if (campaignData.users && Array.isArray(campaignData.users)) {
    processedData.users = campaignData.users.map(function (user) {
      if (user && (typeof user === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(user)) === 'object' && user.id) {
        return user.id;
      }
      return user;
    });
  }

  if (campaignData.organization && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(campaignData.organization) === 'object' && campaignData.organization.id) {
    processedData.organization = campaignData.organization.id;
  }

  // Handle preDataProductsDetail references
  if (campaignData.preDataProductsDetail && Array.isArray(campaignData.preDataProductsDetail)) {
    processedData.preDataProductsDetail = campaignData.preDataProductsDetail.map(function (product) {
      if (product.devices && Array.isArray(product.devices)) {
        return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends___default()({}, product, {
          devices: product.devices.map(function (device) {
            var processedDevice = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends___default()({}, device);

            // Convert device reference to ID
            if (device.device && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(device.device) === 'object' && device.device.id) {
              processedDevice.device = device.device.id;
            }

            // Convert field reference to ID
            if (device.field && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(device.field) === 'object' && device.field.id) {
              processedDevice.field = device.field.id;
            }

            // Convert Firestore timestamps to date strings
            if (device.startDate && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(device.startDate) === 'object' && device.startDate.toDate) {
              var date = device.startDate.toDate();
              processedDevice.startDate = date.getDate().toString().padStart(2, '0') + '/' + (date.getMonth() + 1).toString().padStart(2, '0') + '/' + date.getFullYear();
            }

            if (device.endDate && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(device.endDate) === 'object' && device.endDate.toDate) {
              var _date = device.endDate.toDate();
              processedDevice.endDate = _date.getDate().toString().padStart(2, '0') + '/' + (_date.getMonth() + 1).toString().padStart(2, '0') + '/' + _date.getFullYear();
            }

            return processedDevice;
          })
        });
      }
      return product;
    });
  }

  return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends___default()({
    id: doc.id
  }, __WEBPACK_IMPORTED_MODULE_16_lodash_omit___default()(processedData, ['termsAndConditionsAcceptance.user']));
}

/**
 * Checks if a device is near the end of its service period.
 * A device is considered "near end of service" if it's within the configured
 * number of days before the service end date.
 *
 * @param {Object} device - The device object containing serviceEndDate
 * @param {Date} device.serviceEndDate - The service end date
 * @param {Object} globalConstants - Global constants object containing daysForEndOfServiceNotice
 * @param {number} globalConstants.daysForEndOfServiceNotice - Number of days before end to show notice (default: 30)
 * @returns {boolean} True if device is near end of service, false otherwise
 */
function isNearEndOfService(device) {
  var globalConstants = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!device.serviceEndDate) return false;

  var today = new Date();
  today.setHours(0, 0, 0, 0);

  var endDate = new Date(device.serviceEndDate);
  endDate.setHours(0, 0, 0, 0);

  var daysUntilEnd = Math.ceil((endDate - today) / (1000 * 60 * 60 * 24));

  // Get the constant from global constants, default to 30 days if not found
  var daysForEndOfServiceNotice = globalConstants.daysForEndOfServiceNotice || __WEBPACK_IMPORTED_MODULE_34__constants_const__["d" /* DEVICE_CONSTANTS */].DAYS_FOR_END_OF_SERVICE_NOTICE;

  return daysUntilEnd <= daysForEndOfServiceNotice && daysUntilEnd > 0;
}

/**
 * Filters and returns only the latest cloned devices from a list of devices.
 * Each device contains a `name` (its unique ID) and a `clonedFrom` array
 * indicating the chain of devices it was cloned from.
 *
 * The logic is: a device that has been cloned will appear in another device's
 * `clonedFrom` list. Therefore, the latest cloned devices are those whose `name`
 * does not appear in any other `clonedFrom` array.
 *
 * @param {Array<{ name: string, clonedFrom: string[] }>} devices - The list of all devices.
 * @returns {Array<{ name: string, clonedFrom: string[] }>} - Only the latest cloned devices.
 */
function getLatestClonedDevices(devices) {
  // Collect all device names that appear in any clonedFrom array
  var allClonedIds = new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default.a(__WEBPACK_IMPORTED_MODULE_22_lodash_flatMap___default()(devices, function (device) {
    return device.clonedFrom;
  }));

  // Filter devices whose name is NOT included in the clonedFrom sets
  // These are considered the latest in their respective cloning chains
  return devices.filter(function (device) {
    return !allClonedIds.has(device.id);
  });
}

/**
 * Parses the field data retrieved from Firestore into the required format for this app
 * @param {string} fieldId
 * @param {Object} fieldData - Raw data from Firebase
 * @returns {Object}
 */
function parseField(fieldId, fieldData) {
  var crops = [];
  if (fieldData.crops) {
    crops = fieldData.crops.map(function (crop) {
      return crop.id;
    });
  }

  // Create editable copies of gates to avoid readonly property issues
  var gates = [];
  if (fieldData.gates) {
    gates = fieldData.gates.map(function (gate) {
      return {
        latitude: gate.latitude || '',
        longitude: gate.longitude || ''
      };
    });
  }

  return {
    id: fieldId,
    name: fieldData.name,
    organization: fieldData.organization && fieldData.organization.id,
    contact: fieldData.contact && fieldData.contact.id,
    auxContact: fieldData.auxContact && fieldData.auxContact.id,
    gates: gates,
    crops: crops,
    clonedFrom: fieldData.clonedFrom ? fieldData.clonedFrom.map(function (cloned) {
      return cloned.id;
    }) : []
  };
}

/**
 * Filters and returns only the latest cloned fields from a list of fields.
 * Each field contains a `name` (its unique ID) and a `clonedFrom` array
 * indicating the chain of fields it was cloned from.
 *
 * The logic is: a field that has been cloned will appear in another field's
 * `clonedFrom` list. Therefore, the latest cloned fields are those whose `name`
 * does not appear in any other `clonedFrom` array.
 *
 * @param {Array<{ name: string, clonedFrom: string[] }>} fields - The list of all fields.
 * @returns {Array<{ name: string, clonedFrom: string[] }>} - Only the latest cloned fields.
 */
function getLatestClonedFields(fields) {
  // Collect all field names that appear in any clonedFrom array
  var allClonedIds = new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default.a(__WEBPACK_IMPORTED_MODULE_22_lodash_flatMap___default()(fields, function (field) {
    return field.clonedFrom || [];
  }));

  // Filter fields whose name is NOT included in the clonedFrom sets
  // These are considered the latest in their respective cloning chains
  return fields.filter(function (field) {
    return !allClonedIds.has(field.id);
  });
}

/**
 * Gets crops data for a list of fields from Firestore.
 *
 * @param {Array} fields - Array of field objects with crops array
 * @param {Object} db - Firestore database instance
 * @returns {Promise<Array>} Array of processed crop data
 */
var getCropsForFields = function () {
  var _ref6 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee2(fields, db) {
    var cropsIds, cropsQueries, cropsData, cropsIdsBatch, cropsQuery, cropsQueriesSnapshot, crops;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            cropsIds = __WEBPACK_IMPORTED_MODULE_24_lodash_uniq___default()(__WEBPACK_IMPORTED_MODULE_25_lodash_flatten___default()(fields.map(function (field) {
              return field.crops;
            })));
            cropsQueries = [];
            cropsData = [];


            while (cropsIds.length) {
              cropsIdsBatch = cropsIds.splice(0, 10);
              cropsQuery = db.collection('app/v1/crops').where(__WEBPACK_IMPORTED_MODULE_32__plugins_firebase__["c" /* firestoreConstructors */].FieldPath.documentId(), 'in', cropsIdsBatch).get();

              cropsQueries.push(cropsQuery);
            }

            _context2.next = 6;
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all(cropsQueries);

          case 6:
            cropsQueriesSnapshot = _context2.sent;
            crops = cropsQueriesSnapshot.reduce(function (cropsAcc, snapshot) {
              snapshot.forEach(function (doc) {
                cropsAcc.push(doc);
              });
              return cropsAcc;
            }, []);


            crops.forEach(function (crop) {
              if (crop.data()) {
                var cropData = crop.data();
                // Skip crops that have been logically deleted
                if ((!cropData.devices || cropData.devices.length === 0) && !cropData.field) {
                  return;
                }

                var startDate = cropData.startDate ? typeof cropData.startDate === 'string' ? new Date(cropData.startDate) : cropData.startDate.toDate() : undefined;
                var devices = cropData.devices ? cropData.devices.map(function (device) {
                  return device.id;
                }) : [];
                var campaign = cropData.campaign && cropData.campaign.id;
                var organization = cropData.organization && cropData.organization.id;
                var cropDataObj = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends___default()({}, cropData, {
                  id: crop.id,
                  field: cropData.field && cropData.field.id,
                  devices: devices,
                  campaign: campaign,
                  organization: organization,
                  clonedFrom: cropData.clonedFrom && cropData.clonedFrom.id,
                  type: cropData.type.split('|'),
                  sowingDate: startDate ? startDate.getDate().toString().padStart(2, '0') + '/' + (startDate.getMonth() + 1).toString().padStart(2, '0') + '/' + startDate.getFullYear() : ''
                });
                if (cropDataObj.location) {
                  cropDataObj.location = parseFirestoreLocation(cropDataObj.location);
                }
                if (cropDataObj.startPoint) {
                  cropDataObj.startPoint = parseFirestoreLocation(cropDataObj.startPoint);
                }
                if (cropDataObj.endPoint) {
                  cropDataObj.endPoint = parseFirestoreLocation(cropDataObj.endPoint);
                }
                cropsData.push(cropDataObj);
              }
            });
            return _context2.abrupt('return', cropsData);

          case 10:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function getCropsForFields(_x12, _x13) {
    return _ref6.apply(this, arguments);
  };
}();

/**
 * Loads campaign data into the store including devices, fields, users, and crops.
 * This function can be used when a campaign is selected or when a new campaign is finished.
 *
 * @param {string} campaignId - The ID of the campaign to load
 * @returns {Promise<void>}
 */
var loadCampaignDataToStore = function () {
  var _ref7 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee3(campaignId) {
    var user, selectedCampaign, devices, fields, users, db, crops;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            user = __WEBPACK_IMPORTED_MODULE_33__store__["a" /* store */].getters.user;

            if (!(!user || !user.campaigns)) {
              _context3.next = 5;
              break;
            }

            console.warn('User or campaigns not available');
            return _context3.abrupt('return');

          case 5:

            // Find the selected campaign
            selectedCampaign = user.campaigns.find(function (campaign) {
              return campaign.id === campaignId;
            });

            if (selectedCampaign) {
              _context3.next = 9;
              break;
            }

            console.warn('Selected campaign not found:', campaignId);
            return _context3.abrupt('return');

          case 9:

            // Update devices and fields in store
            devices = selectedCampaign.devices || [];
            fields = selectedCampaign.fields || [];
            users = selectedCampaign.users || [];


            __WEBPACK_IMPORTED_MODULE_33__store__["a" /* store */].commit('setDevices', devices);
            __WEBPACK_IMPORTED_MODULE_33__store__["a" /* store */].commit('setFields', fields);
            __WEBPACK_IMPORTED_MODULE_33__store__["a" /* store */].commit('setUsers', users);

            // Load crops for the new fields

            if (!(fields.length > 0)) {
              _context3.next = 23;
              break;
            }

            _context3.next = 18;
            return __WEBPACK_IMPORTED_MODULE_32__plugins_firebase__["a" /* firestore */];

          case 18:
            db = _context3.sent;
            _context3.next = 21;
            return getCropsForFields(fields, db);

          case 21:
            crops = _context3.sent;

            __WEBPACK_IMPORTED_MODULE_33__store__["a" /* store */].commit('setCrops', crops);

          case 23:
            _context3.next = 29;
            break;

          case 25:
            _context3.prev = 25;
            _context3.t0 = _context3['catch'](0);

            console.error('Error loading campaign data:', _context3.t0);
            throw _context3.t0;

          case 29:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, this, [[0, 25]]);
  }));

  return function loadCampaignDataToStore(_x14) {
    return _ref7.apply(this, arguments);
  };
}();

function ddMMyyyyToJsDate(date) {
  var _date$split = date.split('/'),
      _date$split2 = __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_slicedToArray___default()(_date$split, 3),
      day = _date$split2[0],
      month = _date$split2[1],
      year = _date$split2[2];

  return new Date(year, month - 1, day);
}

var getSatisfactionSurveyConstants = function () {
  var _ref8 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee4() {
    var db, satisfactionSurveyConstants;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (!__WEBPACK_IMPORTED_MODULE_23_lodash_isEmpty___default()(__WEBPACK_IMPORTED_MODULE_14_lodash_get___default()(__WEBPACK_IMPORTED_MODULE_33__store__["a" /* store */], 'getters.satisfactionSurveyConstants', {}))) {
              _context4.next = 8;
              break;
            }

            _context4.next = 3;
            return __WEBPACK_IMPORTED_MODULE_32__plugins_firebase__["a" /* firestore */];

          case 3:
            db = _context4.sent;
            _context4.next = 6;
            return db.collection('app/v1/constants').doc('satisfactionSurvey').get();

          case 6:
            satisfactionSurveyConstants = _context4.sent;

            __WEBPACK_IMPORTED_MODULE_33__store__["a" /* store */].commit('setSatisfactionSurveyConstants', satisfactionSurveyConstants.data() || {});

          case 8:
            return _context4.abrupt('return', __WEBPACK_IMPORTED_MODULE_14_lodash_get___default()(__WEBPACK_IMPORTED_MODULE_33__store__["a" /* store */], 'getters.satisfactionSurveyConstants', {}));

          case 9:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, this);
  }));

  return function getSatisfactionSurveyConstants() {
    return _ref8.apply(this, arguments);
  };
}();

/**
 * Calculates the percentage of correct outlets configuration for an audit.
 *
 * @param {Object} auditData - The audit data object containing the spans and outlets.
 * @returns {Object} - The percentage of correct outlets configuration, the total number of outlets, and the number of correct outlets.
 */
function getOutletsConfigurationAnalysis(auditData) {
  var total = 0;
  var correct = 0;

  var outletsWithoutRegulator = [];
  var sprinklersWithoutNozzle = [];
  var sprinklersWithoutPad = [];

  if (auditData.spans && auditData.spans.length > 0) {
    auditData.spans.forEach(function (span) {
      if (span.outlets && span.outlets.length > 0) {
        span.outlets.forEach(function (outlet) {
          if (!outlet.type || outlet.type.id !== __WEBPACK_IMPORTED_MODULE_34__constants_const__["e" /* AUDITS */].OUTLET_TYPES.OUTLET.ID) {
            // If an outlet is plugged, it's not considered to calculate the percentage
            return;
          }
          if (outlet.sprinkler && outlet.sprinkler.nozzle && outlet.sprinkler.pad && outlet.regulator) {
            correct++;
          } else {
            if (!outlet.regulator) {
              outletsWithoutRegulator.push({
                outletNumber: outlet.number,
                spanNumber: span.number
              });
            }

            if (outlet.sprinkler && ![__WEBPACK_IMPORTED_MODULE_34__constants_const__["e" /* AUDITS */].SPRINKLER_TYPES.WITHOUT_SPRINKLER, __WEBPACK_IMPORTED_MODULE_34__constants_const__["e" /* AUDITS */].SPRINKLER_TYPES.PLUG].includes(__WEBPACK_IMPORTED_MODULE_14_lodash_get___default()(outlet, 'sprinkler.sprinklerType.id', '')) && (!outlet.sprinkler.nozzle || outlet.sprinkler.nozzle.id === __WEBPACK_IMPORTED_MODULE_34__constants_const__["e" /* AUDITS */].NOZZLE.NULL)) {
              sprinklersWithoutNozzle.push({
                outletNumber: outlet.number,
                spanNumber: span.number
              });
            }

            if (outlet.sprinkler && ![__WEBPACK_IMPORTED_MODULE_34__constants_const__["e" /* AUDITS */].SPRINKLER_TYPES.WITHOUT_SPRINKLER, __WEBPACK_IMPORTED_MODULE_34__constants_const__["e" /* AUDITS */].SPRINKLER_TYPES.PLUG].includes(__WEBPACK_IMPORTED_MODULE_14_lodash_get___default()(outlet, 'sprinkler.sprinklerType.id', '')) && !outlet.sprinkler.pad) {
              sprinklersWithoutPad.push({
                outletNumber: outlet.number,
                spanNumber: span.number
              });
            }
          }
          total++;
        });
      }
    });
  }

  return {
    percentage: total > 0 ? correct / total * 100 : 0,
    total: total,
    correct: correct,
    outletsWithoutRegulator: outletsWithoutRegulator.sort(function (a, b) {
      return a.outletNumber - b.outletNumber;
    }),
    sprinklersWithoutNozzle: sprinklersWithoutNozzle.sort(function (a, b) {
      return a.outletNumber - b.outletNumber;
    }),
    sprinklersWithoutPad: sprinklersWithoutPad.sort(function (a, b) {
      return a.outletNumber - b.outletNumber;
    })
  };
}

function getOutletsReportData(auditData) {
  // Extract all outlets from spans using lodash
  var allOutlets = __WEBPACK_IMPORTED_MODULE_22_lodash_flatMap___default()(__WEBPACK_IMPORTED_MODULE_14_lodash_get___default()(auditData, 'spans', []), 'outlets').filter(function (outlet) {
    return outlet.type && outlet.type.id === __WEBPACK_IMPORTED_MODULE_34__constants_const__["e" /* AUDITS */].OUTLET_TYPES.OUTLET.ID;
  }); // Filter out plugged outlets

  // Filter outlets with valid regulator data and create regulator keys
  var regulatorKeys = allOutlets.filter(function (outlet) {
    return __WEBPACK_IMPORTED_MODULE_14_lodash_get___default()(outlet, 'regulator.regulatorType.model');
  }).map(function (outlet) {
    var brand = __WEBPACK_IMPORTED_MODULE_14_lodash_get___default()(outlet, 'regulator.regulatorType.brand', '');
    var model = __WEBPACK_IMPORTED_MODULE_14_lodash_get___default()(outlet, 'regulator.regulatorType.model', '');
    var pressureName = __WEBPACK_IMPORTED_MODULE_14_lodash_get___default()(outlet, 'regulator.pressure.name', '');
    return (brand + ' ' + model + ' ' + pressureName + ' PSI').trim();
  }).filter(function (key) {
    return key;
  }); // Remove empty keys

  // Count occurrences using lodash
  var regulatorModels = regulatorKeys.reduce(function (acc, key) {
    acc[key] = (acc[key] || 0) + 1;
    return acc;
  }, {});

  // Filter outlets with valid sprinkler data and create sprinkler keys
  var sprinklerKeys = allOutlets.filter(function (outlet) {
    return __WEBPACK_IMPORTED_MODULE_14_lodash_get___default()(outlet, 'sprinkler.sprinklerType.model') && ![__WEBPACK_IMPORTED_MODULE_34__constants_const__["e" /* AUDITS */].SPRINKLER_TYPES.WITHOUT_SPRINKLER, __WEBPACK_IMPORTED_MODULE_34__constants_const__["e" /* AUDITS */].SPRINKLER_TYPES.PLUG].includes(__WEBPACK_IMPORTED_MODULE_14_lodash_get___default()(outlet, 'sprinkler.sprinklerType.id', ''));
  }).map(function (outlet) {
    var brand = __WEBPACK_IMPORTED_MODULE_14_lodash_get___default()(outlet, 'sprinkler.sprinklerType.brand', '');
    var model = __WEBPACK_IMPORTED_MODULE_14_lodash_get___default()(outlet, 'sprinkler.sprinklerType.model', '');
    return (brand + ' ' + model).trim();
  }).filter(function (key) {
    return key;
  }); // Remove empty keys

  // Count occurrences using lodash
  var sprinklerModels = sprinklerKeys.reduce(function (acc, key) {
    acc[key] = (acc[key] || 0) + 1;
    return acc;
  }, {});

  var sprinklersWithoutPad = allOutlets.filter(function (outlet) {
    return outlet.sprinkler && ![__WEBPACK_IMPORTED_MODULE_34__constants_const__["e" /* AUDITS */].SPRINKLER_TYPES.WITHOUT_SPRINKLER, __WEBPACK_IMPORTED_MODULE_34__constants_const__["e" /* AUDITS */].SPRINKLER_TYPES.PLUG].includes(__WEBPACK_IMPORTED_MODULE_14_lodash_get___default()(outlet, 'sprinkler.sprinklerType.id', '')) && !outlet.sprinkler.pad;
  }).map(function (outlet) {
    return {
      outletNumber: outlet.number,
      spanNumber: outlet.spanNumber
    };
  }).sort(function (a, b) {
    return a.outletNumber - b.outletNumber;
  });

  // Filter outlets with valid sprinkler data and pad data and create pad keys
  var padKeys = allOutlets.filter(function (outlet) {
    return __WEBPACK_IMPORTED_MODULE_14_lodash_get___default()(outlet, 'sprinkler.pad');
  }).map(function (outlet) {
    var brand = __WEBPACK_IMPORTED_MODULE_14_lodash_get___default()(outlet, 'sprinkler.pad.brand', '');
    var model = __WEBPACK_IMPORTED_MODULE_14_lodash_get___default()(outlet, 'sprinkler.pad.model', '');
    return (brand + ' ' + model).trim();
  }).filter(function (key) {
    return key;
  }); // Remove empty keys

  // Count occurrences using lodash
  var padModels = padKeys.reduce(function (acc, key) {
    acc[key] = (acc[key] || 0) + 1;
    return acc;
  }, {});

  var outletsWithoutWeight = allOutlets.filter(function (outlet) {
    return !outlet.weight;
  }).map(function (outlet) {
    return {
      outletNumber: outlet.number,
      spanNumber: outlet.span.number
    };
  }).sort(function (a, b) {
    return a.outletNumber - b.outletNumber;
  });

  // Extract all tyre sizes from spans using lodash
  var tyreSizes = __WEBPACK_IMPORTED_MODULE_24_lodash_uniq___default()(__WEBPACK_IMPORTED_MODULE_22_lodash_flatMap___default()(__WEBPACK_IMPORTED_MODULE_14_lodash_get___default()(auditData, 'spans', []), function (span) {
    return __WEBPACK_IMPORTED_MODULE_14_lodash_get___default()(span, 'tower.tyres', []);
  }).filter(function (tyre) {
    return __WEBPACK_IMPORTED_MODULE_14_lodash_get___default()(tyre, 'size.name');
  }).map(function (tyre) {
    return __WEBPACK_IMPORTED_MODULE_14_lodash_get___default()(tyre, 'size.name');
  }));

  var maxAccLarge = __WEBPACK_IMPORTED_MODULE_26_lodash_max___default()(__WEBPACK_IMPORTED_MODULE_14_lodash_get___default()(auditData, 'spans', []).map(function (span) {
    return parseFloat(__WEBPACK_IMPORTED_MODULE_14_lodash_get___default()(span, 'calculatedData.accLarge', 0));
  })) || 0;

  var maxEndSystemRadius = __WEBPACK_IMPORTED_MODULE_26_lodash_max___default()(__WEBPACK_IMPORTED_MODULE_14_lodash_get___default()(auditData, 'endSystems', []).map(function (endSystem) {
    return parseFloat(__WEBPACK_IMPORTED_MODULE_14_lodash_get___default()(endSystem, 'radius', 0));
  })) || 0;

  var theoreticalIrrigationTotalLength = maxAccLarge + maxEndSystemRadius;

  return {
    regulatorModels: regulatorModels,
    sprinklerModels: sprinklerModels,
    sprinklersWithoutPad: sprinklersWithoutPad,
    padModels: padModels,
    outletsWithoutWeight: outletsWithoutWeight,
    allOutletsCount: allOutlets.length,
    tyreSizes: tyreSizes,
    theoreticalIrrigationTotalLength: theoreticalIrrigationTotalLength,
    endsOfSystemData: auditData.endSystems.filter(function (outlet) {
      return outlet.outletType && outlet.outletType.id === __WEBPACK_IMPORTED_MODULE_34__constants_const__["e" /* AUDITS */].OUTLET_TYPES.CANNON.ID || outlet.outletType.id === __WEBPACK_IMPORTED_MODULE_34__constants_const__["e" /* AUDITS */].OUTLET_TYPES.END_OF_PIVOT_SPRINKLER.ID;
    })
  };
}

function formatNumberHelper(num) {
  var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  // Convert to number if it's a string
  var number = parseFloat(num);

  // Check if it's a valid number
  if (isNaN(number)) {
    return '-';
  }

  // Check if it's an integer (no decimal part)
  if (number % 1 === 0) {
    return number.toString();
  }

  // Otherwise, show with specified decimals
  var truncatedNumber = Math.round(number * Math.pow(10, decimals)) / Math.pow(10, decimals);

  // Check if all decimals (up to the specified amount) are 0
  // Use a tolerance based on the decimal precision
  var integerPart = Math.floor(truncatedNumber);
  var tolerance = Math.pow(10, -decimals) / 2;
  var hasNonZeroDecimals = Math.abs(truncatedNumber - integerPart) >= tolerance;

  // If all decimals are 0 (within the specified precision), show as integer
  if (!hasNonZeroDecimals) {
    return integerPart.toString();
  }

  // Otherwise, format with the specified number of decimals
  // Remove trailing zeros
  return truncatedNumber.toFixed(decimals).replace(/\.?0+$/, '');
}

/**
 * Maps target points to their nearest sample points based on geographical distance
 * and assigns elevation data from the nearest sample to each target point.
 *
 * @param {Array<Object>} targetPoints - Array of target points to map elevation data to
 * @param {number} targetPoints[].lat - Latitude of the target point
 * @param {number} targetPoints[].lng - Longitude of the target point
 * @param {Array<Object>} samples - Array of sample points containing elevation data
 * @param {Object} samples[].location - Location object of the sample point
 * @param {number} samples[].location.lat - Latitude of the sample point
 * @param {number} samples[].location.lng - Longitude of the sample point
 * @param {number} samples[].elevation - Elevation value of the sample point
 *
 * @returns {Array<Object>} Array of target points with additional elevation data:
 * @returns {number} returns[].lat - Original latitude of the target point
 * @returns {number} returns[].lng - Original longitude of the target point
 * @returns {number|null} returns[].elevation - Elevation from the nearest sample point, or null if no samples
 * @returns {Object|null} returns[].nearest - The nearest sample point object, or null if no samples
 * @returns {number|null} returns[].distance - Distance to the nearest sample point in meters, or null if no samples
 */
function mapAltimetryByNearest(targetPoints, samples) {
  if (!Array.isArray(targetPoints) || !Array.isArray(samples)) return [];
  if (samples.length === 0) {
    return targetPoints.map(function (p) {
      return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends___default()({}, p, { elevation: null, nearest: null, distance: null });
    });
  }

  var keyOf = function keyOf(p) {
    return p.lat + ',' + p.lng;
  };
  var resolveOne = function resolveOne(p) {
    // Find the nearest sample
    var nearest = __WEBPACK_IMPORTED_MODULE_27_lodash_minBy___default()(samples, function (s) {
      return __WEBPACK_IMPORTED_MODULE_12_geolib_es_getDistance___default()({ latitude: p.lat, longitude: p.lng }, { latitude: s.location.lat, longitude: s.location.lng });
    });
    var distance = __WEBPACK_IMPORTED_MODULE_12_geolib_es_getDistance___default()({ latitude: p.lat, longitude: p.lng }, { latitude: nearest.location.lat, longitude: nearest.location.lng });
    return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends___default()({}, p, { elevation: nearest.elevation, nearest: nearest, distance: distance });
  };

  var memoResolveOne = __WEBPACK_IMPORTED_MODULE_28_lodash_memoize___default()(resolveOne, keyOf);
  return targetPoints.map(memoResolveOne);
}

function isObservationsDocumentEmpty(auditData) {
  if (!auditData.observations || !auditData.observations.document || !Array.isArray(auditData.observations.document)) {
    return true;
  }

  // Recursive function to find text content in any node
  var hasTextContent = function hasTextContent(node) {
    if (!node) {
      return false;
    }

    // Check if node has text property with non-empty content
    if (node.text !== undefined && node.text !== null) {
      var trimmedText = String(node.text).trim();
      if (trimmedText !== '') {
        return true;
      }
    }

    // Check if node has props with content (like images)
    if (node.props) {
      // Check for image blocks or other components with content
      if (node.type === 'component-block' && node.props.asset) {
        return true;
      }
    }

    // Recursively check children
    if (node.children && Array.isArray(node.children)) {
      return node.children.some(function (child) {
        return hasTextContent(child);
      });
    }

    return false;
  };

  // Check all document items for content
  return !auditData.observations.document.some(function (item) {
    // Skip empty paragraphs
    if (item.type === 'paragraph') {
      return hasTextContent(item);
    }
    // Check other types (lists, component-blocks, etc.)
    return hasTextContent(item);
  });
}

function parseCrop(cropId, cropData) {
  var startDate = cropData.startDate ? typeof cropData.startDate === 'string' ? new Date(cropData.startDate) : cropData.startDate.toDate() : undefined;

  var cropDataObj = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends___default()({}, cropData, {
    id: cropId,
    field: cropData.field ? cropData.field.id : null,
    devices: cropData.devices ? cropData.devices.map(function (device) {
      return device.id;
    }) : [],
    type: cropData.type ? cropData.type.split('|') : [],
    sowingDate: startDate ? startDate.getDate().toString().padStart(2, '0') + '/' + (startDate.getMonth() + 1).toString().padStart(2, '0') + '/' + startDate.getFullYear() : '',
    campaign: cropData.campaign ? cropData.campaign.id : null,
    organization: cropData.organization ? cropData.organization.id : null,
    clonedFrom: cropData.clonedFrom ? cropData.clonedFrom.map(function (cloned) {
      return cloned.id;
    }) : []
  });

  if (cropDataObj.location) {
    cropDataObj.location = parseFirestoreLocation(cropDataObj.location);
  }
  if (cropDataObj.startPoint) {
    cropDataObj.startPoint = parseFirestoreLocation(cropDataObj.startPoint);
  }
  if (cropDataObj.endPoint) {
    cropDataObj.endPoint = parseFirestoreLocation(cropDataObj.endPoint);
  }
  if (cropDataObj.points) {
    cropDataObj.points = cropDataObj.points.map(function (p) {
      if (!p.coordinatesString) {
        p.coordinatesString = p.latitude + ', ' + p.longitude;
      }
      return p;
    });
  }

  return cropDataObj;
}

function parseStringToCoordinates(input) {
  if (typeof input !== 'string') {
    return { valid: false, latitude: null, longitude: null };
  }

  var coords = isLikelyDMS(input) ? parseDMSLatLonString(input) : parseDecimalLatLonString(input);

  return coords && __WEBPACK_IMPORTED_MODULE_13_geolib_es_isValidCoordinate___default()(coords) ? coords : null;
}

/**
 * Returns only the fields that changed between two objects (recursive for nested objects and arrays)
 * Preserves the original object structure using lodash set
 * @param {Object} oldData - Previous data
 * @param {Object} newData - New data
 * @param {string} prefix - Prefix for nested keys (used internally for recursion)
 * @returns {Object} - Changed fields with new values (preserving object structure)
 */
function getDataChanges() {
  var oldData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var newData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var prefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  var changes = {};

  // Check new/modified fields
  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(newData).forEach(function (key) {
    var oldValue = oldData[key];
    var newValue = newData[key];
    var fullKey = prefix ? prefix + '.' + key : key;

    // Skip if values are equal
    if (areValuesEqual(oldValue, newValue)) return;

    // If both are arrays, compare element by element
    if (Array.isArray(oldValue) && Array.isArray(newValue)) {
      // If lengths differ, store the whole array
      if (oldValue.length !== newValue.length) {
        __WEBPACK_IMPORTED_MODULE_30_lodash_set___default()(changes, fullKey, newValue);
      } else {
        // Compare each element
        newValue.forEach(function (item, index) {
          if (!areValuesEqual(oldValue[index], item)) {
            // If both elements are plain objects, recurse
            if (__WEBPACK_IMPORTED_MODULE_18_lodash_isPlainObject___default()(oldValue[index]) && __WEBPACK_IMPORTED_MODULE_18_lodash_isPlainObject___default()(item)) {
              var nestedChanges = getDataChanges(oldValue[index], item, fullKey + '[' + index + ']');
              // Merge nested changes with changes
              __WEBPACK_IMPORTED_MODULE_31_lodash_merge___default()(changes, nestedChanges);
            } else {
              __WEBPACK_IMPORTED_MODULE_30_lodash_set___default()(changes, fullKey + '[' + index + ']', item);
            }
          }
        });

        // Ensure there is not undefined array items
        var arrayChanges = __WEBPACK_IMPORTED_MODULE_14_lodash_get___default()(changes, fullKey);
        if (arrayChanges) {
          __WEBPACK_IMPORTED_MODULE_30_lodash_set___default()(changes, fullKey, [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(arrayChanges)).map(function (item) {
            return item === undefined ? null : item;
          }));
        }
      }
    } else if (__WEBPACK_IMPORTED_MODULE_18_lodash_isPlainObject___default()(oldValue) && __WEBPACK_IMPORTED_MODULE_18_lodash_isPlainObject___default()(newValue)) {
      // If both are plain objects, recurse
      var nestedChanges = getDataChanges(oldValue, newValue, fullKey);
      // Merge nested changes with changes
      __WEBPACK_IMPORTED_MODULE_31_lodash_merge___default()(changes, nestedChanges);
    } else {
      // Different values or different types
      __WEBPACK_IMPORTED_MODULE_30_lodash_set___default()(changes, fullKey, newValue);
    }
  });

  return changes;
}

/**
 * Compares two values handling Firestore-specific types
 * @param {*} v1 - First value
 * @param {*} v2 - Second value
 * @returns {boolean} - True if equal
 */
function areValuesEqual(v1, v2) {
  var getTypeName = function getTypeName(val) {
    return val && val.constructor && val.constructor.name;
  };
  // Handle Firestore DocumentReference
  if (getTypeName(v1) === 'DocumentReference' && getTypeName(v2) === 'DocumentReference') {
    return v1.path === v2.path;
  }
  // Handle Firestore Timestamp
  if (getTypeName(v1) === 'Timestamp' && getTypeName(v2) === 'Timestamp') {
    return v1.getDate().getTime() === v2.getDate().getTime();
  }
  // Handle Date objects
  if (v1 instanceof Date && v2 instanceof Date) {
    return v1.getTime() === v2.getTime();
  }
  // Use lodash isEqual for everything else
  return __WEBPACK_IMPORTED_MODULE_29_lodash_isEqual___default()(v1, v2);
}

/***/ }),

/***/ 308:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/farmhand.739737b.png";

/***/ }),

/***/ 309:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fieldman.612af73.png";

/***/ }),

/***/ 310:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/manager.5799d88.png";

/***/ }),

/***/ 361:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export GC_USER_ID */
/* unused harmony export GC_AUTH_TOKEN */
/* unused harmony export LINKS_PER_PAGE */
/* unused harmony export __SUBSCRIPTION_API_ENDPOINT__ */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GoogleMapsKey; });
/* unused harmony export AppLink */
var GC_USER_ID = 'graphcool-user-id';
var GC_AUTH_TOKEN = 'graphcool-auth-token';
var LINKS_PER_PAGE = 5;
var __SUBSCRIPTION_API_ENDPOINT__ = 'http://admin.ponceag.com/admin/api';
var GoogleMapsKey = 'AIzaSyDEi2wgWpANAY4sttulylcvbtSfQ1Oxw88';
var AppLink = 'http://test.ponceag.com';

/***/ }),

/***/ 362:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_register__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_apollo__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_check_connection__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_i18n__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetify__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuetify_dist_vuetify_min_css__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants_config__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants_filters__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_flag_icon__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_logrocket__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_logrocket___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_logrocket__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_mixpanel_browser__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lib_posthog_client__ = __webpack_require__(180);
var App = function App() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 586));
};

















__WEBPACK_IMPORTED_MODULE_11_logrocket___default.a.init('');
__WEBPACK_IMPORTED_MODULE_12_mixpanel_browser__["a" /* default */].init('530c5db4921cde2f716cc15e87a5e890');
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib_posthog_client__["a" /* initPosthog */])();

var Vue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_register__["a" /* VueRegister */])();
var apolloProvider = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_apollo__["a" /* Apollo */])();
/* eslint-disable no-new */

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__constants_filters__["a" /* default */])(Vue);
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__constants_config__["a" /* default */])(Vue);

Vue.use(__WEBPACK_IMPORTED_MODULE_10_vue_flag_icon__["a" /* default */]);
Vue.use(__WEBPACK_IMPORTED_MODULE_6_vuetify___default.a);

new Vue({
  el: '#app',
  vuetify: new __WEBPACK_IMPORTED_MODULE_6_vuetify___default.a({}),
  router: __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */],
  apolloProvider: apolloProvider,
  i18n: __WEBPACK_IMPORTED_MODULE_5__lib_i18n__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* store */],
  template: '<App/>',
  components: { App: App },
  data: {
    config: __WEBPACK_IMPORTED_MODULE_8__constants_config__["a" /* default */],
    filters: __WEBPACK_IMPORTED_MODULE_9__constants_filters__["a" /* default */]
  },
  created: function created() {}
});

/***/ }),

/***/ 363:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_helpers__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_i18n__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isEmpty__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isEmpty__);






/**
 * Route guard: public routes, sign-in redirect, role-based access, and bootstrap via /loading when the app is not ready.
 */
/* harmony default export */ __webpack_exports__["a"] = (function (to, from, next) {
  var token = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* store */].getters.userAuth;
  var impersonated = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* store */].getters.impersonatedUserId;
  var user = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* store */].getters.user;
  var publicRoute = ['Welcome'].includes(to.name);
  var routeInit = ['/signin'].includes(to.fullPath);
  var crudRoutes = ['/organizationHome', '/addDevice', '/addUser', '/editUser', '/addCrop', '/addField', '/manageField'];
  var reportRoutes = ['/reports'];
  var auditRoutes = ['/audits'];
  document.title = routeInit ? 'PONCE | ' + __WEBPACK_IMPORTED_MODULE_3__lib_i18n__["a" /* default */].t('WebTitles.login') : to.fullPath === '/reports' ? 'PONCE | ' + __WEBPACK_IMPORTED_MODULE_3__lib_i18n__["a" /* default */].t('WebTitles.reports') : to.fullPath.includes('/loading') ? 'PONCE' : 'PONCE | ' + __WEBPACK_IMPORTED_MODULE_3__lib_i18n__["a" /* default */].t('WebTitles.dashboard');

  // Short-link flow: skip strict checks so /loading can resolve the target URL
  if (to.fullPath.includes('/r/') || to.query.to && to.query.to.includes('/r/')) {
    return next();
  }

  if (publicRoute) {
    next();
  } else if (routeInit) {
    // Signed-in users hitting /signin go to loading to load profile and pick a home route
    token || impersonated ? next('/loading') : next();
  } else {
    if (token || impersonated) {
      // --- Bootstrap: until appReady, force /loading (with intended path in query) except for the checks below ---
      if (to.path !== '/loading' && from.path !== '/loading' && !__WEBPACK_IMPORTED_MODULE_1__store__["a" /* store */].getters.appReady) {
        // CRUD org routes: need edit permission; otherwise send user to their default area (reports or audits)
        if (!__WEBPACK_IMPORTED_MODULE_4_lodash_isEmpty___default()(user) && crudRoutes.includes(to.fullPath) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_helpers__["h" /* isAuthToEdit */])(user, impersonated)) {
          if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_helpers__["i" /* isAuthToReports */])(user, impersonated)) {
            next('/reports');
          } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_helpers__["j" /* isAuthToAudits */])(user, impersonated)) {
            next('/audits');
          }
          return;
        }
        // Reports: need reports permission; else org home or audits fallback
        if (!__WEBPACK_IMPORTED_MODULE_4_lodash_isEmpty___default()(user) && reportRoutes.includes(to.fullPath) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_helpers__["i" /* isAuthToReports */])(user, impersonated)) {
          if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_helpers__["h" /* isAuthToEdit */])(user, impersonated)) {
            next('/organizationHome');
          } else {
            next('/audits');
          }
          return;
        }
        // Audits home: need audits permission; else org home or reports fallback
        if (!__WEBPACK_IMPORTED_MODULE_4_lodash_isEmpty___default()(user) && auditRoutes.includes(to.fullPath) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_helpers__["j" /* isAuthToAudits */])(user, impersonated)) {
          if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_helpers__["h" /* isAuthToEdit */])(user, impersonated)) {
            next('/reports');
          } else {
            next('/organizationHome');
          }
          return;
        }
        // Field survey setup entry: same audience as audits plus users linked via fieldSurveyIds
        if (!__WEBPACK_IMPORTED_MODULE_4_lodash_isEmpty___default()(user) && to.path.startsWith('/fieldSurveys/') && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_helpers__["K" /* isAuthToFieldSurveys */])(user, impersonated)) {
          if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_helpers__["h" /* isAuthToEdit */])(user, impersonated)) {
            next('/organizationHome');
          } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_helpers__["i" /* isAuthToReports */])(user, impersonated)) {
            next('/reports');
          } else {
            next('/audits');
          }
          return;
        }
        // Legacy add-* routes without going through loading: normalize to org home
        if (['AddDevice', 'AddField', 'AddCrop', 'EditUser', 'AddUser', 'ManageField'].includes(to.name)) {
          to = {
            path: '/organizationHome',
            query: {}
          };
        }
        // Defer to LoadingScreen + getUserData, then navigate to to.path
        next({ path: '/loading', query: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, to.query, { to: to.path }) });
      } else {
        next();
      }
    } else {
      next('/signin');
    }
  }
});

/***/ }),

/***/ 364:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    organizations: [],
    devices: {}
  },
  mutations: {
    setOrganizations: function setOrganizations(state, payload) {
      state.organizations = payload;
    },
    setOrgDevices: function setOrgDevices(state, payload) {
      var newState = state.devices;
      newState[payload.orgId] = payload.devices;
      state.devices = newState;
    }
  },
  actions: {
    setOrganizations: function setOrganizations(_ref, payload) {
      var commit = _ref.commit;

      commit('setOrganizations', payload);
    },
    setOrgDevices: function setOrgDevices(_ref2, payload) {
      var commit = _ref2.commit;

      commit('setOrgDevices', payload);
    }
  },
  getters: {
    organizations: function organizations(state) {
      return state.organizations;
    },
    orgDevices: function orgDevices(state) {
      return state.devices;
    }
  }
});

/***/ }),

/***/ 365:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    language: '',
    timezone: ''
  },
  getters: {
    language: function language(state) {
      return state.language;
    },
    timezone: function timezone(state) {
      return state.timezone;
    }
  },
  mutations: {
    setLanguage: function setLanguage(state, language) {
      state.language = language;
    },
    setTimezone: function setTimezone(state, timezone) {
      state.timezone = timezone;
    }
  },
  actions: {
    setTimezone: function setTimezone(context, timezone) {
      context.commit('setTimezone', timezone);
    }
  }
});

/***/ }),

/***/ 366:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    step: 1,
    loading: false,
    error: null,
    isOnline: true,
    appReady: false,
    satisfactionSurveyConstants: {},
    devUsers: [],
    globalConstants: null,
    pendingCampaignOnboardingDialogShown: false,
    activeCampaign: null
  },
  mutations: {
    setLoading: function setLoading(state, payload) {
      state.loading = payload;
    },
    setError: function setError(state, payload) {
      state.error = payload;
    },
    clearError: function clearError(state) {
      state.error = null;
    },
    setIsOnline: function setIsOnline(state, payload) {
      state.isOnline = payload;
    },
    setAppReady: function setAppReady(state, payload) {
      state.appReady = payload;
    },
    setSatisfactionSurveyConstants: function setSatisfactionSurveyConstants(state, value) {
      state.satisfactionSurveyConstants = value;
    },
    setDevUsers: function setDevUsers(state, value) {
      state.devUsers = value;
    },
    setGlobalConstants: function setGlobalConstants(state, value) {
      state.globalConstants = value;
    },
    setPendingCampaignOnboardingDialogShown: function setPendingCampaignOnboardingDialogShown(state, value) {
      state.pendingCampaignOnboardingDialogShown = value;
    },
    setActiveCampaign: function setActiveCampaign(state, campaignId) {
      state.activeCampaign = campaignId;
    }
  },
  actions: {
    clearError: function clearError(_ref) {
      var commit = _ref.commit;

      commit('clearError');
    },
    setError: function setError(_ref2, payload) {
      var commit = _ref2.commit;

      commit('setError', payload);
    },
    setIsOnline: function setIsOnline(_ref3, payload) {
      var commit = _ref3.commit;

      commit('setIsOnline', payload);
    }
  },
  getters: {
    loading: function loading(state) {
      return state.loading;
    },
    error: function error(state) {
      return state.error;
    },
    step: function step(state) {
      return state.step;
    },
    isOnline: function isOnline(state) {
      return state.isOnline;
    },
    appReady: function appReady(state) {
      return state.appReady;
    },
    satisfactionSurveyConstants: function satisfactionSurveyConstants(state) {
      return state.satisfactionSurveyConstants;
    },
    devUsers: function devUsers(state) {
      return state.devUsers;
    },
    globalConstants: function globalConstants(state) {
      return state.globalConstants;
    },
    pendingCampaignOnboardingDialogShown: function pendingCampaignOnboardingDialogShown(state) {
      return state.pendingCampaignOnboardingDialogShown;
    },
    activeCampaign: function activeCampaign(state) {
      return state.activeCampaign;
    }
  }
});

/***/ }),

/***/ 367:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);



var getInitialState = function getInitialState() {
  return {
    user: null,
    userAuth: null,
    userRoles: null,
    impersonatedUserId: null,
    userOrganization: {
      id: '',
      name: ''
    },
    selectedOrganization: {
      id: '',
      name: '',
      hubspotId: ''
    },
    userPermissions: {},
    organizationUsers: [],
    users: [],
    devices: [],
    crops: [],
    fields: [],
    organizationDevices: [],
    availableCampaigns: []
  };
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, getInitialState(), {
    timeRange: {
      from: new Date().setDate(new Date().getDate() - 7),
      to: new Date().getTime(),
      type: 1
    }
  }),
  mutations: {
    setUser: function setUser(state, payload) {
      state.user = payload;
    },
    setUserAuth: function setUserAuth(state, user) {
      state.userAuth = user;
    },
    setTimeRange: function setTimeRange(state, payload) {
      state.timeRange.from = payload.from;
      state.timeRange.to = payload.to;
      state.timeRange.type = payload.type;
    },
    setUserRoles: function setUserRoles(state, payload) {
      state.userRoles = payload;
    },
    setOrganization: function setOrganization(state, payload) {
      state.userOrganization = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, state.userOrganization, payload);
      state.selectedOrganization = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, state.selectedOrganization, payload);
    },
    setSelectedOrganization: function setSelectedOrganization(state, payload) {
      state.selectedOrganization = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, state.selectedOrganization, payload);
    },
    resetState: function resetState(state) {
      var s = getInitialState();
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(s).forEach(function (key) {
        state[key] = s[key];
      });
    },
    setUserPermissions: function setUserPermissions(state, payload) {
      state.userPermissions = payload;
    },
    setOrganizationUsers: function setOrganizationUsers(state, payload) {
      state.organizationUsers = payload;
    },
    setOrganizationFields: function setOrganizationFields(state, payload) {
      state.organizationFields = payload;
    },
    setUsers: function setUsers(state, payload) {
      state.users = payload;
    },
    setDevices: function setDevices(state, payload) {
      state.devices = payload;
    },
    setCrops: function setCrops(state, payload) {
      state.crops = payload;
    },
    setFields: function setFields(state, payload) {
      state.fields = payload;
    },
    setImpersonatedUserId: function setImpersonatedUserId(state, payload) {
      state.impersonatedUserId = payload;
    },
    setOrganizationDevices: function setOrganizationDevices(state, payload) {
      state.organizationDevices = payload;
    },
    updateCampaignUsers: function updateCampaignUsers(state, payload) {
      var campaignIndex = state.user.campaigns.findIndex(function (campaign) {
        return campaign.id === payload.campaignId;
      });
      if (campaignIndex !== -1) {
        var _state$user$campaigns;

        // Add processed users to the existing users array
        if (!state.user.campaigns[campaignIndex].users) {
          state.user.campaigns[campaignIndex].users = [];
        }
        (_state$user$campaigns = state.user.campaigns[campaignIndex].users).push.apply(_state$user$campaigns, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(payload.processedUsers));
      }
    },
    updateCampaign: function updateCampaign(state, payload) {
      var campaignIndex = state.user.campaigns.findIndex(function (campaign) {
        return campaign.id === payload.campaignId;
      });
      if (campaignIndex !== -1) {
        state.user.campaigns[campaignIndex] = payload.campaignData;
      }
    },
    setAvailableCampaigns: function setAvailableCampaigns(state, payload) {
      state.availableCampaigns = payload;
    }
  },
  actions: {
    signUserIn: function signUserIn(_ref, payload) {
      var commit = _ref.commit;

      commit('setUser', payload);
    },
    autoSignIn: function autoSignIn(context, payload) {
      context.commit('setUserAuth', payload);
    },
    resetPasswordWithEmail: function resetPasswordWithEmail(_ref2) {
      var commit = _ref2.commit;

      // const { email } = payload
      commit('setLoading', true);
      // Petition a graphql, concatenada con el siguiente then..
      // .then(
      //   () => {
      //     commit('setLoading', false)
      //     console.log('Email Sent')
      //   }
      // )
      // .catch(
      //   error => {
      //     commit('setLoading', false)
      //     commit('setError', error)
      //     console.log(error)
      //   }
      // )
    },
    logout: function logout(_ref3) {
      var commit = _ref3.commit;

      commit('resetState');
    },
    setTimeRange: function setTimeRange(_ref4, payload) {
      var commit = _ref4.commit;

      commit('setTimeRange', payload);
    },
    setUserRoles: function setUserRoles(_ref5, payload) {
      var commit = _ref5.commit;

      commit('setUserRoles', payload);
    },
    setOrganization: function setOrganization(_ref6, payload) {
      var commit = _ref6.commit;

      commit('setOrganization', payload);
    },
    setSelectedOrganization: function setSelectedOrganization(_ref7, payload) {
      var commit = _ref7.commit;

      commit('setSelectedOrganization', payload);
    },
    setUserPermissions: function setUserPermissions(_ref8, payload) {
      var commit = _ref8.commit;

      commit('setUserPermissions', payload);
    },
    updateCampaignUsers: function updateCampaignUsers(_ref9, payload) {
      var commit = _ref9.commit;

      commit('updateCampaignUsers', payload);
    }
  },
  getters: {
    user: function user(state) {
      return state.user;
    },
    userAuth: function userAuth(state) {
      return state.userAuth;
    },
    timeRange: function timeRange(state) {
      return state.timeRange;
    },
    userRoles: function userRoles(state) {
      return state.userRoles;
    },
    userOrganization: function userOrganization(state) {
      return state.userOrganization;
    },
    selectedOrganization: function selectedOrganization(state) {
      return state.selectedOrganization;
    },
    userPermissions: function userPermissions(state) {
      return state.userPermissions;
    },
    organizationUsers: function organizationUsers(state) {
      return state.organizationUsers;
    },
    organizationFields: function organizationFields(state) {
      return state.organizationFields;
    },
    users: function users(state) {
      return state.users;
    },
    devices: function devices(state) {
      return state.devices;
    },
    crops: function crops(state) {
      return state.crops;
    },
    fields: function fields(state) {
      return state.fields;
    },
    impersonatedUserId: function impersonatedUserId(state) {
      return state.impersonatedUserId;
    },

    getCampaign: function getCampaign(state) {
      return function (id) {
        return state.user.campaigns.find(function (campaign) {
          return campaign.id === id;
        });
      };
    },
    getCampaignFields: function getCampaignFields(state) {
      return function (campaignId) {
        if (!state.user || !state.user.campaigns) {
          return [];
        }
        var campaign = state.user.campaigns.find(function (campaign) {
          return campaign.id === campaignId;
        });
        if (!campaign || !campaign.fields) {
          return [];
        }
        return campaign.fields;
      };
    },
    organizationDevices: function organizationDevices(state) {
      return state.organizationDevices;
    },
    availableCampaigns: function availableCampaigns(state) {
      return state.availableCampaigns;
    },

    getUserById: function getUserById(state) {
      return function (userId) {
        return state.users.find(function (user) {
          return user.id === userId;
        });
      };
    }
  }
});

/***/ }),

/***/ 368:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'flag',
    props: {
        iso: { type: String, default: null },
        title: { type: String, default: null },
        squared: { type: Boolean, default: true }
    },
    computed: {
        flagIconClass: function flagIconClass() {
            return (!!this.squared ? 'flag-icon-squared ' : '') + 'flag-icon-' + this.iso.toLowerCase();
        }
    }
});

/***/ }),

/***/ 369:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(601)));

/***/ }),

/***/ 370:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(603)));

/***/ }),

/***/ 371:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(604)));

/***/ }),

/***/ 372:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(609)));

/***/ }),

/***/ 417:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 418:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 419:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 420:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 421:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 437:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__version__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__version___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__version__);
/* unused harmony reexport version */
/* unused harmony reexport versionInfo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__graphql__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__graphql__);
/* unused harmony reexport graphql */
/* unused harmony reexport graphqlSync */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__type__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__type___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__type__);
/* unused harmony reexport GraphQLSchema */
/* unused harmony reexport GraphQLDirective */
/* unused harmony reexport GraphQLScalarType */
/* unused harmony reexport GraphQLObjectType */
/* unused harmony reexport GraphQLInterfaceType */
/* unused harmony reexport GraphQLUnionType */
/* unused harmony reexport GraphQLEnumType */
/* unused harmony reexport GraphQLInputObjectType */
/* unused harmony reexport GraphQLList */
/* unused harmony reexport GraphQLNonNull */
/* unused harmony reexport specifiedScalarTypes */
/* unused harmony reexport GraphQLInt */
/* unused harmony reexport GraphQLFloat */
/* unused harmony reexport GraphQLString */
/* unused harmony reexport GraphQLBoolean */
/* unused harmony reexport GraphQLID */
/* unused harmony reexport specifiedDirectives */
/* unused harmony reexport GraphQLIncludeDirective */
/* unused harmony reexport GraphQLSkipDirective */
/* unused harmony reexport GraphQLDeprecatedDirective */
/* unused harmony reexport TypeKind */
/* unused harmony reexport DEFAULT_DEPRECATION_REASON */
/* unused harmony reexport introspectionTypes */
/* unused harmony reexport __Schema */
/* unused harmony reexport __Directive */
/* unused harmony reexport __DirectiveLocation */
/* unused harmony reexport __Type */
/* unused harmony reexport __Field */
/* unused harmony reexport __InputValue */
/* unused harmony reexport __EnumValue */
/* unused harmony reexport __TypeKind */
/* unused harmony reexport SchemaMetaFieldDef */
/* unused harmony reexport TypeMetaFieldDef */
/* unused harmony reexport TypeNameMetaFieldDef */
/* unused harmony reexport isSchema */
/* unused harmony reexport isDirective */
/* unused harmony reexport isType */
/* unused harmony reexport isScalarType */
/* unused harmony reexport isObjectType */
/* unused harmony reexport isInterfaceType */
/* unused harmony reexport isUnionType */
/* unused harmony reexport isEnumType */
/* unused harmony reexport isInputObjectType */
/* unused harmony reexport isListType */
/* unused harmony reexport isNonNullType */
/* unused harmony reexport isInputType */
/* unused harmony reexport isOutputType */
/* unused harmony reexport isLeafType */
/* unused harmony reexport isCompositeType */
/* unused harmony reexport isAbstractType */
/* unused harmony reexport isWrappingType */
/* unused harmony reexport isNullableType */
/* unused harmony reexport isNamedType */
/* unused harmony reexport isRequiredArgument */
/* unused harmony reexport isRequiredInputField */
/* unused harmony reexport isSpecifiedScalarType */
/* unused harmony reexport isIntrospectionType */
/* unused harmony reexport isSpecifiedDirective */
/* unused harmony reexport assertSchema */
/* unused harmony reexport assertDirective */
/* unused harmony reexport assertType */
/* unused harmony reexport assertScalarType */
/* unused harmony reexport assertObjectType */
/* unused harmony reexport assertInterfaceType */
/* unused harmony reexport assertUnionType */
/* unused harmony reexport assertEnumType */
/* unused harmony reexport assertInputObjectType */
/* unused harmony reexport assertListType */
/* unused harmony reexport assertNonNullType */
/* unused harmony reexport assertInputType */
/* unused harmony reexport assertOutputType */
/* unused harmony reexport assertLeafType */
/* unused harmony reexport assertCompositeType */
/* unused harmony reexport assertAbstractType */
/* unused harmony reexport assertWrappingType */
/* unused harmony reexport assertNullableType */
/* unused harmony reexport assertNamedType */
/* unused harmony reexport getNullableType */
/* unused harmony reexport getNamedType */
/* unused harmony reexport validateSchema */
/* unused harmony reexport assertValidSchema */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__language__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__language___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__language__);
/* unused harmony reexport Source */
/* unused harmony reexport getLocation */
/* unused harmony reexport printLocation */
/* unused harmony reexport printSourceLocation */
/* unused harmony reexport createLexer */
/* unused harmony reexport TokenKind */
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_3__language__, "parse")) __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__language__["parse"]; });
/* unused harmony reexport parseValue */
/* unused harmony reexport parseType */
/* unused harmony reexport print */
/* unused harmony reexport visit */
/* unused harmony reexport visitInParallel */
/* unused harmony reexport visitWithTypeInfo */
/* unused harmony reexport getVisitFn */
/* unused harmony reexport BREAK */
/* unused harmony reexport Kind */
/* unused harmony reexport DirectiveLocation */
/* unused harmony reexport isDefinitionNode */
/* unused harmony reexport isExecutableDefinitionNode */
/* unused harmony reexport isSelectionNode */
/* unused harmony reexport isValueNode */
/* unused harmony reexport isTypeNode */
/* unused harmony reexport isTypeSystemDefinitionNode */
/* unused harmony reexport isTypeDefinitionNode */
/* unused harmony reexport isTypeSystemExtensionNode */
/* unused harmony reexport isTypeExtensionNode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__execution__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__execution___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__execution__);
/* unused harmony reexport execute */
/* unused harmony reexport defaultFieldResolver */
/* unused harmony reexport defaultTypeResolver */
/* unused harmony reexport responsePathAsArray */
/* unused harmony reexport getDirectiveValues */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__subscription__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__subscription___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__subscription__);
/* unused harmony reexport subscribe */
/* unused harmony reexport createSourceEventStream */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__validation__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__validation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__validation__);
/* unused harmony reexport validate */
/* unused harmony reexport ValidationContext */
/* unused harmony reexport specifiedRules */
/* unused harmony reexport ExecutableDefinitionsRule */
/* unused harmony reexport FieldsOnCorrectTypeRule */
/* unused harmony reexport FragmentsOnCompositeTypesRule */
/* unused harmony reexport KnownArgumentNamesRule */
/* unused harmony reexport KnownDirectivesRule */
/* unused harmony reexport KnownFragmentNamesRule */
/* unused harmony reexport KnownTypeNamesRule */
/* unused harmony reexport LoneAnonymousOperationRule */
/* unused harmony reexport NoFragmentCyclesRule */
/* unused harmony reexport NoUndefinedVariablesRule */
/* unused harmony reexport NoUnusedFragmentsRule */
/* unused harmony reexport NoUnusedVariablesRule */
/* unused harmony reexport OverlappingFieldsCanBeMergedRule */
/* unused harmony reexport PossibleFragmentSpreadsRule */
/* unused harmony reexport ProvidedRequiredArgumentsRule */
/* unused harmony reexport ScalarLeafsRule */
/* unused harmony reexport SingleFieldSubscriptionsRule */
/* unused harmony reexport UniqueArgumentNamesRule */
/* unused harmony reexport UniqueDirectivesPerLocationRule */
/* unused harmony reexport UniqueFragmentNamesRule */
/* unused harmony reexport UniqueInputFieldNamesRule */
/* unused harmony reexport UniqueOperationNamesRule */
/* unused harmony reexport UniqueVariableNamesRule */
/* unused harmony reexport ValuesOfCorrectTypeRule */
/* unused harmony reexport VariablesAreInputTypesRule */
/* unused harmony reexport VariablesInAllowedPositionRule */
/* unused harmony reexport LoneSchemaDefinitionRule */
/* unused harmony reexport UniqueOperationTypesRule */
/* unused harmony reexport UniqueTypeNamesRule */
/* unused harmony reexport UniqueEnumValueNamesRule */
/* unused harmony reexport UniqueFieldDefinitionNamesRule */
/* unused harmony reexport UniqueDirectiveNamesRule */
/* unused harmony reexport PossibleTypeExtensionsRule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__error__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__error___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__error__);
/* unused harmony reexport GraphQLError */
/* unused harmony reexport syntaxError */
/* unused harmony reexport locatedError */
/* unused harmony reexport printError */
/* unused harmony reexport formatError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utilities__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utilities___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__utilities__);
/* unused harmony reexport getIntrospectionQuery */
/* unused harmony reexport introspectionQuery */
/* unused harmony reexport getOperationAST */
/* unused harmony reexport getOperationRootType */
/* unused harmony reexport introspectionFromSchema */
/* unused harmony reexport buildClientSchema */
/* unused harmony reexport buildASTSchema */
/* unused harmony reexport buildSchema */
/* unused harmony reexport getDescription */
/* unused harmony reexport extendSchema */
/* unused harmony reexport lexicographicSortSchema */
/* unused harmony reexport printSchema */
/* unused harmony reexport printType */
/* unused harmony reexport printIntrospectionSchema */
/* unused harmony reexport typeFromAST */
/* unused harmony reexport valueFromAST */
/* unused harmony reexport valueFromASTUntyped */
/* unused harmony reexport astFromValue */
/* unused harmony reexport TypeInfo */
/* unused harmony reexport coerceInputValue */
/* unused harmony reexport coerceValue */
/* unused harmony reexport isValidJSValue */
/* unused harmony reexport isValidLiteralValue */
/* unused harmony reexport concatAST */
/* unused harmony reexport separateOperations */
/* unused harmony reexport stripIgnoredCharacters */
/* unused harmony reexport isEqualType */
/* unused harmony reexport isTypeSubTypeOf */
/* unused harmony reexport doTypesOverlap */
/* unused harmony reexport assertValidName */
/* unused harmony reexport isValidNameError */
/* unused harmony reexport BreakingChangeType */
/* unused harmony reexport DangerousChangeType */
/* unused harmony reexport findBreakingChanges */
/* unused harmony reexport findDangerousChanges */
/* unused harmony reexport findDeprecatedUsages */
/**
 * GraphQL.js provides a reference implementation for the GraphQL specification
 * but is also a useful utility for operating on GraphQL files and building
 * sophisticated tools.
 *
 * This primary module exports a general purpose function for fulfilling all
 * steps of the GraphQL specification in a single operation, but also includes
 * utilities for every part of the GraphQL specification:
 *
 *   - Parsing the GraphQL language.
 *   - Building a GraphQL type schema.
 *   - Validating a GraphQL request against a type schema.
 *   - Executing a GraphQL request against a type schema.
 *
 * This also includes utility functions for operating on GraphQL types and
 * GraphQL documents to facilitate building tools.
 *
 * You may also import from each sub-directory directly. For example, the
 * following two import statements are equivalent:
 *
 *     import { parse } from 'graphql';
 *     import { parse } from 'graphql/language';
 */
// The GraphQL.js version info.
 // The primary entry point into fulfilling a GraphQL request.

 // Create and operate on GraphQL type definitions and schema.


// Parse and operate on GraphQL language source files.

// Execute GraphQL queries.


// Validate GraphQL documents.

// Create, format, and print GraphQL errors.

// Utilities for operating on GraphQL type schema and parsed sources.



/***/ }),

/***/ 56:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__user__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__settings__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__organizations__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex_persist__ = __webpack_require__(613);









__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var vuexLocal = new __WEBPACK_IMPORTED_MODULE_6_vuex_persist__["a" /* default */]({
  storage: window.localStorage,
  reducer: function reducer(state) {
    return { user: state.user, settings: state.settings };
  }
});

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    user: __WEBPACK_IMPORTED_MODULE_2__user__["a" /* default */],
    shared: __WEBPACK_IMPORTED_MODULE_3__shared__["a" /* default */],
    settings: __WEBPACK_IMPORTED_MODULE_4__settings__["a" /* default */],
    organizations: __WEBPACK_IMPORTED_MODULE_5__organizations__["a" /* default */]
  },
  plugins: [vuexLocal.plugin]
});

/***/ }),

/***/ 587:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(419)
}
var Component = __webpack_require__(39)(
  /* script */
  __webpack_require__(368),
  /* template */
  __webpack_require__(593),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 588:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(39)(
  /* script */
  __webpack_require__(369),
  /* template */
  __webpack_require__(595),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 589:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(39)(
  /* script */
  __webpack_require__(370),
  /* template */
  __webpack_require__(597),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 590:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(420)
}
var Component = __webpack_require__(39)(
  /* script */
  __webpack_require__(371),
  /* template */
  __webpack_require__(594),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 591:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(39)(
  /* script */
  __webpack_require__(373),
  /* template */
  __webpack_require__(598),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 592:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(421)
}
var Component = __webpack_require__(39)(
  /* script */
  __webpack_require__(372),
  /* template */
  __webpack_require__(596),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 593:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.iso) ? _c('span', {
    staticClass: "flag-icon",
    class: _vm.flagIconClass,
    attrs: {
      "title": _vm.title || _vm.iso
    }
  }) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 594:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-map-container"
  }, [_c('div', {
    ref: "vue-map",
    staticClass: "vue-map"
  }), _vm._v(" "), _c('div', {
    staticClass: "vue-map-hidden"
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("visible")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 595:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', _vm._g(_vm._b({
    ref: "input"
  }, 'input', _vm.$attrs, false), _vm.$listeners))
},staticRenderFns: []}

/***/ }),

/***/ 596:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-street-view-pano-container"
  }, [_c('div', {
    ref: "vue-street-view-pano",
    staticClass: "vue-street-view-pano"
  }), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 597:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    ref: "flyaway"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 598:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.label)
    }
  }), _vm._v(" "), _c('input', {
    ref: "input",
    class: _vm.className,
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 620:
/***/ (function(module, exports) {

module.exports = {"_args":[["weekstart@1.1.0","/home/ponce-dev-staging/report"]],"_from":"weekstart@1.1.0","_id":"weekstart@1.1.0","_inBundle":false,"_integrity":"sha512-ZO3I7c7J9nwGN1PZKZeBYAsuwWEsCOZi5T68cQoVNYrzrpp5Br0Bgi0OF4l8kH/Ez7nKfxa5mSsXjsgris3+qg==","_location":"/weekstart","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"weekstart@1.1.0","name":"weekstart","escapedName":"weekstart","rawSpec":"1.1.0","saveSpec":null,"fetchSpec":"1.1.0"},"_requiredBy":["/"],"_resolved":"https://registry.npmjs.org/weekstart/-/weekstart-1.1.0.tgz","_spec":"1.1.0","_where":"/home/ponce-dev-staging/report","author":{"name":"Denis Sikuler"},"bugs":{"url":"https://github.com/gamtiq/weekstart/issues"},"description":"Library to get first day of week.","devDependencies":{"@babel/preset-env":"^7.13.10","eslint":"^7.22.0","eslint-config-guard":"^2.0.1","ink-docstrap":"1.3.2","jest":"^26.6.3","jsdoc":"^3.6.6","jsdoc-file":"^1.0.1","microbundle":"0.4.4","version-bump-prompt":"^6.1.0"},"files":["dist","full.js","full.d.ts","index.d.ts","src","History.md"],"homepage":"https://github.com/gamtiq/weekstart","keywords":["week","start","first","day","locale","country","region"],"license":"MIT","main":"dist/commonjs/main.js","module":"dist/es-module/main.js","name":"weekstart","repository":{"type":"git","url":"git://github.com/gamtiq/weekstart.git"},"scripts":{"all":"npm run check-all && npm run doc && npm run build","build":"npm run build-umd && npm run build-commonjs && npm run build-esm && npm run build-umd-min","build-commonjs":"microbundle build \"src/!(*.test).js\" --output dist/commonjs --format cjs --strict --no-compress","build-esm":"microbundle build \"src/!(*.test).js\" --output dist/es-module --format es --no-compress","build-umd":"microbundle build src/main.js src/full.js --output dist --format umd --strict --no-compress","build-umd-min":"microbundle build src/main.js src/full.js --output dist/min --format umd --strict","check":"npm run lint && npm test","check-all":"npm run lint-all && npm test","doc":"jsdoc -c jsdoc-conf.js","lint":"eslint --cache --max-warnings 0 \"**/*.js\"","lint-all":"eslint --max-warnings 0 \"**/*.js\"","lint-all-error":"eslint \"**/*.js\"","lint-error":"eslint --cache \"**/*.js\"","release":"bump patch --commit --tag --all --push package.json package-lock.json bower.json component.json","release-major":"bump major --commit --tag --all --push package.json package-lock.json bower.json component.json","release-minor":"bump minor --commit --tag --all --push package.json package-lock.json bower.json component.json","test":"jest"},"types":"./index.d.ts","umd:main":"dist/main.js","version":"1.1.0"}

/***/ }),

/***/ 623:
/***/ (function(module, exports) {

module.exports = {"DashboardMainScreen":{"irrigationOrders":"Irrigation orders"},"DownloadData":{"client":"Client","periodCovered":"Period covered","to":"to","irrigationOrder":"IO","device":"Equipment","lot":"Field","startDate":"Start D.","endDate":"End D.","mm":"T. Mm.","theoricHoursShort":"T. Hs.","accumulatedHoursShort":"Ac. Hs.","accumulatedHours":"Accumulated Hs.","theoricHours":"Theoretical Hs."},"EquipmentsTable":{"devices":"Equipments","device":"Equipment","currentLot":"Current lot","orientation":"Orientation","state":"State","disconnected":"Disconnected","off":"Off","irrigating":"Irrigating","movement":"Movement"},"GroupedBarChart":{"accumulatedHours":"Accumulated Hs.","theoricHours":"Theoretical Hs."},"IrrigationOrdersTable":{"irrigationOrders":"Irrigation orders","irrigationOrder":"IO","device":"Equipment","lot":"Lot","startDate":"Start D.","endDate":"End D.","mm":"T. Mm.","theoricHours":"T. Hs.","accumulatedHours":"Ac. Hs.","theoricHoursShort":"T. Hs.","accumulatedHoursShort":"Ac. Hs."},"OrganizationFilter":{"organizationFilter":"Organization Filter"},"TimeFilter":{"capitalizedFrom":"From","from":"from","capitalizedTo":"Until","to":"until","customRange":"Custom range","aplly":"Apply","quickSelection":"Quick selection","lastHour":"Last hour","lastSixHours":"Last 6 hours","lastTwentyFourHours":"Last 24 hours","lastFortyEightHours":"Last 48 hours","lastSevenDays":"Last 7 days","lastFourteenDays":"Last 14 days","thisWeek":"This week","thisMonth":"This month"},"FaultsDetailsList":{"date":"Date","code":"Code","duration":"Duration","timeToGetBack":"Time to next irrigation","detail":"Detail","pump":"Pump","equipment":"Equipment"},"IOReportDetailsList":{"emission":"Emission","code":"Code","mm":"Millimeters","programed":"Scheduled","start":"Start","mmUnit":"mm"},"PieChart":{"dataNotAvailable":"Data not available","noFaults":"No failures","north":"NORTH","mmUnit":"mm","angles":"Angles","angle":"Angle","applicationRate":"Application rate"},"PressureChart":{"dataNotAvailable":"Data not available","north":"NORTH","angle":"Angle","pressure":"Pressure","category":"Category","barUnit":"bar","minimum":"Minimum","average":"Average","maximum":"Maximum","book":"Book"},"CardCircularGraphics":{"geolocatedView":"Geolocated view","variables":"Variables","irrigationOrders":"Irrigation orders","north":"NORTH","imageNotAvailable":"Image not available","degreeOfCompliance":"Degree of compliance","realImage":"Real image","applicationRateHomogeneity":"Application homogeneity","faults":"Failures","pump":"Pump","equipment":"Equipment","fourthTowerFail":"The fourth tower jammed which caused an overstrain and the gearmotor burned out","lowTension":"A voltage drop caused the pump to cut off but the irrigation equipment continued to walk","altimetry":"Altimetry","pressure":"Pressure","chartPressure":"Chart","minimumPressure":"Minimum","averagePressure":"Average","maximumPressure":"Maximum","irrigationOrderReport":"IO Report","lotNotComplete":"Lot not complete","DFX12Failure":"DFX12 failure occurred during your application","passes":"Passes","averageApplicationRate":"Average\nApplication rate","mmUnit":"mm","emitter":"Emitter","quantity":"Quantity","notOrderedIrrigation":"Irrigation not\nordered","angle":"Angle","failure":"Failure","start":"Start","end":"End"},"Toolbar":{"profilePic":"Profile Image","logout":"Logout","virtualAccess":"Virtual Access","dashboard":"Dashboard","reports":"Reports","audits":"Audits"},"Signin":{"setAccountData":"Welcome back","email":"Email","password":"Password","enter":"Log in","forgotPassword":"Forgot password?","reports":"Reports","noConnection":"No connection! Please try again later","wrongSigninData":"Wrong password or email","emailNotBeEmpty":"Email cannot be empty","wrongSigninDataHint":"Incorrect password or email. Please try again or click in \"Forgot password?\" to recover"},"CardDetails":{"lotDetails":"Field details","mmUnit":"mm","accumulated":"accumulated","applicationRate":"Application Rate","completedPasses":"Completed passes","hsUnit":"hs","irrigationHours":"Irrigation hours","faults":"Failures","barUnit":"bar","averagePressure":"Average pressure","crop":"Crop","numberOfPumps":"Number of pumps","field":"Field","area":"Surface","zone":"Zone","irrigator":"Operator","corn":"Corn","sunflower":"Sunflower","soy":"Soy","wheat":"Wheat","peanut":"Peanut","alfalfa":"Alfalfa","barley":"Barley","cotton":"Cotton","clover":"Clover","potato":"Potato","sugarCane":"Sugar Cane","ryegrass":"Rye grass","rape":"Rape","rice":"Rice","pea":"Pea","oatmeal":"Oatmeal","carinata":"Carinata","rye":"Rye","chickpea":"Chickpea","sunflowerSeed":"Sunflower Seed","seedCorn":"Seed Corn","moha":"Moha","millet":"Millet","flax":"Flax","lentil":"Lentil","seedPotato":"Seed Potato","kidneyBean":"Kidney Bean","sorghum":"Sorghum","vicia":"Vicia","carrot":"Carrot","notSpecified":"Not Specified","onion":"Onion","beet":"Beet"},"CardLinearGraphics":{"temporalView":"Temporal view","variables":"Variables","dataNotAvailable":"Data not available","irrigation":"Irrigation","movement":"Movement","mmUnit":"mm","off":"Off","fault":"Failure"},"Header":{"performanceReport":"Performance report {0}","totalIrrigationHours":"Total irrigation hours","workingPressure":"Working pressure","correct":"Correct","incorrect":"Incorrect","faultsInDevice":"Equipment failures","faults":"failures","noReports":"There are no reports"},"MainCard":{"brand":"Brand","flow":"Flow","area":"Area","homogeneityCoefficient":"Homogeneity coefficient","faultsEvery100hs":"Failures every 100hs","responseTimeBeforeFaults":"Failure response time","irrigationOrderComplition":"Compliance with irrigation orders","auditMessage":"This equipment fails more than average. Learn about its condition and improve performance with an audit.","quoteAudit":"Request audit quote","requestAuditQuoteMessage":"Hi Esteban! I'm interested in receiving a quote to audit this equipment."},"Reports":{"equipmentPerformance":"PERFORMANCE BY EQUIPMENT","noReports":"No reports available","urlReportNotFound":"There are no reports for the selected equipment, lot, and date range"},"Config":{"off":"Off","irrigating":"Irrigating","movement":"Moving equipment","failure":"Equipment failure","fieldIsRequired":"The field is required","onlyNumbers":"Use only numbers please","phoneIsRequired":"The phone is required","formatRequired":"Required format: +549223XXXXXXX","formatWithoutPrefixRequired":"Required format: 9223XXXXXXX","thisFieldIsRequired":"This field is required","passwordIsRequired":"The password is required","passwordRequirements":"Password must have at least 6 characters","emailIsRequired":"The e-mail is required","emailRule":"The e-mail must be valid","nameIsRequired":"The name is required","name21char":"The name cannot exceed 21 characters","name16char":"The name cannot exceed 16 characters","coordinatesRule":"Required format: (-)38.002625, (-)38.002625","grower":"Farmer","company":"Company","corporation":"Corporation","active":"Active","inactive":"Inactive","pivot":"Pivot","forwardAvance":"Linear","irrigationReel":"Irrigation reel","chartDetailRequired":"The Chart details are required","coordsRequired":"Complete crop location","minPressureRule":"The minimum pressure must be less than the maximum pressure","maxPressureRule":"The maximum pressure must be greater than the minimum pressure","cropDevicesEqualTypeToCrop":"Assigned devices must be of the same type as the crop","fillRequiredFields":"Complete required fields","longitudeRule":"Longitude must be between -180 and 180","latitudeRule":"Latitude must be between -90 and 90","IRCropWithLessThanThreePoints":"The crop cannot have less than three points","emailAlreadyInUse":"The email is already in use","linearTwoWings":"Two wings","linearOneWing":"One wing","linearPivotable":"Pivotable","allCoordinatesRule":"The coordinate must have a valid format","startDateMinDaysRule":"The start date must be at least {minDays} days after the current date","endDateMaxDurationRule":"The end date cannot exceed the duration of the contracted service","endDateAfterStartDateRule":"The end date must be after the start date","ok":"OK","newServiceEndDateRule":"The new end date must be after the current end date","unitsToExtendMaxRule":"The contracted amount is exceeded","extensionToServiceEndedDevice":"The extension cannot be assigned because the service has already ended"},"PassRecovery":{"forgottenPassword":"Forgot password?","email":"Email","sendRecoveryLink":"Send password reset link","signIn":"Log in","noConnection":"No connection! Try again later","checkEmail":"Check your email address","wrongEmail":"No account found with this email","recoveryEmailSent":"We sent you an email with the link to reset your password. Check your email inbox, <strong>including the Spam or Junk folder</strong>.","recoveryEmailSentSecond":"If you don't receive it in a few minutes, {contactSupport} so we can help you.","contactSupport":"contact support"},"PassChange":{"setNewPassword":"Set new password","newPassword":"New password","confirmPassword":"Repeat password","differentPasswords":"Make sure both passwords match","setPassword":"Set new password","signIn":"Log in","noConnection":"No connection! Try again later","passwordSetted":"Password set","invalidToken":"Invalid token. Send a new link"},"AddDevice":{"id":"ID","equipmentData":"Equipment data","equipmentName":"Equipment name","equipmentType":"Equipment type","equipmentSubtype":"Equipment subtype","pluviometricChart":"Pluviometric chart","search":"Search","chartDetail":"Chart details","validityDate":"Configuration validity start","register":"Register","goBack":"Back","allowedFileTypes":"Allowed types: {0}","centerLatitude":"Center latitude","centerLongitude":"Center longitude","startAndEndPoints":"Start and end of lot","startCoordinates":"Start coordinates","endCoordinates":"End coordinates","endPointEqualToStart":"Use this coordinates for the end of lot","radius":"Radius","latitude":"Latitude","longitude":"Longitude","coordinatesHint":"Ex.: (lat,lon) -33.529083, -61.789972 · (DMS) 33°31'44.7\"S 61°47'23.9\"W","addPoint":"Add point","mapDetails":"Map details","next":"Next","creationDateGreaterThanValidityDate":"The creation date must be before the validity date","creationDateGreaterThanCurrentDate":"The creation date must be before the current date","creationDateLowerThanCurrentDate":"The validity date must be after the current date","coordinates":"Coordinates","pluviometricConfiguration":"Pluviometric configuration","noActivePluviometricChart":"No active pluviometric chart","newPluviometricChart":"New configuration","deletePluviometricChartTitle":"Are you sure you want to delete this pluviometric chart configuration?","delete":"Delete","cancel":"Cancel","pluviometricChartFromStartServiceDateError":"No active pluviometric chart for service start date"},"OrganizationData":{"fieldData":"Field data","users":"Users","crops":"Crops","addUser":"Add user","devices":"Devices","addDevice":"Add device","assignedUsers":"Assigned users","edit":"Edit","delete":"Delete","noAssignedUsers":"No assigned users","fields":"Fields","addField":"Add field","deleteCropCardText":"Are you sure you want to remove {0} from your organization?","deleteDeviceCardText":"Are you sure you want to remove {0} from your organization?","deleteDeviceMainBtnText":"Yes, remove equipment","deleteDeviceSecondaryBtnText":"Cancel","deleteFieldCardText":"Are you sure you want to remove {0} from your organization?","deleteFieldMainBtnText":"Yes, remove field","deleteFieldSecondaryBtnText":"Cancel","assignedUserQty":"{users} assigned user","assignedUsersQty":"{users} assigned users","deviceCropsQty":"Irrigating in {crops} crops","deviceCropQty":"Irrigating in {crops} crop","withoutPluviometricChart":"Without pluviometric chart","fieldCropQty":"{crops} crop","fieldCropsQty":"{crops} crops","removeFieldWithCrops":"Cannot delete a field that contains crops","emptyDevices":"No devices created","emptyFields":"No fields created","emptyUsers":"No users created","dashboard":"Dashboard","deviceDetail":"{name}'s detail","noAssignedCrops":"No assigned lots","pendingCampaignOnboardingDialogTitle":"Pending pre-alert","pendingCampaignOnboardingDialogText":"Complete the necessary information to expedite the start of the service","pendingCampaignOnboardingDialogRemindMeLater":"Later","pendingCampaignOnboardingDialogConfirm":"Continue","pluviometricChart":"Pluviometric chart","finishCampaignOnboarding":{"title":"Complete configuration","requiredDevicesData":"Register missing mandatory equipments information","addFieldsAndCrops":"Assign lots to equipments in the Fields section","addUsers":"Assign users to equipments in the Users section"},"requiredDeviceData":"Incomplete configuration","monitoringToFinalize":"Monitoring to finalize","servicesSoonToEnd":{"title":"Services soon to end","mainDescription":"The monitoring of the following equipment ends in the coming days.","extensionInfo":"You can request an extension in the equipment configuration menu."},"queryServiceExtension":"Request extension"},"AddCrop":{"cropData":"Crop data","cropDevices":"Devices","cropName":"Crop name","cropField":"Field","cropType":"Crop type","cropSowingDate":"Sowing date","cropArea":"Area (ha)","cropCoordinates":"Crop coordinates","showMap":"Show map","hideMap":"Hide map","showCoordinates":"Show coordinates","hideCoordinates":"Hide coordinates","register":"Register","newCropQuestion":"Do you want to add another crop to {0}?","yes":"Yes","no":"No","nameRequired":"You must set the NAME before locating the crop","addNewField":"Add field +","shapeType":"Crop type","pivotShape":"Pivot","linearShape":"Linear","IRShape":"Irrigation reel","shapeTypeRequired":"You must select a crop type first","noDevices":"No devices created","centerCoordinates":"Center coordinates","coordinatesHint":"E.g.: (lat,lon) -33.529083, -61.789972 · (GMS) 33°31'44.7\"S 61°47'23.9\"W","angleHint":"Angle {angle}°"},"DeviceData":{"addCrop":"Add crop","users":"Users","deleteCropCardText":"Are you sure you want to remove {0} from your organization?","deleteCropMainBtnText":"Yes, remove crop","deleteCropSecondaryBtnText":"Cancel","abbreviatedPermissions":{"failure":"fai","pressure":"pre","off":"off","position":"pos","reports":"rep"},"cardLocked":"To move forward you must press \"Next\""},"AssignedUsers":{"title":"Who do you want to see {0} on their phone?","addUser":"Add user","register":"End register","usersPermissions":"See the permissions of each user","goBack":"Back"},"CropMap":{"markLot":"Mark \"{0}\"","markPolygonLot":"Mark the vertices of the crop","cropStart":"Indicate crop start","cropEnd":"Indicate crop end","confirmTitle":"Done!\nAre you satisfied with the location?","editData":"Edit record","declineData":"No, edit record","confirmData":"Yes, finish registration","samePosition":"Same location as start","requiredData":"You must complete the data within the map"},"UsersPermissions":{"title":"Who do you want us to notify?","failure":"Failures","pressure":"Pressure","off":"Off","position":"Position","irrigationOrders":"Irrigation orders","reports":"Reports","editDataPermission":"Edit and create devices","emptyDevicesList":"No devices assigned","audits":"Audits"},"AddField":{"contact":"Contact","auxContact":"Auxiliary"},"FieldEditor":{"fieldData":"Field data","fieldName":"Field name","fieldContact":"Field contact","fieldAuxContact":"ADDITIONAL field contact","auxContactSubtitle":"In case the field contact does not answer we will try with the additional","markGates":"Mark gates on the map","register":"Register","gates":"Gates","addNewUser":"Add new user","coordinatesHint":"Ex.: (lat,lon) -33.529083, -61.789972"},"FieldMap":{"markGates":"Mark the access gates to the equipment","confirmData":"Done, I marked all the accesses"},"PluviometricChart":{"pluviometricChart":"Pluviometric chart","automaticReading":"Automatic reading","creationDate":"Chart creation date","brand":"Brand","model":"Model","length":"Equipment length","pumpFlow":"Pump flow","area":"Equipment area","pressureRange":"Pressure range","chartPressure":"Chart pressure","minPressure":"Minimum pressure","maxPressure":"Maximum pressure","advancedConfig":"Advanced configuration","fieldArea":"Field area","fullLapArea":"Full lap area","areaWithCannon":"ha with cannon","cannonRadius":"Cannon radius","flow":"Flow","flowPerArea":"Flow / area","flowPerDay":"Flow / day","cannonFlow":"Cannon flow","fullApplicationRate":"100% application rate","pressure":"Pressure","highestElevation":"Highest elevation","lowestElevation":"Lowest elevation","basePress":"Base pressure","pivotPress":"Pivot pressure","endPress":"End pressure","pipes":"Piping","tubesQty":"Number of different tubes","spanLength":"Span length","internalDiameter":"Internal diameter","tubeLength":"Tube length","tubes":{"length":"Length","internalDiameter":"I.D.","material":"Material","cFactor":"C Factor","loss":"Loss"},"lrdu":"LRDU Drive Train","rpm":"RPM","frequency":"Frequency","highFloat":"High float","wheelGBRatio":"Wheel GB ratio","lrduDist":"LRDU dist","hoursPer360":"Hrs / 360°","distancePerTime":"Distance / time","sprinklerSettings":"Sprinkler configuration","sprinklers":{"spanQty":"Number of spans","distToCenter":"Distance to center","dropHeight":"Drop height","sprinklerNumber":"Sprinkler number","nozzleSize":"Sprinkler size","sprinklerModel":"Sprinkler model","sprinklerBrand":"Sprinkler brand","wearPad":"Pad","regulator":"Regulator","outletPressure":"Outlet pressure","isClogged":"Has plug","colors":{"skyBlue-beige":"Sky Blue-Beige","beige":"Beige","beige-gold":"Beige-Gold","gold":"Gold","gold-lime":"Gold-Lime","lime":"Lime","lime-lavender":"Lime-Lavender","lavender":"Lavender","lavender-grey":"Lavender-Grey","grey":"Grey","grey-turquoise":"Grey-Turquoise","turquoise":"Turquoise","turquoise-yellow":"Turquoise-Yellow","yellow":"Yellow","yellow-red":"Yellow-Red","red":"Red","red-white":"Red-White","white":"White","white-blue":"White-Blue","blue":"Blue","blue-darkBrown":"Blue-Dark Brown","darkBrown":"Dark Brown","darkBrown-orange":"Dark Brown-Orange","orange":"Orange","orange-darkGreen":"Orange-Dark Green","darkGreen":"Dark Green","darkGreen-purple":"Dark Green-Purple","purple":"Purple","black":"Black","black-darkTurquoise":"Black-Dark Turquoise","darkTurquoise":"Dark Turquoise","darkTurquoise-mustard":"Dark Turquoise-Mustard","mustard":"Mustard","mustard-garnet":"Mustard-Garnet","garnet":"Garnet","garnet-cream":"Garnet-Cream","cream":"Cream","cream-darkBlue":"Cream-Dark Blue","darkBlue":"Dark Blue","darkBlue-copper":"Dark Blue-Copper","copper":"Copper","green":"Green","pink":"Pink","ice":"Ice","lightBlue":"Light Blue","bronze":"Bronze","golden":"Golden"}},"span":"Span","units":{"per":"per","meter":"m","foot":"ft","cubicMeter":"m3","hour":"h","liter":"l","second":"s","gallonsPerMinute":"GPM","hectare":"ha","acres":"acres","acre":"acre","bar":"bar","psi":"PSI","litersPerSecond":"LPS","milimeters":"mm","day":"day","inch":"inch"},"save":"Save data","back":"Back","flowPerSpan":"Flow per span","spans":{"length":"Length","area":"Area","rqd":"Rqd","act":"Act","deviation":"Deviation","sprinklerQuantity":"Sprinkler quantity"},"otherBrand":"Other","otherModel":"Other","tubeMaterials":{"aluminum":"Aluminum","cement asbestos":"Cement asbestos","galvanized 12-gauge steel":"12-gauge galvanized steel","galvanized steel":"Galvanized steel","polyethylene plastic":"Polyethylene plastic","pvc plastic":"PVC plastic","steel":"Steel","cast iron":"Cast iron","other":"Other"},"cannonReach":"Cannon reach","hoseLength":"Hose length","noPluviometricChartSelected":"No pluviometric chart selected","activeConfiguration":"Active configuration","addPluviometricChart":"Add configuration"},"AddUser":{"userRegister":"User register","devices":"Devices","permissions":"Permissions","addUserDialog":{"questionTitle":"Add user","extistingUsers":"Existing users","newUser":"New user","usersAssignmentTitle":"Select the users who will have access to the platform","searchUser":"Search user","linkUsers":"Link users"}},"NewUser":{"name":"Name","lastName":"Last name","role":"Role","organization":"Organization","setPermissions":"Set permissions","countryCode":"Country code","phoneNumber":"Phone","example":"Example","addAndEditPermission":"Can this user edit and create devices?","no":"No","yes":"Yes","next":"Next","cancel":"Cancel","fileSizeLimit":"The file size must be less than {0}Mb","allowedFileTypes":"Allowed file types: {0}","loadingOrganizationsError":"Error while loading the organizations","register":"Register"},"Roles":{"fieldman":"Field manager","fieldmans":"field managers","farmhand":"Farmhand","farmhands":"farmhands","manager":"Manager","managers":"managers","admin":"Admin","admins":"admins","owner":"Owner","owners":"owners"},"AssignDevices":{"title":"What equipments do you want {0} to be able to see on his phone?","save":"Save","next":"Next","seePermisions":"View permissions by equipment","addDevice":"Add equipment","noDevicesAlert":"You must assign equipments to the user before viewing permissions","selectAll":"Select all","loadingDevicesError":"Error while loading equipments"},"GeneralPermissions":{"permissions":"Permissions","viewPermissionsByDevice":"View permissions by equipment","channels":"Communication channels","whatsapp":"WhatsApp","sms":"SMS","push":"Push","alertPeriod":"Alert period","startHour":"Start hour","endHour":"End hour","noDevicesAlert":"You must assign equipments to the user before viewing permissions","save":"Save","permissionChangedText":"This change will impact all equipments assigned to {0}.\n\nDo you want this change to also be implemented in all {1} in your organization?","permissionChangeMainBtn":"Yes, to all the {0}","permissionChangeSecondaryBtn":"No, just this one","confirmPermissionChangedText":"Users {0} have equipments with their custom permissions.\n\nAre you sure you want to modify your notifications?","confirmPermissionChangeMainBtn":"No, just modify {0}","confirmPermissionChangeSecondaryBtn":"Yes, I'm sure"},"UI":{"serverError":"Error while executing request, please try again.","registerError":"Save error. Try again later","existingDeviceError":"A device with that ID already exists.","registerSuccess":"Successful saving!","deleteSuccess":"Successful deleting!","deleteError":"Delete error. Try again later","phoneAlreadyExists":"The entered phone number is already registered","cropsRequired":"The equipment should have at least one crop","campaignNotFound":"Campaign not found"},"EditUser":{"userDetail":"User detail","assignedDevices":"Assigned equipments","seePermisions":"View permissions by equipment","save":"Save","rolePermissions":"See role permissions","name":"Name","lastName":"Last name","email":"Mail","role":"Role","countryCode":"Country code","phoneNumber":"Phone","phoneExample":"Example:","yes":"Yes","no":"No","addAndEditPermission":"Can this user edit and create devices?","deleteUser":"Remove user","deleteUserCardText":"Are you sure you want to remove {0} from your organization?","deleteUserMainBtnText":"Yes, remove user","deleteUserSecondaryBtnText":"Cancel","fileSizeLimit":"The file size must be less than {0}Mb","allowedFileTypes":"Allowed file types: {0}","selectAll":"Select all","permissions":"Permissions","noAccountUser":"The user has not confirmed their account.","resendInvitation":"Resend Invitation","invitationSent":"Invitation sent"},"PermissionsByDevice":{"title":"Permissions of {0} \"{1}\"","all":"ALL","save":"Save","back":"Back"},"Success":{"successfulSave":"Successfully saved"},"ExitConfirmation":{"title":"Are you sure you want to abandon the upload process?","subtitle":"You will lose all the data uploaded so far","yes":"Yes","no":"No"},"ManageField":{"crops":"Crops","addCrop":"Add crop","delete":"Delete","deleteCropMainBtnText":"Yes, remove crop","deleteCropSecondaryBtnText":"Cancel","cropDeviceQty":"{devices} equipment","cropDevicesQty":"{devices} equipments","assignedDevices":"Assigned equipment","noAssignedDevices":"No equipment assigned","dashboard":"Dashboard","emptyCrops":"No crops created"},"Welcome":{"welcome":"Welcome to PONCE!","description":"To set up your user, we need you to confirm your email and define a password.","email":"Email","password":"Password","confirm":"Confirm","registerSuccess":"Successful registration! You will be redirected to the App in a few moments...","loginError":"Failed to login","tokenInvalid":"The invitation link is invalid or has expired","resendInvitation":"Resend invitation","invitationSent":"Invitation sent","passwordsDoNotMatch":"Passwords do not match","passwordConfirmation":"Confirm password"},"WebTitles":{"dashboard":"Dashboard","reports":"Reports","login":"Login"},"SatisfactionSurveyModal":{"confirmBtnText":"Submit","declineBtnText":"Later","options":{"other":"Other","inaccurateData":"Inaccurate information","confusingInfo":"Confusing information","missingData":"Missing information","dataNeeded":"What is missing?"},"questions":{"reports":{"utility":"How useful are the reports?","why":"Why?"}},"thankYou":"Thank you for your response!"},"NewCampaignInitialData":{"serviceOnboardingTitle":"Service onboarding","saving":"Saving...","changesSaved":"Changes saved","pivot":"pivot","linear":"linear","irrigationReel":"irrigation reel","pivots":"pivots","linears":"linears","irrigationReels":"irrigation reels","introduction":{"title":"Welcome to the monitoring service onboarding process","introductionText":"To begin with the installation of the sensors, we need you to complete some key information that will allow our technicians to assist in the field for the installation. The sooner you complete it, the sooner we can plan and execute the installation without delays.","contractedEquipments":"Contracted equipments:","thingsToConsiderTitle":"Things to consider:","thingsToConsiderText":"The installation of the sensors requires at least 21 days from the completion of this registration. It will not be possible to carry out installations before that minimum period.","nextStepsTitle":"What's next?","nextStepsText":"Once this initial form is completed, you will be able to proceed to the full onboarding process, where you will define:","nextStepsTextItems":["Irrigation equipments","Fields","Users who will operate the service"],"campaignNameInput":{"placeholder":"Enter campaign name","hint":"Example: Campaign 2025/26"},"startCampaign":"Start now","contractedEquipmentsDetail":"{deviceType} service {serviceName} ({durationMonths} months)","contractedExtensionDetail":"extension of service ({durationMonths})","contractedExtensionsDetail":"extensions of service ({durationMonths})","month":"month","months":"months"},"devicesAndServices":{"title":"Equipment and service information","subtitle":"Complete the equipment location data and service dates to ensure the installation of the sensors.","tip":"It is possible to grant editing permissions so someone else can continue the equipment onboarding","contractedEquipmentsTitle":"Contracted equipments","finish":"Finish","back":"Back","inviteUsers":"Invite users","device":"Equipment","startDate":"Service start","endDate":"Service end","field":"Field","coordinates":"Exact equipment position","coordinatesHint":"Ex.: (lat,lon) -33.529083, -61.789972 · (DMS) 33°31'44.7\"S 61°47'23.9\"W","addNewDevice":"Add new equipment","addNewField":"Add new field","setNewDeviceTitle":"Enter equipment name","setNewDeviceLabel":"Equipment name","setNewDeviceSubmitButton":"Add equipment","newDeviceError":"Save error. Try again later","startDateWarningTitle":"Attention","startDateWarningMessageFirst":"Some equipment does not meet the required installation date conditions.","startDateWarningMessageSecond":"To complete the registration, it is necessary to correct your data.","extensionProductsDescription":"Extensions must be associated prior to the completion of the service","unitsToExtend":"Extensions to apply","addNewExtension":"+ Assign new extension","removeExtension":"- Remove extension"},"finish":{"title":"Pre-onboarding completed","body":"You have successfully registered the client, location, and scheduling data. Soon, the PONCE team will contact you to coordinate the installation of the monitoring devices.<br/><br/>The next step is to complete the configuration of the equipment and fields to be monitored from the administration panel. In addition, from there you will be able to register the users who will have access to the organization's services and notifications.","goToDashboard":"Go to Administration"},"termsAndConditions":{"title":"Terms of Service","introductionText":"Before continuing, it is necessary that you review and accept the conditions that regulate the PONCE monitoring service.","checkboxLabel":"I have read and accept the Terms and Conditions of Service","next":"Next","t&cTitle":"Terms and Conditions of the PONCE Monitoring Service"}},"EditCampaign":{"service":"Service","changesSaved":"Changes saved successfully","errorSavingChanges":"Error saving changes","noProductsAvailable":"No products available for this campaign","campaignNameSaved":"Campaign name saved successfully","startDatePassedMessage":"The start date has already passed. You can only edit the end date.","devicesAndServices":{"device":"Equipment","startDate":"Service start","endDate":"Service end","field":"Field","coordinates":"Exact equipment position","coordinatesHint":"Example: -32.53254, -69.264214","addNewDevice":"Add new equipment","addNewField":"Add new field","setNewDeviceTitle":"Enter equipment name","setNewDeviceLabel":"Equipment name","setNewDeviceSubmitButton":"Add equipment","newDeviceError":"Save error. Try again later","back":"Back","finish":"Confirm","noDevices":"No equipments","extensionProductsDescription":"Extensions must be associated prior to the completion of the service","unitsToExtend":"Extensions to apply","addNewExtension":"+ Assign new extension","removeExtension":"- Remove extension"},"pivot":"pivot","linear":"linear","irrigationReel":"irrigation reel","pivots":"pivots","linears":"linears","irrigationReels":"irrigation reels","introduction":{"contractedEquipmentsDetail":"{deviceType} service {serviceName} ({durationMonths} months)","contractedExtensionDetail":"extension of service ({durationMonths})","contractedExtensionsDetail":"extensions of service ({durationMonths})","month":"month","months":"months"},"emptyCampaigns":"No campaigns available"},"PostponementRequestDialog":{"title":"Pending confirmation","body":"There are changes in the service dates. Confirm the modifications to avoid delays","changeReason":"Change reason:","newStartDate":"New start date:","currentStartDate":"Current start date:","changeType":{"1":"The irrigation equipment does not meet the necessary conditions for the installation of sensors.","2":"It is not possible to access the field due to bad weather conditions.","3":"There is no personal available to perform the installation of the sensors.","4":"The equipment location is incorrect.","5":"The weather conditions do not allow the installation of the sensors.","6":"The irrigation system is in operation and cannot be stopped for the installation of the sensors.","7":"Lack of permissions or authorizations to perform the installation in the field.","8":"Lack of response from the client to coordinate the installation with the person responsible for the equipment.","9":"Delays by PONCE in the installation, either due to lack of sensor availability or technical service personnel."},"confirm":"Confirm"},"ServiceExtensionDialog":{"title":"Service extension","serviceEndsOn":"The monitoring service of the equipment {deviceName} ends on {date}","queryNewServiceEndDate":"Request a new service end date","serviceEndDate":"Service end","submit":"Request extension","serviceExtensionReceived":"Your service extension request has been received.","serviceExtensionReceivedSubtitle":"A PONCE representative will contact the organization owner to request approval for this extension.","accept":"Accept","pendingServiceExtensionTitle":"Pending request","pendingServiceExtensionDetail":"Extension until {date}. Requester: {userName}","pendingServiceExtensionDescription":"The extension will be applied once the owner confirms it.","serviceExtensionError":"Error requesting service extension","dateWithinPeriod":"The selected date is within the contracted period","dateWithinPeriodSubtitle":"To modify the end date, the organization owner must update the service from the administration page"},"Audits":{"noAudits":"No audits","fieldSurveySetupRequired":"To view audits you must complete the service setup","goToFieldSurveySetup":"Go to service setup","Header":{"audits":"Audits {0}","totalIrrigationHours":"Total irrigation hours","workingPressure":"Working pressure","correct":"Correct","incorrect":"Incorrect","faultsInDevice":"Falls in your equipment","faults":"falls","noAudits":"No audits"},"FieldSurveyStatus":{"new":"Pending","inProgress":"In progress","completed":"Completed"}},"FieldSurveyEntry":{"title":"Field survey","placeholderBody":"This screen will host the setup flow. Content coming soon."},"FieldSurveyForm":{"pageTitle":"Service setup - {org} - {date}","loadingTitle":"Loading…","titleError":"Could not load field survey","mapHint":"Mark the location of equipment {equipmentNumber} on the map.","hiredEquipmentsOne":"1 equipment unit contracted.","hiredEquipmentsMany":"{count} equipment units contracted.","hiredEquipmentsUnknown":"{count} items in list (contracted quantity unavailable).","hiredEquipmentsUnknownOne":"1 item in list (contracted quantity unavailable).","hireMore":"Hire more","hireMoreWhatsappText":"Hi Esteban! I'm interested in receiving a proposal to audit more equipment.","editService":"Edit service","finishEditService":"Finish editing","confirm":"Confirm","confirmNotImplemented":"Confirmation will be available soon.","confirmSuccess":"Service setup completed.","confirmError":"Could not complete service setup.","noSurveyWorks":"No survey works for this field survey yet.","surveyWorksError":"Could not load survey works.","saveSuccess":"Changes saved.","saveError":"Could not save changes.","deleteSuccess":"Work item removed.","deleteError":"Could not delete work item.","edit":"Edit","delete":"Delete","save":"Save","saving":"Saving…","cancel":"Cancel","fieldName":"Equipment name","fieldUser":"Assigned technician","fieldCoordinates":"Coordinates","pluviometricChartYes":"Irrigation chart","pluviometricChartNo":"No irrigation chart","chartUploadButtonLabel":"Irrigation chart","chartReplace":"Change irrigation chart","chartRemove":"Remove irrigation chart","chartClearSelection":"Cancel new file","chartUndoRemove":"Keep irrigation chart","chartPendingUpload":"New irrigation chart: {name} (will upload when you save).","chartWillRemove":"Irrigation chart will be removed when you save.","chartCurrentFile":"Irrigation chart: {name}","deleteConfirmMessage":"Are you sure you want to remove this equipment?","mapSearchPlaceholder":"Search in Google Maps","mapAddBlockedNoQty":"You cannot place points on the map until the number of devices is defined.","mapAddBlockedLimit":"You have already added all contracted devices.","addTechnician":"Add technician","newTechnicianTitle":"New technician","newTechnicianSave":"Save","newTechnicianError":"Could not create technician.","newTechnicianNoCampaign":"There is no active campaign to link the user.","newTechnicianEmail":"Email","ponceTechnicianOption":"PONCE technician","ponceChargeWarningBody":"Assignments to PONCE technicians have been detected. This will incur additional charges. Do you want to continue?"},"FieldSurveyPending":{"title":"Pending surveys","message":"You have self-assessment surveys to complete.","completeLater":"Complete later","goToSetup":"Go to setup"}}

/***/ }),

/***/ 624:
/***/ (function(module, exports) {

module.exports = {"DashboardMainScreen":{"irrigationOrders":"Órdenes de riego"},"DownloadData":{"client":"Cliente","periodCovered":"Periodo abarcado","to":"al","irrigationOrder":"OdR","device":"Equipo","lot":"Lote","startDate":"F. Inicio","endDate":"F. Fin","mm":"Mm. T.","theoricHoursShort":"Hs. T.","accumulatedHoursShort":"Hs. Ac.","accumulatedHours":"Hs. Acumuladas","theoricHours":"Hs. Teóricas"},"EquipmentsTable":{"devices":"Equipos","device":"Equipo","currentLot":"Lote actual","orientation":"Sentido","state":"Estado","disconnected":"Desconectado","off":"Apagado","irrigating":"Regando","movement":"Movimiento"},"GroupedBarChart":{"accumulatedHours":"Hs. Acumuladas","theoricHours":"Hs. Teóricas"},"IrrigationOrdersTable":{"irrigationOrders":"Órdenes de riego","irrigationOrder":"OdR","device":"Equipo","lot":"Lote","startDate":"F. Inicio","endDate":"F. Fin","mm":"Mm. T.","theoricHours":"Hs. T.","accumulatedHours":"Hs. Ac.","theoricHoursShort":"Hs. T.","accumulatedHoursShort":"Hs. Ac."},"OrganizationFilter":{"organizationFilter":"Filtro de Organización"},"TimeFilter":{"capitalizedFrom":"Desde","from":"desde","capitalizedTo":"Hasta","to":"hasta","customRange":"Rango personalizado","aplly":"Aplicar","quickSelection":"Selección rápida","lastHour":"Ultima hora","lastSixHours":"Ultimas 6 horas","lastTwentyFourHours":"Ultimas 24 horas","lastFortyEightHours":"Ultimas 48 horas","lastSevenDays":"Ultimos 7 días","lastFourteenDays":"Ultimos 14 días","thisWeek":"Esta semana","thisMonth":"Este mes"},"FaultsDetailsList":{"date":"Fecha","code":"Código","duration":"Duración","timeToGetBack":"Tiempo en volver a regar","detail":"Detalle","pump":"Bomb","equipment":"Equipo"},"IOReportDetailsList":{"emission":"Emisión","code":"Código","mm":"Milímetros","programed":"Programado","start":"Comienzo","mmUnit":"mm"},"PieChart":{"dataNotAvailable":"Datos no disponibles","noFaults":"Sin fallas","north":"NORTE","mmUnit":"mm","angles":"Ángulos","angle":"Ángulo","applicationRate":"Lámina"},"PressureChart":{"dataNotAvailable":"Datos no disponibles","north":"NORTE","angle":"Ángulo","pressure":"Presión","category":"Categoría","barUnit":"bar","minimum":"Mínima","average":"Promedio","maximum":"Máxima","book":"Cartilla"},"CardCircularGraphics":{"geolocatedView":"Vista geolocalizada","variables":"Variables","irrigationOrders":"Ordenes de riego","north":"NORTE","imageNotAvailable":"Imagen no disponible","degreeOfCompliance":"Grado de cumplimiento","realImage":"Imagen real","applicationRateHomogeneity":"Homogeneidad de lámina","faults":"Fallas","pump":"Bomba","equipment":"Equipo","fourthTowerFail":"Se atasco la cuarta torre lo que produjo un sobreesfuerzo y que se queme el motorreductor","lowTension":"Un bajón de tensión hizo que corte la bomba pero continue caminando el equipo de riego","altimetry":"Altimetría","pressure":"Presión","chartPressure":"Cartilla","minimumPressure":"Mínima","averagePressure":"Promedio","maximumPressure":"Máxima","irrigationOrderReport":"Reporte OdR","lotNotComplete":"No completo el lote","DFX12Failure":"Sucedió la falla DFX12 durante su aplicación","passes":"Pasadas","averageApplicationRate":"Lamina\nPromedio","mmUnit":"mm","emitter":"Emisor","quantity":"Cantidad","notOrderedIrrigation":"Riego no\nordenado","angle":"Ángulo","failure":"Falla","start":"Inicio","end":"Fin"},"Toolbar":{"profilePic":"Imagen de Perfil","logout":"Cerrar Sesión","virtualAccess":"Acceso Virtual","dashboard":"Administración","reports":"Reportes","audits":"Auditorías"},"Signin":{"setAccountData":"Bienvenido de nuevo","email":"Email","password":"Contraseña","enter":"Iniciar sesión","forgotPassword":"¿Olvidaste tu contraseña?","reports":"Reportes","noConnection":"Sin conexión! Intenta nuevamente más tarde","wrongSigninData":"Contraseña o mail incorrectos","emailNotBeEmpty":"Email no puede estar vacío","wrongSigninDataHint":"La contraseña o el mail son incorrectos. Vuelve a intentarlo o haz clic en \"¿Olvidaste tu contraseña?\" para restablecerla"},"CardDetails":{"lotDetails":"Detalles lote","mmUnit":"mm","accumulated":"acumulados","applicationRate":"Lámina","completedPasses":"Pasadas completadas","hsUnit":"hs","irrigationHours":"Horas de riego","faults":"Fallas","barUnit":"bar","averagePressure":"Presión promedio","crop":"Cultivo","numberOfPumps":"Cant. de bombas","field":"Campo","area":"Superficie","zone":"Zona","irrigator":"Regador","corn":"Maíz","sunflower":"Girasol","soy":"Soja","wheat":"Trigo","peanut":"Maní","alfalfa":"Alfalfa","barley":"Cebada","cotton":"Algodón","clover":"Trébol","potato":"Papa","sugarCane":"Caña de Azucar","ryegrass":"Raigrás","rape":"Colza","rice":"Arroz","pea":"Arveja","oatmeal":"Avena","carinata":"Carinata","rye":"Centeno","chickpea":"Garbanzo","sunflowerSeed":"Girasol Semilla","seedCorn":"Maíz Semilla","moha":"Moha","millet":"Mijo","flax":"Lino","lentil":"Lenteja","seedPotato":"Papa Semilla","kidneyBean":"Poroto","sorghum":"Sorgo","vicia":"Vicia","carrot":"Zanahoria","notSpecified":"No Especifica","onion":"Cebolla","beet":"Remolacha"},"CardLinearGraphics":{"temporalView":"Vista temporal","variables":"Variables","dataNotAvailable":"Datos no disponibles","irrigation":"Riego","movement":"Movimiento","mmUnit":"mm","off":"Apagado","fault":"Falla"},"Header":{"performanceReport":"Reporte de desempeño {0}","totalIrrigationHours":"Hs. de riego totales","workingPressure":"Presión de funcionamiento","correct":"Correcta","incorrect":"Incorrecta","faultsInDevice":"Fallas en tu equipo","faults":"fallas","noReports":"No hay reportes"},"MainCard":{"brand":"Marca","flow":"Caudal","area":"Superficie","homogeneityCoefficient":"Coef. de homogeneidad","faultsEvery100hs":"Fallas cada 100hs","responseTimeBeforeFaults":"Tiempo de respuesta ante fallas","irrigationOrderComplition":"Cumplimiento de ordenes de riego","auditMessage":"Este equipo falla más que la media. Conoce el estado y mejora el desempeño del equipo con una auditoría.","quoteAudit":"Solicitar cotización de auditoría","requestAuditQuoteMessage":"Hola Esteban! Me interesa recibir una cotización para auditar este equipo."},"Reports":{"equipmentPerformance":"DESEMPEÑO POR EQUIPOS","noReports":"No hay reportes de equipos","urlReportNotFound":"No existen reportes para el equipo, lote y rango de fechas seleccionado"},"Config":{"off":"Apagado","irrigating":"Regando","movement":"Moviendo equipo","failure":"Equipo en falla","fieldIsRequired":"El campo es requerido","onlyNumbers":"Solo números por favor","phoneIsRequired":"El teléfono es requerido","formatRequired":"Formato requerido: +549223XXXXXXX","formatWithoutPrefixRequired":"Formato requerido: 9223XXXXXXX","thisFieldIsRequired":"Este campo es requerido","passwordIsRequired":"La contraseña es requerida","passwordRequirements":"La contraseña debe contener al menos 6 caracteres","emailIsRequired":"El e-mail es requerido","emailRule":"El e-mail debe ser válido","nameIsRequired":"El nombre es requerido","name21char":"El nombre no puede superar los 21 caracteres","name16char":"El nombre no puede superar los 16 caracteres","coordinatesRule":"Formato requerido: (-)38.002625, (-)38.002625","grower":"Productor","company":"Empresa","corporation":"Corporación","active":"Activo","inactive":"Inactivo","pivot":"Pivot","forwardAvance":"Avance frontal","irrigationReel":"Enrollador","chartDetailRequired":"El Detalle de la carta es requerido","coordsRequired":"Completar ubicación de lote","minPressureRule":"La presión mínima debe ser menor que la presión máxima","maxPressureRule":"La presión máxima debe ser mayor que la presión mínima","cropDevicesEqualTypeToCrop":"Los equipos asignados deben ser del mismo tipo que el lote","fillRequiredFields":"Completar los datos requeridos","longitudeRule":"La longitud debe estar entre -180 y 180","latitudeRule":"La latitud debe estar entre -90 y 90","IRCropWithLessThanThreePoints":"El lote no puede tener menos de tres puntos","emailAlreadyInUse":"El email ya se encuentra en uso","linearTwoWings":"Dos alas","linearOneWing":"Un ala","linearPivotable":"Pivoteable","allCoordinatesRule":"La coordenada debe tener un formato válido","startDateMinDaysRule":"La fecha de inicio debe ser al menos {minDays} días después de la fecha actual","endDateMaxDurationRule":"La fecha de fin no puede exceder la duración del servicio contratado","endDateAfterStartDateRule":"La fecha de fin debe ser posterior a la fecha de inicio","ok":"Aceptar","newServiceEndDateRule":"La nueva fecha de fin debe ser posterior a la fecha de fin actual","unitsToExtendMaxRule":"Se supera la cantidad contratada","extensionToServiceEndedDevice":"La extensión no puede ser asignada porque el servicio ya finalizó"},"PassRecovery":{"forgottenPassword":"¿Olvidaste tu contraseña?","email":"Email","sendRecoveryLink":"Enviar link de recuperación","signIn":"Iniciar Sesión","noConnection":"Sin conexión! Intenta nuevamente más tarde","checkEmail":"Verifica tu casilla de correos","wrongEmail":"No pudimos encontrar una cuenta con el correo electrónico que ingresaste","recoveryEmailSent":"Te enviamos un correo con el enlace para restablecer tu contraseña. Revisa tu casilla de email, <strong>incluyendo la carpeta de Spam o Correo no deseado</strong>.","recoveryEmailSentSecond":"Si no lo recibes en unos minutos, {contactSupport} para que podamos ayudarte.","contactSupport":"contacta a soporte"},"PassChange":{"setNewPassword":"Establece una nueva contraseña","newPassword":"Nueva contraseña","confirmPassword":"Confirmar contraseña","differentPasswords":"Asegúrate de que la segunda contraseña que ingresaste coincida con la primera","setPassword":"Establecer contraseña","signIn":"Iniciar Sesión","noConnection":"Sin conexión! Intenta nuevamente más tarde","passwordSetted":"Contraseña establecida","invalidToken":"Token inválido. Vuelve a enviar link de recuperación de contraseña"},"AddDevice":{"id":"ID","equipmentData":"Datos de equipo","equipmentName":"Nombre del equipo","equipmentType":"Equipo de riego","equipmentSubtype":"Subtipo de equipo","pluviometricChart":"Cartilla pluviométrica","search":"Buscar","chartDetail":"Detalle de la carta","validityDate":"Inicio de vigencia de configuración","register":"Registrar","goBack":"Atrás","allowedFileTypes":"Tipos permitidos: {0}","centerLatitude":"Latitud de centro","centerLongitude":"Longitud de centro","startAndEndPoints":"Inicio y fin de lote","startCoordinates":"Coordenadas de inicio de lote","endCoordinates":"Coordenadas de fin de lote","endPointEqualToStart":"Usar mismas coordenadas para el fin del lote","radius":"Radio","latitude":"Latitud","longitude":"Longitud","coordinatesHint":"Ej.: (lat,lon) -33.529083, -61.789972 · (GMS) 33°31'44.7\"S 61°47'23.9\"W","addPoint":"Agregar punto","mapDetails":"Detalles de mapa","next":"Siguiente","creationDateGreaterThanValidityDate":"La fecha de creación debe ser anterior a la fecha de validez","creationDateGreaterThanCurrentDate":"La fecha de creación debe ser anterior a la fecha actual","creationDateLowerThanCurrentDate":"La fecha de validez debe ser posterior a la fecha actual","coordinates":"Coordenadas","pluviometricConfiguration":"Configuración pluviométrica","noActivePluviometricChart":"No hay configuración pluviométrica activa","newPluviometricChart":"Nueva configuración","deletePluviometricChartTitle":"¿Estás seguro que deseas eliminar esta configuración pluviométrica?","delete":"Eliminar","cancel":"Cancelar","pluviometricChartFromStartServiceDateError":"No existe una configuración pluviométrica vigente para la fecha de inicio del servicio"},"OrganizationData":{"fieldData":"Datos de campo","users":"Usuarios","crops":"Lotes","addUser":"Agregar usuario","devices":"Equipos","addDevice":"Agregar equipo","assignedUsers":"Usuarios asignados","edit":"Editar","delete":"Eliminar","noAssignedUsers":"No hay usuarios asignados","fields":"Campos","addField":"Agregar campo","deleteCropCardText":"¿Estás seguro que deseas eliminar a {0} de tu organización?","deleteDeviceCardText":"¿Estás seguro que deseas eliminar a {0} de tu organización?","deleteDeviceMainBtnText":"Sí, eliminar equipo","deleteDeviceSecondaryBtnText":"Cancelar","deleteFieldCardText":"¿Estás seguro que deseas eliminar a {0} de tu organización?","deleteFieldMainBtnText":"Sí, eliminar campo","deleteFieldSecondaryBtnText":"Cancelar","assignedUserQty":"{users} usuario asignado","assignedUsersQty":"{users} usuarios asignados","deviceCropsQty":"Regando en {crops} lotes","deviceCropQty":"Regando en {crops} lote","withoutPluviometricChart":"Sin cartilla pluviométrica","fieldCropQty":"{crops} lote","fieldCropsQty":"{crops} lotes","removeFieldWithCrops":"No se puede eliminar un campo que contiene lotes","emptyDevices":"No hay equipos creados","emptyFields":"No hay campos creados","emptyUsers":"No hay usuarios creados","dashboard":"Administración","deviceDetail":"Detalle de {name}","noAssignedCrops":"No hay lotes asignados","pendingCampaignOnboardingDialogTitle":"Prealta pendiente","pendingCampaignOnboardingDialogText":"Completa la información necesaria para agilizar el comienzo del servicio","pendingCampaignOnboardingDialogRemindMeLater":"Más tarde","pendingCampaignOnboardingDialogConfirm":"Continuar","pluviometricChart":"Cartilla pluviométrica","finishCampaignOnboarding":{"title":"Completar configuración","requiredDevicesData":"Registrar información obligatoria faltante de equipos","addFieldsAndCrops":"Asignar lotes a los equipos en la sección Campos","addUsers":"Asignar usuarios a los equipos en la sección Usuarios"},"requiredDeviceData":"Configuración incompleta","monitoringToFinalize":"Monitoreo por finalizar","servicesSoonToEnd":{"title":"Servicios pronto a finalizar","mainDescription":"El monitoreo de los siguientes equipos finaliza en los próximos días.","extensionInfo":"Podrás solicitar una extensión en el menú de configuración de equipo."},"queryServiceExtension":"Solicitar extensión"},"AddCrop":{"cropData":"Datos de lote","cropDevices":"Equipos que lo riegan","cropName":"Nombre de lote","cropField":"Campo","cropType":"Cultivo","cropSowingDate":"Fecha de siembra","cropArea":"Superficie (ha)","cropCoordinates":"Coordenadas del lote","showMap":"Mostrar mapa","hideMap":"Ocultar mapa","showCoordinates":"Mostrar coordenadas","hideCoordinates":"Ocultar coordenadas","register":"Registrar","newCropQuestion":"¿Deseas registrar otro lote a {0}?","yes":"Sí","no":"No","nameRequired":"Debe ingresar un nombre antes de ubicar el lote","addNewField":"Agregar campo +","shapeType":"Tipo de lote","pivotShape":"Pivot","linearShape":"Avance frontal","IRShape":"Enrollador","shapeTypeRequired":"Debe seleccionar un tipo de lote primero","noDevices":"No hay equipos creados","centerCoordinates":"Coordenadas de centro","coordinatesHint":"Ej.: (lat,lon) -33.529083, -61.789972 · (GMS) 33°31'44.7\"S 61°47'23.9\"W","angleHint":"Ángulo {angle}°"},"DeviceData":{"addCrop":"Agregar lote","users":"Usuarios","deleteCropCardText":"¿Estás seguro que deseas eliminar a {0} de tu organización?","deleteCropMainBtnText":"Sí, eliminar lote","deleteCropSecondaryBtnText":"Cancelar","abbreviatedPermissions":{"failure":"fal","pressure":"pre","off":"apa","position":"pos","reports":"rep"},"cardLocked":"Para avanzar debe presionar \"Siguiente\""},"AssignedUsers":{"title":"¿Quienes querés que vean {0} en su celular?","addUser":"Agregar usuario","register":"Finalizar registro","usersPermissions":"Ver los permisos de cada usuario","goBack":"Atrás"},"CropMap":{"markLot":"Marque \"{0}\"","markPolygonLot":"Marque los vértices del lote","cropStart":"Indique inicio de lote","cropEnd":"Indique fin de lote","confirmTitle":"¡Listo!\n¿Estás conforme con la ubicación?","editData":"Editar registro","declineData":"No, editar registro","confirmData":"Si, finalizar registro","samePosition":"Misma ubicación que inicio","requiredData":"Debes completar los datos dentro del mapa"},"PluviometricChart":{"pluviometricChart":"Cartilla pluviométrica","automaticReading":"Lectura automática","creationDate":"Fecha de creación de la cartilla","brand":"Marca","model":"Modelo","length":"Largo del equipo","pumpFlow":"Caudal de la bomba","area":"Superficie del equipo","pressureRange":"Rango de presión","chartPressure":"Presión de cartilla","minPressure":"Presión mínima","maxPressure":"Presión máxima","advancedConfig":"Configuración avanzada","fieldArea":"Área de campo","fullLapArea":"A vuelta completa","areaWithCannon":"ha con cañon","cannonRadius":"Radio de cañon","flow":"Flujo","flowPerArea":"Caudal / superficie","flowPerDay":"Caudal / día","cannonFlow":"Caudal de cañon","fullApplicationRate":"Lámina al 100%","pressure":"Presión","highestElevation":"Elevación más alta","lowestElevation":"Elevación más baja","basePress":"Presión de base","pivotPress":"Presión de pivot","endPress":"Presión de fin","pipes":"Cañería","tubesQty":"Cantidad de tubos diferentes","spanLength":"Longitud del tramo","internalDiameter":"Diámetro interno","tubeLength":"Largo del tubo","tubes":{"length":"Longitud","internalDiameter":"D.I.","material":"Material","cFactor":"Factor C","loss":"Pérdida"},"lrdu":"LRDU Drive Train","rpm":"RPM","frequency":"Frecuencia","highFloat":"High float","wheelGBRatio":"Wheel GB ratio","lrduDist":"LRDU dist","hoursPer360":"Hrs / 360°","distancePerTime":"Distancia / tiempo","sprinklerSettings":"Configuración de aspersores","sprinklers":{"spanQty":"Cantidad de tramos","distToCenter":"Distancia al centro","dropHeight":"Altura de caída","sprinklerNumber":"Número de aspersor","nozzleSize":"Tamaño de aspersor","sprinklerModel":"Modelo de aspersor","sprinklerBrand":"Marca de aspersor","wearPad":"Plato","regulator":"Regulador","outletPressure":"Presión de salida","isClogged":"Tiene tapón","colors":{"skyBlue-beige":"Celeste-Beige","beige":"Beige","beige-gold":"Beige-Oro","gold":"Oro","gold-lime":"Oro-Lima","lime":"Lima","lime-lavender":"Lima-Lavanda","lavender":"Lavanda","lavender-grey":"Lavanda-Gris","grey":"Gris","grey-turquoise":"Gris-Turquesa","turquoise":"Turquesa","turquoise-yellow":"Turquesa-Amarillo","yellow":"Amarillo","yellow-red":"Amarillo-Rojo","red":"Rojo","red-white":"Rojo-Blanco","white":"Blanco","white-blue":"Blanco-Azul","blue":"Azul","blue-darkBrown":"Azul-Marrón oscuro","darkBrown":"Marrón oscuro","darkBrown-orange":"Marrón oscuro-Naranja","orange":"Naranja","orange-darkGreen":"Naranja-Verde oscuro","darkGreen":"Verde oscuro","darkGreen-purple":"Verde oscuro-Púrpura","purple":"Púrpura","black":"Negro","black-darkTurquoise":"Negro-Turquesa oscuro","darkTurquoise":"Turquesa oscuro","darkTurquoise-mustard":"Turquesa oscuro-Mostaza","mustard":"Mostaza","mustard-garnet":"Mostaza-Granate","garnet":"Granate","garnet-cream":"Granate-Crema","cream":"Crema","cream-darkBlue":"Crema-Azul oscuro","darkBlue":"Azul oscuro","darkBlue-copper":"Azul oscuro-Cobre","copper":"Cobre","green":"Verde","pink":"Rosado","ice":"Hielo","lightBlue":"Azul claro","bronze":"Bronce","golden":"Dorado"}},"span":"Tramo","units":{"per":"por","meter":"m","foot":"ft","cubicMeter":"m3","hour":"h","liter":"l","second":"s","gallonsPerMinute":"GPM","hectare":"ha","acres":"acres","acre":"acre","bar":"bar","psi":"PSI","litersPerSecond":"LPS","milimeters":"mm","day":"día","inch":"inch"},"save":"Guardar datos","back":"Volver","flowPerSpan":"Caudal por tramo","spans":{"length":"Longitud","area":"Área","rqd":"Rqd","act":"Act","deviation":"Desviación","sprinklerQuantity":"Cantidad de aspersores"},"otherBrand":"Otra","otherModel":"Otro","tubeMaterials":{"aluminum":"Aluminio","cement asbestos":"Asbesto cemento","galvanized 12-gauge steel":"Acero galvanizado calibre 12","galvanized steel":"Acero galvanizado","polyethylene plastic":"Plástico de polietileno","pvc plastic":"Plástico PVC","steel":"Acero","cast iron":"Hierro fundido","other":"Otro"},"cannonReach":"Alcance del cañón","hoseLength":"Largo de la manguera","noPluviometricChartSelected":"No hay cartilla pluviométrica seleccionada","activeConfiguration":"Configuración activa","addPluviometricChart":"Agregar configuración"},"UsersPermissions":{"title":"¿A quién deseas que notifiquemos?","failure":"Fallas","pressure":"Presión","off":"Apagado","position":"Posición","irrigationOrders":"Órdenes de riego","reports":"Reportes","editDataPermission":"Edición y creación de equipos","emptyDevicesList":"No hay equipos asignados","audits":"Auditorías"},"AddField":{"contact":"Contacto","auxContact":"Auxiliar"},"FieldEditor":{"fieldData":"Datos del campo","fieldName":"Nombre del campo","fieldContact":"Contacto de campo","fieldAuxContact":"Contacto de campo ADICIONAL","auxContactSubtitle":"En caso de que el contacto de campo no conteste lo intentaremos con el adicional","markGates":"Marcar tranqueras en mapa","register":"Registrar","gates":"Tranqueras","addNewUser":"Agregar nuevo usuario","coordinatesHint":"Ej.: (lat,lon) -33.529083, -61.789972"},"FieldMap":{"markGates":"Marque las tranqueras de acceso a los equipos","confirmData":"Listo, marqué todos los accesos"},"AddUser":{"userRegister":"Registro de usuario","devices":"Equipos","permissions":"Permisos","addUserDialog":{"questionTitle":"Agregar usuario","extistingUsers":"Usuarios existentes","newUser":"Nuevo usuario","usersAssignmentTitle":"Selecciona los usuarios que tendrán acceso a la plataforma","searchUser":"Buscar usuario","linkUsers":"Vincular usuarios"}},"NewUser":{"name":"Nombre","lastName":"Apellido","role":"Rol","organization":"Organización","setPermissions":"Configurar permisos","countryCode":"Código de país","phoneNumber":"Celular","example":"Ejemplo","addAndEditPermission":"¿Este usuario puede editar y crear equipos?","no":"No","yes":"Sí","next":"Siguiente","cancel":"Cancelar","fileSizeLimit":"El tamaño del archivo debe ser menor a {0}Mb","allowedFileTypes":"Tipos de archivo permitidos: {0}","loadingOrganizationsError":"Error al cargar las organizaciones","register":"Registrar"},"Roles":{"fieldman":"Encargado de campo","fieldmans":"encargados de campo","farmhand":"Regador","farmhands":"regadores","manager":"Productor/Gerente","managers":"productores/gerentes","admin":"Admin","admins":"admins","owner":"Propietario","owners":"propietarios"},"AssignDevices":{"title":"¿Qué equipos quiere que {0} pueda ver en su celular?","save":"Guardar","next":"Siguiente","seePermisions":"Ver permisos por equipo","addDevice":"Agregar equipo","noDevicesAlert":"Debe asignar equipos al usuario antes de ver los permisos","selectAll":"Seleccionar todos","loadingDevicesError":"Error al cargar los equipos"},"GeneralPermissions":{"permissions":"Permisos","viewPermissionsByDevice":"Ver permisos por equipo","channels":"Canales de comunicación","whatsapp":"WhatsApp","sms":"SMS","push":"Push","alertPeriod":"Período de alerta","startHour":"Hora de inicio","endHour":"Hora de fin","noDevicesAlert":"Debe asignar equipos al usuario antes de ver los permisos","save":"Guardar","permissionChangedText":"Este cambio impactará en todos los equipos asignados a {0}.\n\n¿Deseas que este cambio también se implemente en todos los {1} de tu organización?","permissionChangeMainBtn":"Sí, a todos los {0}","permissionChangeSecondaryBtn":"No, solo a este","confirmPermissionChangedText":"Los usuarios {0} tienen equipos con sus permisos personalizados.\n\n¿Estás seguro que deseas modificar sus notificaciones?","confirmPermissionChangeMainBtn":"No, solo modificar a {0}","confirmPermissionChangeSecondaryBtn":"Sí, estoy seguro"},"UI":{"serverError":"Error al ejecutar solicitud, por favor reintentá.","registerError":"Registro fallido. Intenta nuevamente más tarde","existingDeviceError":"Ya existe un equipo con ese ID.","registerSuccess":"¡Registro exitoso!","deleteSuccess":"¡Eliminación exitosa!","deleteError":"Eliminación fallida. Intenta nuevamente más tarde","phoneAlreadyExists":"El número ingresado ya esta registrado","cropsRequired":"El equipo debe tener al menos un lote","campaignNotFound":"Campaña no encontrada"},"EditUser":{"userDetail":"Detalle de usuario","assignedDevices":"Equipos asignados","seePermisions":"Ver permisos por equipo","save":"Guardar","rolePermissions":"Ver permisos de rol","name":"Nombre","lastName":"Apellido","email":"Mail","role":"Rol","countryCode":"Código de país","phoneNumber":"Celular","phoneExample":"Ejemplo:","yes":"Sí","no":"No","addAndEditPermission":"¿Este usuario puede editar y crear equipos?","deleteUser":"Eliminar usuario","deleteUserCardText":"¿Estás seguro que deseas eliminar a {0} de tu organización?","deleteUserMainBtnText":"Sí, eliminar usuario","deleteUserSecondaryBtnText":"Cancelar","fileSizeLimit":"El tamaño del archivo debe ser menor a {0}Mb","allowedFileTypes":"Tipos de archivo permitidos: {0}","selectAll":"Seleccionar todos","permissions":"Permisos","noAccountUser":"El usuario no ha confirmado su cuenta","resendInvitation":"Reenviar invitación","invitationSent":"Invitación enviada"},"PermissionsByDevice":{"title":"Permisos de {0} \"{1}\"","all":"TODOS","save":"Guardar","back":"Volver"},"Success":{"successfulSave":"Guardado con éxito"},"ExitConfirmation":{"title":"¿Estás seguro que deseas abandonar el proceso de carga?","subtitle":"Perderás todos los datos cargados hasta el momento","yes":"Sí","no":"No"},"ManageField":{"crops":"Lotes","addCrop":"Agregar lote","delete":"Eliminar","deleteCropMainBtnText":"Sí, eliminar lote","deleteCropSecondaryBtnText":"Cancelar","cropDeviceQty":"{devices} equipo","cropDevicesQty":"{devices} equipos","assignedDevices":"Equipos asignados","noAssignedDevices":"No hay equipos asignados","dashboard":"Administración","emptyCrops":"No hay lotes creados"},"Welcome":{"welcome":"¡Bienvenido a PONCE!","description":"Para configurar tu usuario necesitamos que confirmes tu e-mail y definas una contraseña.","email":"Email","password":"Contraseña","confirm":"Confirmar","registerSuccess":"¡Registro exitoso! Sera redireccionado a la App en unos instantes...","loginError":"Error al iniciar sesión","tokenInvalid":"El enlace de invitación no es válido o ha expirado","resendInvitation":"Reenviar invitación","invitationSent":"Invitación enviada","passwordsDoNotMatch":"Las contraseñas no coinciden","passwordConfirmation":"Confirmar contraseña"},"WebTitles":{"dashboard":"Administración","reports":"Reportes","login":"Login"},"SatisfactionSurveyModal":{"confirmBtnText":"Enviar","declineBtnText":"Más tarde","options":{"other":"Otro","inaccurateData":"Información imprecisa","confusingInfo":"Información confusa","missingData":"Falta información","dataNeeded":"¿Qué falta?"},"questions":{"reports":{"utility":"¿Qué tan útiles son los reportes?","why":"¿Por qué?"}},"thankYou":"¡Gracias por tu respuesta!"},"NewCampaignInitialData":{"serviceOnboardingTitle":"Alta de servicio","saving":"Guardando...","changesSaved":"Cambios guardados","pivot":"pivot","linear":"frontal","irrigationReel":"enrollador","pivots":"pivots","linears":"frontales","irrigationReels":"enrolladores","introduction":{"title":"Bienvenido al proceso de alta del servicio de monitoreo","introductionText":"Para comenzar con la instalación de los sensores, necesitamos que completes algunos datos clave que permitirán que nuestros técnicos puedan asistir a campo para instalar los sensores. Cuanto antes lo completes, antes podremos planificar y ejecutar la instalación sin demoras.","contractedEquipments":"Equipos contratados:","thingsToConsiderTitle":"A tener en cuenta:","thingsToConsiderText":"La instalación de los sensores requiere al menos 21 días desde la finalización de este registro. No será posible realizar instalaciones antes de ese plazo mínimo.","nextStepsTitle":"¿Qué sigue después?","nextStepsText":"Una vez completado este formulario inicial, vas a poder avanzar al proceso de alta completo, donde vas a definir:","nextStepsTextItems":["Equipos de riego","Lotes","Usuarios que operarán el servicio"],"campaignNameInput":{"placeholder":"Ingresar nombre de campaña","hint":"Ejemplo: Campaña 2025/26"},"startCampaign":"Comenzar ahora","contractedEquipmentsDetail":"{deviceType} servicio {serviceName} ({durationMonths} meses)","contractedExtensionDetail":"extensión de servicio ({durationMonths})","contractedExtensionsDetail":"extensiones de servicio ({durationMonths})","month":"mes","months":"meses"},"devicesAndServices":{"title":"Información de equipos y servicios","subtitle":"Completa los datos de ubicación de equipos y fechas de servicio para garantizar la instalación de los sensores.","tip":"Es posible otorgar permisos de edición para que otro continue el alta de equipos","contractedEquipmentsTitle":"Equipos contratados","finish":"Finalizar","back":"Atrás","inviteUsers":"Invitar usuarios","device":"Equipo","startDate":"Inicio de servicio","endDate":"Fin de servicio","field":"Campo","coordinates":"Posición exacta del equipo","coordinatesHint":"Ej.: (lat,lon) -33.529083, -61.789972 · (GMS) 33°31'44.7\"S 61°47'23.9\"W","addNewDevice":"Agregar nuevo equipo","addNewField":"Agregar nuevo campo","setNewDeviceTitle":"Ingresar nombre de equipo","setNewDeviceLabel":"Nombre de equipo","setNewDeviceSubmitButton":"Agregar equipo","newDeviceError":"Registro fallido. Intenta nuevamente más tarde","noDevices":"No hay equipos","noFields":"No hay campos","startDateWarningTitle":"Atención","startDateWarningMessageFirst":"Algunos equipos no cumplen con las condiciones de fecha de instalación requeridas.","startDateWarningMessageSecond":"Para completar el alta, es necesario corregir sus datos.","extensionProductsDescription":"Las extensiones deben ser asociadas previo a la finalización del servicio","unitsToExtend":"Extensiones a aplicar","addNewExtension":"+ Asignar nueva extensión","removeExtension":"- Eliminar extensión"},"finish":{"title":"Prealta finalizado","body":"Has registrado correctamente los datos de cliente, ubicación y programación. Pronto el equipo de PONCE se contactará contigo para coordinación de la instalación de los dispositivos de monitoreo.</br></br>El siguiente paso implica completar la configuración de los equipos y lotes a ser monitoreados desde el panel de administración. Además, desde allí podrás registrar a los usuarios que tendrán acceso a los servicios y notificaciones de la organización.","goToDashboard":"Ir a Administración"},"termsAndConditions":{"title":"Términos de servicio","introductionText":"Antes de continuar, es necesario que revises y aceptes las condiciones que regulan el servicio de monitoreo de PONCE.","checkboxLabel":"He leído y acepto los Términos y Condiciones de Servicio","next":"Siguiente","t&cTitle":"Términos y Condiciones del Servicio de Monitoreo de PONCE"}},"EditCampaign":{"service":"Servicio","changesSaved":"Cambios guardados exitosamente","errorSavingChanges":"Error al guardar los cambios","noProductsAvailable":"No hay productos disponibles para esta campaña","campaignNameSaved":"Nombre de campaña guardado exitosamente","startDatePassedMessage":"La fecha de inicio ya pasó. Solo puedes editar la fecha de fin.","devicesAndServices":{"device":"Equipo","startDate":"Inicio de servicio","endDate":"Fin de servicio","field":"Campo","coordinates":"Posición exacta del equipo","coordinatesHint":"Ejemplo: -32.53254, -69.264214","addNewDevice":"Agregar nuevo equipo","addNewField":"Agregar nuevo campo","setNewDeviceTitle":"Ingresar nombre de equipo","setNewDeviceLabel":"Nombre de equipo","setNewDeviceSubmitButton":"Agregar equipo","newDeviceError":"Registro fallido. Intenta nuevamente más tarde","back":"Atrás","finish":"Confirmar","noDevices":"No hay equipos","extensionProductsDescription":"Las extensiones deben ser asociadas previo a la finalización del servicio","unitsToExtend":"Extensiones a aplicar","addNewExtension":"+ Asignar nueva extensión","removeExtension":"- Eliminar extensión"},"pivot":"pivot","linear":"frontal","irrigationReel":"enrollador","pivots":"pivots","linears":"frontales","irrigationReels":"enrolladores","introduction":{"contractedEquipmentsDetail":"{deviceType} servicio {serviceName} ({durationMonths} meses)","contractedExtensionDetail":"extensión de servicio ({durationMonths})","contractedExtensionsDetail":"extensiones de servicio ({durationMonths})","month":"mes","months":"meses"},"emptyCampaigns":"No hay campañas disponibles"},"PostponementRequestDialog":{"title":"Confirmación pendiente","body":"Hay cambios en las fechas de servicio. Confirma las modificaciones para evitar demoras","changeReason":"Motivo de cambio:","newStartDate":"Nueva fecha de inicio:","currentStartDate":"Fecha de inicio actual:","changeType":{"1":"La maquinaria de riego no cumple con las condiciones necesarias para la instalación de sensores.","2":"No se puede acceder al campo debido a malas condiciones climáticas.","3":"No hay personal disponible para realizar la instalación de los sensores.","4":"La ubicación del equipo es incorrecta.","5":"Las condiciones meteorológicas no permiten la instalación de los sensores.","6":"El sistema de riego está en operación y no puede ser detenido para la instalación de los sensores.","7":"Falta de permisos o autorizaciones para realizar la instalación en el campo.","8":"Falta de respuesta por parte del cliente para coordinar la instalación con la persona responsable del equipo.","9":"Retrasos por parte de PONCE en la instalación, ya sea por falta de disponibilidad de sensores o técnicos de servicio."},"confirm":"Confirmar"},"ServiceExtensionDialog":{"title":"Extensión de servicio","serviceEndsOn":"El servicio de monitoreo del equipo {deviceName} finaliza el {date}","queryNewServiceEndDate":"Solicita una nueva fecha de finalización de servicio","serviceEndDate":"Fin de servicio","submit":"Solicitar extensión","serviceExtensionReceived":"Tu solicitud de extensión de servicio fue recibida.","serviceExtensionReceivedSubtitle":"Un representante de PONCE se comunicará con el Propietario de la organización para solicitar la aprobación de esta extensión.","accept":"Aceptar","pendingServiceExtensionTitle":"Solicitud pendiente","pendingServiceExtensionDetail":"Extensión hasta el {date}. Solicitante: {userName}","pendingServiceExtensionDescription":"La extensión se aplicará una vez que el Propietario la confirme.","serviceExtensionError":"Error al solicitar la extensión de servicio","dateWithinPeriod":"La fecha seleccionada se encuentra dentro del período contratado","dateWithinPeriodSubtitle":"Para modificar la fecha de fin, el Propietario de la organización debe actualizar el servicio desde la página de administración"},"Audits":{"Header":{"audits":"Auditorías {0}","totalIrrigationHours":"Hs. de riego totales","workingPressure":"Presión de funcionamiento","correct":"Correcta","incorrect":"Incorrecta","faultsInDevice":"Fallas en tu equipo","faults":"fallas","noAudits":"No hay auditorías"},"noAudits":"No hay auditorías","fieldSurveySetupRequired":"Para poder visualizar las auditorías debe completar el alta de servicio","goToFieldSurveySetup":"Ir al alta de servicio","FieldSurveyStatus":{"new":"Pendiente","inProgress":"En curso","completed":"Completado"}},"FieldSurveyEntry":{"title":"Autorelevamiento","placeholderBody":"Esta pantalla alojará el flujo de alta. Contenido próximamente."},"FieldSurveyForm":{"pageTitle":"Alta de servicio - {org} - {date}","loadingTitle":"Cargando…","titleError":"No se pudo cargar el autorelevamiento","mapHint":"Marca la ubicación del equipo {equipmentNumber} en el mapa.","hiredEquipmentsOne":"1 equipo contratado.","hiredEquipmentsMany":"{count} equipos contratados.","hiredEquipmentsUnknown":"{count} equipos en lista (cantidad contratada no disponible).","hiredEquipmentsUnknownOne":"1 equipo en lista (cantidad contratada no disponible).","hireMore":"Contratar más","hireMoreWhatsappText":"Hola Esteban! Estoy interesado en recibir una propuesta para auditar más equipos","editService":"Editar servicio","finishEditService":"Finalizar edición","confirm":"Confirmar","confirmNotImplemented":"Confirmación disponible próximamente.","confirmSuccess":"Alta de servicio completada.","confirmError":"No se pudo completar el alta de servicio.","noSurveyWorks":"No hay trabajos cargados para este relevamiento.","surveyWorksError":"No se pudieron cargar los trabajos.","saveSuccess":"Cambios guardados.","saveError":"No se pudieron guardar los cambios.","deleteSuccess":"Trabajo eliminado.","deleteError":"No se pudo eliminar el trabajo.","edit":"Editar","delete":"Eliminar","save":"Guardar","saving":"Guardando…","cancel":"Cancelar","fieldName":"Nombre del equipo","fieldUser":"Usuario técnico","fieldCoordinates":"Coordenadas","pluviometricChartYes":"Carta de riego","pluviometricChartNo":"Sin carta de riego","chartUploadButtonLabel":"Carta de riego","chartReplace":"Cambiar carta de riego","chartRemove":"Quitar carta de riego","chartClearSelection":"Cancelar archivo nuevo","chartUndoRemove":"Mantener carta de riego","chartPendingUpload":"Nueva carta de riego: {name} (se subirá al guardar).","chartWillRemove":"Se quitará la carta de riego al guardar.","chartCurrentFile":"Carta de riego: {name}","deleteConfirmMessage":"¿Estás seguro de que deseas eliminar este equipo?","mapSearchPlaceholder":"Buscar en Google Maps","mapAddBlockedNoQty":"No se puede marcar en el mapa hasta que la cantidad de equipos esté definida.","mapAddBlockedLimit":"Ya cargaste todos los equipos contratados.","addTechnician":"Agregar técnico","newTechnicianTitle":"Nuevo técnico","newTechnicianSave":"Guardar","newTechnicianError":"No se pudo crear el técnico.","newTechnicianNoCampaign":"No hay campaña activa para asociar al usuario.","newTechnicianEmail":"Email","ponceTechnicianOption":"Técnico de Ponce","ponceChargeWarningBody":"Se han detectado asignaciones a técnicos PONCE. Esto generará cargos adicionales ¿Desea continuar?"},"FieldSurveyPending":{"title":"Relevamientos pendientes","message":"Tenés relevamientos por completar.","completeLater":"Completar luego","goToSetup":"Ir al alta"}}

/***/ }),

/***/ 75:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "$$iterator", function() { return $$iterator; });
/* harmony export (immutable) */ __webpack_exports__["isIterable"] = isIterable;
/* harmony export (immutable) */ __webpack_exports__["isArrayLike"] = isArrayLike;
/* harmony export (immutable) */ __webpack_exports__["isCollection"] = isCollection;
/* harmony export (immutable) */ __webpack_exports__["getIterator"] = getIterator;
/* harmony export (immutable) */ __webpack_exports__["getIteratorMethod"] = getIteratorMethod;
/* harmony export (immutable) */ __webpack_exports__["createIterator"] = createIterator;
/* harmony export (immutable) */ __webpack_exports__["forEach"] = forEach;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "$$asyncIterator", function() { return $$asyncIterator; });
/* harmony export (immutable) */ __webpack_exports__["isAsyncIterable"] = isAsyncIterable;
/* harmony export (immutable) */ __webpack_exports__["getAsyncIterator"] = getAsyncIterator;
/* harmony export (immutable) */ __webpack_exports__["getAsyncIteratorMethod"] = getAsyncIteratorMethod;
/* harmony export (immutable) */ __webpack_exports__["createAsyncIterator"] = createAsyncIterator;
/* harmony export (immutable) */ __webpack_exports__["forAwaitEach"] = forAwaitEach;
/**
 * Copyright (c) 2016, Lee Byron
 * All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @flow
 * @ignore
 */

/**
 * [Iterator](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#iterator)
 * is a *protocol* which describes a standard way to produce a sequence of
 * values, typically the values of the Iterable represented by this Iterator.
 *
 * While described by the [ES2015 version of JavaScript](http://www.ecma-international.org/ecma-262/6.0/#sec-iterator-interface)
 * it can be utilized by any version of JavaScript.
 *
 * @external Iterator
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#iterator|MDN Iteration protocols}
 */

/**
 * [Iterable](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#iterable)
 * is a *protocol* which when implemented allows a JavaScript object to define
 * their iteration behavior, such as what values are looped over in a
 * [`for...of`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/for...of)
 * loop or `iterall`'s `forEach` function. Many [built-in types](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#Builtin_iterables)
 * implement the Iterable protocol, including `Array` and `Map`.
 *
 * While described by the [ES2015 version of JavaScript](http://www.ecma-international.org/ecma-262/6.0/#sec-iterable-interface)
 * it can be utilized by any version of JavaScript.
 *
 * @external Iterable
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#iterable|MDN Iteration protocols}
 */

// In ES2015 environments, Symbol exists
var SYMBOL /*: any */ = typeof Symbol === 'function' ? Symbol : void 0

// In ES2015 (or a polyfilled) environment, this will be Symbol.iterator
var SYMBOL_ITERATOR = SYMBOL && SYMBOL.iterator

/**
 * A property name to be used as the name of an Iterable's method responsible
 * for producing an Iterator, referred to as `@@iterator`. Typically represents
 * the value `Symbol.iterator` but falls back to the string `"@@iterator"` when
 * `Symbol.iterator` is not defined.
 *
 * Use `$$iterator` for defining new Iterables instead of `Symbol.iterator`,
 * but do not use it for accessing existing Iterables, instead use
 * {@link getIterator} or {@link isIterable}.
 *
 * @example
 *
 * var $$iterator = require('iterall').$$iterator
 *
 * function Counter (to) {
 *   this.to = to
 * }
 *
 * Counter.prototype[$$iterator] = function () {
 *   return {
 *     to: this.to,
 *     num: 0,
 *     next () {
 *       if (this.num >= this.to) {
 *         return { value: undefined, done: true }
 *       }
 *       return { value: this.num++, done: false }
 *     }
 *   }
 * }
 *
 * var counter = new Counter(3)
 * for (var number of counter) {
 *   console.log(number) // 0 ... 1 ... 2
 * }
 *
 * @type {Symbol|string}
 */
/*:: declare export var $$iterator: '@@iterator'; */
var $$iterator = SYMBOL_ITERATOR || '@@iterator'

/**
 * Returns true if the provided object implements the Iterator protocol via
 * either implementing a `Symbol.iterator` or `"@@iterator"` method.
 *
 * @example
 *
 * var isIterable = require('iterall').isIterable
 * isIterable([ 1, 2, 3 ]) // true
 * isIterable('ABC') // true
 * isIterable({ length: 1, 0: 'Alpha' }) // false
 * isIterable({ key: 'value' }) // false
 * isIterable(new Map()) // true
 *
 * @param obj
 *   A value which might implement the Iterable protocol.
 * @return {boolean} true if Iterable.
 */
/*:: declare export function isIterable(obj: any): boolean; */
function isIterable(obj) {
  return !!getIteratorMethod(obj)
}

/**
 * Returns true if the provided object implements the Array-like protocol via
 * defining a positive-integer `length` property.
 *
 * @example
 *
 * var isArrayLike = require('iterall').isArrayLike
 * isArrayLike([ 1, 2, 3 ]) // true
 * isArrayLike('ABC') // true
 * isArrayLike({ length: 1, 0: 'Alpha' }) // true
 * isArrayLike({ key: 'value' }) // false
 * isArrayLike(new Map()) // false
 *
 * @param obj
 *   A value which might implement the Array-like protocol.
 * @return {boolean} true if Array-like.
 */
/*:: declare export function isArrayLike(obj: any): boolean; */
function isArrayLike(obj) {
  var length = obj != null && obj.length
  return typeof length === 'number' && length >= 0 && length % 1 === 0
}

/**
 * Returns true if the provided object is an Object (i.e. not a string literal)
 * and is either Iterable or Array-like.
 *
 * This may be used in place of [Array.isArray()][isArray] to determine if an
 * object should be iterated-over. It always excludes string literals and
 * includes Arrays (regardless of if it is Iterable). It also includes other
 * Array-like objects such as NodeList, TypedArray, and Buffer.
 *
 * @example
 *
 * var isCollection = require('iterall').isCollection
 * isCollection([ 1, 2, 3 ]) // true
 * isCollection('ABC') // false
 * isCollection({ length: 1, 0: 'Alpha' }) // true
 * isCollection({ key: 'value' }) // false
 * isCollection(new Map()) // true
 *
 * @example
 *
 * var forEach = require('iterall').forEach
 * if (isCollection(obj)) {
 *   forEach(obj, function (value) {
 *     console.log(value)
 *   })
 * }
 *
 * @param obj
 *   An Object value which might implement the Iterable or Array-like protocols.
 * @return {boolean} true if Iterable or Array-like Object.
 */
/*:: declare export function isCollection(obj: any): boolean; */
function isCollection(obj) {
  return Object(obj) === obj && (isArrayLike(obj) || isIterable(obj))
}

/**
 * If the provided object implements the Iterator protocol, its Iterator object
 * is returned. Otherwise returns undefined.
 *
 * @example
 *
 * var getIterator = require('iterall').getIterator
 * var iterator = getIterator([ 1, 2, 3 ])
 * iterator.next() // { value: 1, done: false }
 * iterator.next() // { value: 2, done: false }
 * iterator.next() // { value: 3, done: false }
 * iterator.next() // { value: undefined, done: true }
 *
 * @template T the type of each iterated value
 * @param {Iterable<T>} iterable
 *   An Iterable object which is the source of an Iterator.
 * @return {Iterator<T>} new Iterator instance.
 */
/*:: declare export var getIterator:
  & (<+TValue>(iterable: Iterable<TValue>) => Iterator<TValue>)
  & ((iterable: mixed) => void | Iterator<mixed>); */
function getIterator(iterable) {
  var method = getIteratorMethod(iterable)
  if (method) {
    return method.call(iterable)
  }
}

/**
 * If the provided object implements the Iterator protocol, the method
 * responsible for producing its Iterator object is returned.
 *
 * This is used in rare cases for performance tuning. This method must be called
 * with obj as the contextual this-argument.
 *
 * @example
 *
 * var getIteratorMethod = require('iterall').getIteratorMethod
 * var myArray = [ 1, 2, 3 ]
 * var method = getIteratorMethod(myArray)
 * if (method) {
 *   var iterator = method.call(myArray)
 * }
 *
 * @template T the type of each iterated value
 * @param {Iterable<T>} iterable
 *   An Iterable object which defines an `@@iterator` method.
 * @return {function(): Iterator<T>} `@@iterator` method.
 */
/*:: declare export var getIteratorMethod:
  & (<+TValue>(iterable: Iterable<TValue>) => (() => Iterator<TValue>))
  & ((iterable: mixed) => (void | (() => Iterator<mixed>))); */
function getIteratorMethod(iterable) {
  if (iterable != null) {
    var method =
      (SYMBOL_ITERATOR && iterable[SYMBOL_ITERATOR]) || iterable['@@iterator']
    if (typeof method === 'function') {
      return method
    }
  }
}

/**
 * Similar to {@link getIterator}, this method returns a new Iterator given an
 * Iterable. However it will also create an Iterator for a non-Iterable
 * Array-like collection, such as Array in a non-ES2015 environment.
 *
 * `createIterator` is complimentary to `forEach`, but allows a "pull"-based
 * iteration as opposed to `forEach`'s "push"-based iteration.
 *
 * `createIterator` produces an Iterator for Array-likes with the same behavior
 * as ArrayIteratorPrototype described in the ECMAScript specification, and
 * does *not* skip over "holes".
 *
 * @example
 *
 * var createIterator = require('iterall').createIterator
 *
 * var myArraylike = { length: 3, 0: 'Alpha', 1: 'Bravo', 2: 'Charlie' }
 * var iterator = createIterator(myArraylike)
 * iterator.next() // { value: 'Alpha', done: false }
 * iterator.next() // { value: 'Bravo', done: false }
 * iterator.next() // { value: 'Charlie', done: false }
 * iterator.next() // { value: undefined, done: true }
 *
 * @template T the type of each iterated value
 * @param {Iterable<T>|{ length: number }} collection
 *   An Iterable or Array-like object to produce an Iterator.
 * @return {Iterator<T>} new Iterator instance.
 */
/*:: declare export var createIterator:
  & (<+TValue>(collection: Iterable<TValue>) => Iterator<TValue>)
  & ((collection: {length: number}) => Iterator<mixed>)
  & ((collection: mixed) => (void | Iterator<mixed>)); */
function createIterator(collection) {
  if (collection != null) {
    var iterator = getIterator(collection)
    if (iterator) {
      return iterator
    }
    if (isArrayLike(collection)) {
      return new ArrayLikeIterator(collection)
    }
  }
}

// When the object provided to `createIterator` is not Iterable but is
// Array-like, this simple Iterator is created.
function ArrayLikeIterator(obj) {
  this._o = obj
  this._i = 0
}

// Note: all Iterators are themselves Iterable.
ArrayLikeIterator.prototype[$$iterator] = function() {
  return this
}

// A simple state-machine determines the IteratorResult returned, yielding
// each value in the Array-like object in order of their indicies.
ArrayLikeIterator.prototype.next = function() {
  if (this._o === void 0 || this._i >= this._o.length) {
    this._o = void 0
    return { value: void 0, done: true }
  }
  return { value: this._o[this._i++], done: false }
}

/**
 * Given an object which either implements the Iterable protocol or is
 * Array-like, iterate over it, calling the `callback` at each iteration.
 *
 * Use `forEach` where you would expect to use a `for ... of` loop in ES6.
 * However `forEach` adheres to the behavior of [Array#forEach][] described in
 * the ECMAScript specification, skipping over "holes" in Array-likes. It will
 * also delegate to a `forEach` method on `collection` if one is defined,
 * ensuring native performance for `Arrays`.
 *
 * Similar to [Array#forEach][], the `callback` function accepts three
 * arguments, and is provided with `thisArg` as the calling context.
 *
 * Note: providing an infinite Iterator to forEach will produce an error.
 *
 * [Array#forEach]: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach
 *
 * @example
 *
 * var forEach = require('iterall').forEach
 *
 * forEach(myIterable, function (value, index, iterable) {
 *   console.log(value, index, iterable === myIterable)
 * })
 *
 * @example
 *
 * // ES6:
 * for (let value of myIterable) {
 *   console.log(value)
 * }
 *
 * // Any JavaScript environment:
 * forEach(myIterable, function (value) {
 *   console.log(value)
 * })
 *
 * @template T the type of each iterated value
 * @param {Iterable<T>|{ length: number }} collection
 *   The Iterable or array to iterate over.
 * @param {function(T, number, object)} callback
 *   Function to execute for each iteration, taking up to three arguments
 * @param [thisArg]
 *   Optional. Value to use as `this` when executing `callback`.
 */
/*:: declare export var forEach:
  & (<+TValue, TCollection: Iterable<TValue>>(
      collection: TCollection,
      callbackFn: (value: TValue, index: number, collection: TCollection) => any,
      thisArg?: any
    ) => void)
  & (<TCollection: {length: number}>(
      collection: TCollection,
      callbackFn: (value: mixed, index: number, collection: TCollection) => any,
      thisArg?: any
    ) => void); */
function forEach(collection, callback, thisArg) {
  if (collection != null) {
    if (typeof collection.forEach === 'function') {
      return collection.forEach(callback, thisArg)
    }
    var i = 0
    var iterator = getIterator(collection)
    if (iterator) {
      var step
      while (!(step = iterator.next()).done) {
        callback.call(thisArg, step.value, i++, collection)
        // Infinite Iterators could cause forEach to run forever.
        // After a very large number of iterations, produce an error.
        /* istanbul ignore if */
        if (i > 9999999) {
          throw new TypeError('Near-infinite iteration.')
        }
      }
    } else if (isArrayLike(collection)) {
      for (; i < collection.length; i++) {
        if (collection.hasOwnProperty(i)) {
          callback.call(thisArg, collection[i], i, collection)
        }
      }
    }
  }
}

/////////////////////////////////////////////////////
//                                                 //
//                 ASYNC ITERATORS                 //
//                                                 //
/////////////////////////////////////////////////////

/**
 * [AsyncIterable](https://tc39.github.io/proposal-async-iteration/#sec-asynciterable-interface)
 * is a *protocol* which when implemented allows a JavaScript object to define
 * an asynchronous iteration behavior, such as what values are looped over in
 * a [`for-await-of`](https://tc39.github.io/proposal-async-iteration/#sec-for-in-and-for-of-statements)
 * loop or `iterall`'s {@link forAwaitEach} function.
 *
 * While described as a proposed addition to the [ES2017 version of JavaScript](https://tc39.github.io/proposal-async-iteration/)
 * it can be utilized by any version of JavaScript.
 *
 * @external AsyncIterable
 * @see {@link https://tc39.github.io/proposal-async-iteration/#sec-asynciterable-interface|Async Iteration Proposal}
 * @template T The type of each iterated value
 * @property {function (): AsyncIterator<T>} Symbol.asyncIterator
 *   A method which produces an AsyncIterator for this AsyncIterable.
 */

/**
 * [AsyncIterator](https://tc39.github.io/proposal-async-iteration/#sec-asynciterator-interface)
 * is a *protocol* which describes a standard way to produce and consume an
 * asynchronous sequence of values, typically the values of the
 * {@link AsyncIterable} represented by this {@link AsyncIterator}.
 *
 * AsyncIterator is similar to Observable or Stream. Like an {@link Iterator} it
 * also as a `next()` method, however instead of an IteratorResult,
 * calling this method returns a {@link Promise} for a IteratorResult.
 *
 * While described as a proposed addition to the [ES2017 version of JavaScript](https://tc39.github.io/proposal-async-iteration/)
 * it can be utilized by any version of JavaScript.
 *
 * @external AsyncIterator
 * @see {@link https://tc39.github.io/proposal-async-iteration/#sec-asynciterator-interface|Async Iteration Proposal}
 */

// In ES2017 (or a polyfilled) environment, this will be Symbol.asyncIterator
var SYMBOL_ASYNC_ITERATOR = SYMBOL && SYMBOL.asyncIterator

/**
 * A property name to be used as the name of an AsyncIterable's method
 * responsible for producing an Iterator, referred to as `@@asyncIterator`.
 * Typically represents the value `Symbol.asyncIterator` but falls back to the
 * string `"@@asyncIterator"` when `Symbol.asyncIterator` is not defined.
 *
 * Use `$$asyncIterator` for defining new AsyncIterables instead of
 * `Symbol.asyncIterator`, but do not use it for accessing existing Iterables,
 * instead use {@link getAsyncIterator} or {@link isAsyncIterable}.
 *
 * @example
 *
 * var $$asyncIterator = require('iterall').$$asyncIterator
 *
 * function Chirper (to) {
 *   this.to = to
 * }
 *
 * Chirper.prototype[$$asyncIterator] = function () {
 *   return {
 *     to: this.to,
 *     num: 0,
 *     next () {
 *       return new Promise(resolve => {
 *         if (this.num >= this.to) {
 *           resolve({ value: undefined, done: true })
 *         } else {
 *           setTimeout(() => {
 *             resolve({ value: this.num++, done: false })
 *           }, 1000)
 *         }
 *       })
 *     }
 *   }
 * }
 *
 * var chirper = new Chirper(3)
 * for await (var number of chirper) {
 *   console.log(number) // 0 ...wait... 1 ...wait... 2
 * }
 *
 * @type {Symbol|string}
 */
/*:: declare export var $$asyncIterator: '@@asyncIterator'; */
var $$asyncIterator = SYMBOL_ASYNC_ITERATOR || '@@asyncIterator'

/**
 * Returns true if the provided object implements the AsyncIterator protocol via
 * either implementing a `Symbol.asyncIterator` or `"@@asyncIterator"` method.
 *
 * @example
 *
 * var isAsyncIterable = require('iterall').isAsyncIterable
 * isAsyncIterable(myStream) // true
 * isAsyncIterable('ABC') // false
 *
 * @param obj
 *   A value which might implement the AsyncIterable protocol.
 * @return {boolean} true if AsyncIterable.
 */
/*:: declare export function isAsyncIterable(obj: any): boolean; */
function isAsyncIterable(obj) {
  return !!getAsyncIteratorMethod(obj)
}

/**
 * If the provided object implements the AsyncIterator protocol, its
 * AsyncIterator object is returned. Otherwise returns undefined.
 *
 * @example
 *
 * var getAsyncIterator = require('iterall').getAsyncIterator
 * var asyncIterator = getAsyncIterator(myStream)
 * asyncIterator.next().then(console.log) // { value: 1, done: false }
 * asyncIterator.next().then(console.log) // { value: 2, done: false }
 * asyncIterator.next().then(console.log) // { value: 3, done: false }
 * asyncIterator.next().then(console.log) // { value: undefined, done: true }
 *
 * @template T the type of each iterated value
 * @param {AsyncIterable<T>} asyncIterable
 *   An AsyncIterable object which is the source of an AsyncIterator.
 * @return {AsyncIterator<T>} new AsyncIterator instance.
 */
/*:: declare export var getAsyncIterator:
  & (<+TValue>(asyncIterable: AsyncIterable<TValue>) => AsyncIterator<TValue>)
  & ((asyncIterable: mixed) => (void | AsyncIterator<mixed>)); */
function getAsyncIterator(asyncIterable) {
  var method = getAsyncIteratorMethod(asyncIterable)
  if (method) {
    return method.call(asyncIterable)
  }
}

/**
 * If the provided object implements the AsyncIterator protocol, the method
 * responsible for producing its AsyncIterator object is returned.
 *
 * This is used in rare cases for performance tuning. This method must be called
 * with obj as the contextual this-argument.
 *
 * @example
 *
 * var getAsyncIteratorMethod = require('iterall').getAsyncIteratorMethod
 * var method = getAsyncIteratorMethod(myStream)
 * if (method) {
 *   var asyncIterator = method.call(myStream)
 * }
 *
 * @template T the type of each iterated value
 * @param {AsyncIterable<T>} asyncIterable
 *   An AsyncIterable object which defines an `@@asyncIterator` method.
 * @return {function(): AsyncIterator<T>} `@@asyncIterator` method.
 */
/*:: declare export var getAsyncIteratorMethod:
  & (<+TValue>(asyncIterable: AsyncIterable<TValue>) => (() => AsyncIterator<TValue>))
  & ((asyncIterable: mixed) => (void | (() => AsyncIterator<mixed>))); */
function getAsyncIteratorMethod(asyncIterable) {
  if (asyncIterable != null) {
    var method =
      (SYMBOL_ASYNC_ITERATOR && asyncIterable[SYMBOL_ASYNC_ITERATOR]) ||
      asyncIterable['@@asyncIterator']
    if (typeof method === 'function') {
      return method
    }
  }
}

/**
 * Similar to {@link getAsyncIterator}, this method returns a new AsyncIterator
 * given an AsyncIterable. However it will also create an AsyncIterator for a
 * non-async Iterable as well as non-Iterable Array-like collection, such as
 * Array in a pre-ES2015 environment.
 *
 * `createAsyncIterator` is complimentary to `forAwaitEach`, but allows a
 * buffering "pull"-based iteration as opposed to `forAwaitEach`'s
 * "push"-based iteration.
 *
 * `createAsyncIterator` produces an AsyncIterator for non-async Iterables as
 * described in the ECMAScript proposal [Async-from-Sync Iterator Objects](https://tc39.github.io/proposal-async-iteration/#sec-async-from-sync-iterator-objects).
 *
 * > Note: Creating `AsyncIterator`s requires the existence of `Promise`.
 * > While `Promise` has been available in modern browsers for a number of
 * > years, legacy browsers (like IE 11) may require a polyfill.
 *
 * @example
 *
 * var createAsyncIterator = require('iterall').createAsyncIterator
 *
 * var myArraylike = { length: 3, 0: 'Alpha', 1: 'Bravo', 2: 'Charlie' }
 * var iterator = createAsyncIterator(myArraylike)
 * iterator.next().then(console.log) // { value: 'Alpha', done: false }
 * iterator.next().then(console.log) // { value: 'Bravo', done: false }
 * iterator.next().then(console.log) // { value: 'Charlie', done: false }
 * iterator.next().then(console.log) // { value: undefined, done: true }
 *
 * @template T the type of each iterated value
 * @param {AsyncIterable<T>|Iterable<T>|{ length: number }} source
 *   An AsyncIterable, Iterable, or Array-like object to produce an Iterator.
 * @return {AsyncIterator<T>} new AsyncIterator instance.
 */
/*:: declare export var createAsyncIterator:
  & (<+TValue>(
      collection: Iterable<Promise<TValue> | TValue> | AsyncIterable<TValue>
    ) => AsyncIterator<TValue>)
  & ((collection: {length: number}) => AsyncIterator<mixed>)
  & ((collection: mixed) => (void | AsyncIterator<mixed>)); */
function createAsyncIterator(source) {
  if (source != null) {
    var asyncIterator = getAsyncIterator(source)
    if (asyncIterator) {
      return asyncIterator
    }
    var iterator = createIterator(source)
    if (iterator) {
      return new AsyncFromSyncIterator(iterator)
    }
  }
}

// When the object provided to `createAsyncIterator` is not AsyncIterable but is
// sync Iterable, this simple wrapper is created.
function AsyncFromSyncIterator(iterator) {
  this._i = iterator
}

// Note: all AsyncIterators are themselves AsyncIterable.
AsyncFromSyncIterator.prototype[$$asyncIterator] = function() {
  return this
}

// A simple state-machine determines the IteratorResult returned, yielding
// each value in the Array-like object in order of their indicies.
AsyncFromSyncIterator.prototype.next = function(value) {
  return unwrapAsyncFromSync(this._i, 'next', value)
}

AsyncFromSyncIterator.prototype.return = function(value) {
  return this._i.return
    ? unwrapAsyncFromSync(this._i, 'return', value)
    : Promise.resolve({ value: value, done: true })
}

AsyncFromSyncIterator.prototype.throw = function(value) {
  return this._i.throw
    ? unwrapAsyncFromSync(this._i, 'throw', value)
    : Promise.reject(value)
}

function unwrapAsyncFromSync(iterator, fn, value) {
  var step
  return new Promise(function(resolve) {
    step = iterator[fn](value)
    resolve(step.value)
  }).then(function(value) {
    return { value: value, done: step.done }
  })
}

/**
 * Given an object which either implements the AsyncIterable protocol or is
 * Array-like, iterate over it, calling the `callback` at each iteration.
 *
 * Use `forAwaitEach` where you would expect to use a [for-await-of](https://tc39.github.io/proposal-async-iteration/#sec-for-in-and-for-of-statements) loop.
 *
 * Similar to [Array#forEach][], the `callback` function accepts three
 * arguments, and is provided with `thisArg` as the calling context.
 *
 * > Note: Using `forAwaitEach` requires the existence of `Promise`.
 * > While `Promise` has been available in modern browsers for a number of
 * > years, legacy browsers (like IE 11) may require a polyfill.
 *
 * @example
 *
 * var forAwaitEach = require('iterall').forAwaitEach
 *
 * forAwaitEach(myIterable, function (value, index, iterable) {
 *   console.log(value, index, iterable === myIterable)
 * })
 *
 * @example
 *
 * // ES2017:
 * for await (let value of myAsyncIterable) {
 *   console.log(await doSomethingAsync(value))
 * }
 * console.log('done')
 *
 * // Any JavaScript environment:
 * forAwaitEach(myAsyncIterable, function (value) {
 *   return doSomethingAsync(value).then(console.log)
 * }).then(function () {
 *   console.log('done')
 * })
 *
 * @template T the type of each iterated value
 * @param {AsyncIterable<T>|Iterable<Promise<T> | T>|{ length: number }} source
 *   The AsyncIterable or array to iterate over.
 * @param {function(T, number, object)} callback
 *   Function to execute for each iteration, taking up to three arguments
 * @param [thisArg]
 *   Optional. Value to use as `this` when executing `callback`.
 */
/*:: declare export var forAwaitEach:
  & (<+TValue, TCollection: Iterable<Promise<TValue> | TValue> | AsyncIterable<TValue>>(
      collection: TCollection,
      callbackFn: (value: TValue, index: number, collection: TCollection) => any,
      thisArg?: any
    ) => Promise<void>)
  & (<TCollection: { length: number }>(
      collection: TCollection,
      callbackFn: (value: mixed, index: number, collection: TCollection) => any,
      thisArg?: any
    ) => Promise<void>); */
function forAwaitEach(source, callback, thisArg) {
  var asyncIterator = createAsyncIterator(source)
  if (asyncIterator) {
    var i = 0
    return new Promise(function(resolve, reject) {
      function next() {
        asyncIterator
          .next()
          .then(function(step) {
            if (!step.done) {
              Promise.resolve(callback.call(thisArg, step.value, i++, source))
                .then(next)
                .catch(reject)
            } else {
              resolve()
            }
            // Explicitly return null, silencing bluebird-style warnings.
            return null
          })
          .catch(reject)
        // Explicitly return null, silencing bluebird-style warnings.
        return null
      }
      next()
    })
  }
}


/***/ }),

/***/ 85:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_i18n__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lang_dictionaryES__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lang_dictionaryES___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__lang_dictionaryES__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lang_dictionaryEN__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lang_dictionaryEN___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__lang_dictionaryEN__);





__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_0_vue_i18n__["a" /* default */]);

var messages = {
  es: __WEBPACK_IMPORTED_MODULE_2__lang_dictionaryES___default.a,
  en: __WEBPACK_IMPORTED_MODULE_3__lang_dictionaryEN___default.a
};

var i18n = new __WEBPACK_IMPORTED_MODULE_0_vue_i18n__["a" /* default */]({
  locale: 'en',
  messages: messages
});

/* harmony default export */ __webpack_exports__["a"] = (i18n);

/***/ })

},[362]);


// WEBPACK FOOTER //
// static/js/app.5fdd1665a2bfec5423fb.js